
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec8e1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec8e1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aES44", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c2793e944d55f2d$export$2e2bcd8739ae039; });
var htmx = function() {
    'use strict';
    // Public API
    const htmx = {
        // Tsc madness here, assigning the functions directly results in an invalid TypeScript output, but reassigning is fine
        /* Event processing */ /** @type {typeof onLoadHelper} */ onLoad: null,
        /** @type {typeof processNode} */ process: null,
        /** @type {typeof addEventListenerImpl} */ on: null,
        /** @type {typeof removeEventListenerImpl} */ off: null,
        /** @type {typeof triggerEvent} */ trigger: null,
        /** @type {typeof ajaxHelper} */ ajax: null,
        /* DOM querying helpers */ /** @type {typeof find} */ find: null,
        /** @type {typeof findAll} */ findAll: null,
        /** @type {typeof closest} */ closest: null,
        /**
     * Returns the input values that would resolve for a given element via the htmx value resolution mechanism
     *
     * @see https://htmx.org/api/#values
     *
     * @param {Element} elt the element to resolve values on
     * @param {HttpVerb} type the request type (e.g. **get** or **post**) non-GET's will include the enclosing form of the element. Defaults to **post**
     * @returns {Object}
     */ values: function(elt, type) {
            const inputValues = getInputValues(elt, type || 'post');
            return inputValues.values;
        },
        /* DOM manipulation helpers */ /** @type {typeof removeElement} */ remove: null,
        /** @type {typeof addClassToElement} */ addClass: null,
        /** @type {typeof removeClassFromElement} */ removeClass: null,
        /** @type {typeof toggleClassOnElement} */ toggleClass: null,
        /** @type {typeof takeClassForElement} */ takeClass: null,
        /** @type {typeof swap} */ swap: null,
        /* Extension entrypoints */ /** @type {typeof defineExtension} */ defineExtension: null,
        /** @type {typeof removeExtension} */ removeExtension: null,
        /* Debugging */ /** @type {typeof logAll} */ logAll: null,
        /** @type {typeof logNone} */ logNone: null,
        /* Debugging */ /**
     * The logger htmx uses to log with
     *
     * @see https://htmx.org/api/#logger
     */ logger: null,
        /**
     * A property holding the configuration htmx uses at runtime.
     *
     * Note that using a [meta tag](https://htmx.org/docs/#config) is the preferred mechanism for setting these properties.
     *
     * @see https://htmx.org/api/#config
     */ config: {
            /**
       * Whether to use history.
       * @type boolean
       * @default true
       */ historyEnabled: true,
            /**
       * The number of pages to keep in **sessionStorage** for history support.
       * @type number
       * @default 10
       */ historyCacheSize: 10,
            /**
       * @type boolean
       * @default false
       */ refreshOnHistoryMiss: false,
            /**
       * The default swap style to use if **[hx-swap](https://htmx.org/attributes/hx-swap)** is omitted.
       * @type HtmxSwapStyle
       * @default 'innerHTML'
       */ defaultSwapStyle: 'innerHTML',
            /**
       * The default delay between receiving a response from the server and doing the swap.
       * @type number
       * @default 0
       */ defaultSwapDelay: 0,
            /**
       * The default delay between completing the content swap and settling attributes.
       * @type number
       * @default 20
       */ defaultSettleDelay: 20,
            /**
       * If true, htmx will inject a small amount of CSS into the page to make indicators invisible unless the **htmx-indicator** class is present.
       * @type boolean
       * @default true
       */ includeIndicatorStyles: true,
            /**
       * The class to place on indicators when a request is in flight.
       * @type string
       * @default 'htmx-indicator'
       */ indicatorClass: 'htmx-indicator',
            /**
       * The class to place on triggering elements when a request is in flight.
       * @type string
       * @default 'htmx-request'
       */ requestClass: 'htmx-request',
            /**
       * The class to temporarily place on elements that htmx has added to the DOM.
       * @type string
       * @default 'htmx-added'
       */ addedClass: 'htmx-added',
            /**
       * The class to place on target elements when htmx is in the settling phase.
       * @type string
       * @default 'htmx-settling'
       */ settlingClass: 'htmx-settling',
            /**
       * The class to place on target elements when htmx is in the swapping phase.
       * @type string
       * @default 'htmx-swapping'
       */ swappingClass: 'htmx-swapping',
            /**
       * Allows the use of eval-like functionality in htmx, to enable **hx-vars**, trigger conditions & script tag evaluation. Can be set to **false** for CSP compatibility.
       * @type boolean
       * @default true
       */ allowEval: true,
            /**
       * If set to false, disables the interpretation of script tags.
       * @type boolean
       * @default true
       */ allowScriptTags: true,
            /**
       * If set, the nonce will be added to inline scripts.
       * @type string
       * @default ''
       */ inlineScriptNonce: '',
            /**
       * If set, the nonce will be added to inline styles.
       * @type string
       * @default ''
       */ inlineStyleNonce: '',
            /**
       * The attributes to settle during the settling phase.
       * @type string[]
       * @default ['class', 'style', 'width', 'height']
       */ attributesToSettle: [
                'class',
                'style',
                'width',
                'height'
            ],
            /**
       * Allow cross-site Access-Control requests using credentials such as cookies, authorization headers or TLS client certificates.
       * @type boolean
       * @default false
       */ withCredentials: false,
            /**
       * @type number
       * @default 0
       */ timeout: 0,
            /**
       * The default implementation of **getWebSocketReconnectDelay** for reconnecting after unexpected connection loss by the event code **Abnormal Closure**, **Service Restart** or **Try Again Later**.
       * @type {'full-jitter' | ((retryCount:number) => number)}
       * @default "full-jitter"
       */ wsReconnectDelay: 'full-jitter',
            /**
       * The type of binary data being received over the WebSocket connection
       * @type BinaryType
       * @default 'blob'
       */ wsBinaryType: 'blob',
            /**
       * @type string
       * @default '[hx-disable], [data-hx-disable]'
       */ disableSelector: '[hx-disable], [data-hx-disable]',
            /**
       * @type {'auto' | 'instant' | 'smooth'}
       * @default 'instant'
       */ scrollBehavior: 'instant',
            /**
       * If the focused element should be scrolled into view.
       * @type boolean
       * @default false
       */ defaultFocusScroll: false,
            /**
       * If set to true htmx will include a cache-busting parameter in GET requests to avoid caching partial responses by the browser
       * @type boolean
       * @default false
       */ getCacheBusterParam: false,
            /**
       * If set to true, htmx will use the View Transition API when swapping in new content.
       * @type boolean
       * @default false
       */ globalViewTransitions: false,
            /**
       * htmx will format requests with these methods by encoding their parameters in the URL, not the request body
       * @type {(HttpVerb)[]}
       * @default ['get', 'delete']
       */ methodsThatUseUrlParams: [
                'get',
                'delete'
            ],
            /**
       * If set to true, disables htmx-based requests to non-origin hosts.
       * @type boolean
       * @default false
       */ selfRequestsOnly: true,
            /**
       * If set to true htmx will not update the title of the document when a title tag is found in new content
       * @type boolean
       * @default false
       */ ignoreTitle: false,
            /**
       * Whether the target of a boosted element is scrolled into the viewport.
       * @type boolean
       * @default true
       */ scrollIntoViewOnBoost: true,
            /**
       * The cache to store evaluated trigger specifications into.
       * You may define a simple object to use a never-clearing cache, or implement your own system using a [proxy object](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Proxy)
       * @type {Object|null}
       * @default null
       */ triggerSpecsCache: null,
            /** @type boolean */ disableInheritance: false,
            /** @type HtmxResponseHandlingConfig[] */ responseHandling: [
                {
                    code: '204',
                    swap: false
                },
                {
                    code: '[23]..',
                    swap: true
                },
                {
                    code: '[45]..',
                    swap: false,
                    error: true
                }
            ],
            /**
       * Whether to process OOB swaps on elements that are nested within the main response element.
       * @type boolean
       * @default true
       */ allowNestedOobSwaps: true,
            /**
       * Whether to treat history cache miss full page reload requests as a "HX-Request" by returning this response header
       * This should always be disabled when using HX-Request header to optionally return partial responses
       * @type boolean
       * @default true
       */ historyRestoreAsHxRequest: true,
            /**
       * Whether to report input validation errors to the end user and update focus to the first input that fails validation.
       * This should always be enabled as this matches default browser form submit behaviour
       * @type boolean
       * @default false
       */ reportValidityOfForms: false
        },
        /** @type {typeof parseInterval} */ parseInterval: null,
        location: /**
     * proxy of window.location used for page reload functions
     * @type location
     */ location,
        /** @type {typeof internalEval} */ _: null,
        version: '2.0.8'
    };
    // Tsc madness part 2
    htmx.onLoad = onLoadHelper;
    htmx.process = processNode;
    htmx.on = addEventListenerImpl;
    htmx.off = removeEventListenerImpl;
    htmx.trigger = triggerEvent;
    htmx.ajax = ajaxHelper;
    htmx.find = find;
    htmx.findAll = findAll;
    htmx.closest = closest;
    htmx.remove = removeElement;
    htmx.addClass = addClassToElement;
    htmx.removeClass = removeClassFromElement;
    htmx.toggleClass = toggleClassOnElement;
    htmx.takeClass = takeClassForElement;
    htmx.swap = swap;
    htmx.defineExtension = defineExtension;
    htmx.removeExtension = removeExtension;
    htmx.logAll = logAll;
    htmx.logNone = logNone;
    htmx.parseInterval = parseInterval;
    htmx._ = internalEval;
    const internalAPI = {
        addTriggerHandler: addTriggerHandler,
        bodyContains: bodyContains,
        canAccessLocalStorage: canAccessLocalStorage,
        findThisElement: findThisElement,
        filterValues: filterValues,
        swap: swap,
        hasAttribute: hasAttribute,
        getAttributeValue: getAttributeValue,
        getClosestAttributeValue: getClosestAttributeValue,
        getClosestMatch: getClosestMatch,
        getExpressionVars: getExpressionVars,
        getHeaders: getHeaders,
        getInputValues: getInputValues,
        getInternalData: getInternalData,
        getSwapSpecification: getSwapSpecification,
        getTriggerSpecs: getTriggerSpecs,
        getTarget: getTarget,
        makeFragment: makeFragment,
        mergeObjects: mergeObjects,
        makeSettleInfo: makeSettleInfo,
        oobSwap: oobSwap,
        querySelectorExt: querySelectorExt,
        settleImmediately: settleImmediately,
        shouldCancel: shouldCancel,
        triggerEvent: triggerEvent,
        triggerErrorEvent: triggerErrorEvent,
        withExtensions: withExtensions
    };
    const VERBS = [
        'get',
        'post',
        'put',
        'delete',
        'patch'
    ];
    const VERB_SELECTOR = VERBS.map(function(verb) {
        return '[hx-' + verb + '], [data-hx-' + verb + ']';
    }).join(', ');
    //= ===================================================================
    // Utilities
    //= ===================================================================
    /**
   * Parses an interval string consistent with the way htmx does. Useful for plugins that have timing-related attributes.
   *
   * Caution: Accepts an int followed by either **s** or **ms**. All other values use **parseFloat**
   *
   * @see https://htmx.org/api/#parseInterval
   *
   * @param {string} str timing string
   * @returns {number|undefined}
   */ function parseInterval(str) {
        if (str == undefined) return undefined;
        let interval = NaN;
        if (str.slice(-2) == 'ms') interval = parseFloat(str.slice(0, -2));
        else if (str.slice(-1) == 's') interval = parseFloat(str.slice(0, -1)) * 1000;
        else if (str.slice(-1) == 'm') interval = parseFloat(str.slice(0, -1)) * 60000;
        else interval = parseFloat(str);
        return isNaN(interval) ? undefined : interval;
    }
    /**
   * @param {Node} elt
   * @param {string} name
   * @returns {(string | null)}
   */ function getRawAttribute(elt, name) {
        return elt instanceof Element && elt.getAttribute(name);
    }
    /**
   * @param {Element} elt
   * @param {string} qualifiedName
   * @returns {boolean}
   */ // resolve with both hx and data-hx prefixes
    function hasAttribute(elt, qualifiedName) {
        return !!elt.hasAttribute && (elt.hasAttribute(qualifiedName) || elt.hasAttribute('data-' + qualifiedName));
    }
    /**
   *
   * @param {Node} elt
   * @param {string} qualifiedName
   * @returns {(string | null)}
   */ function getAttributeValue(elt, qualifiedName) {
        return getRawAttribute(elt, qualifiedName) || getRawAttribute(elt, 'data-' + qualifiedName);
    }
    /**
   * @param {Node} elt
   * @returns {Node | null}
   */ function parentElt(elt) {
        const parent = elt.parentElement;
        if (!parent && elt.parentNode instanceof ShadowRoot) return elt.parentNode;
        return parent;
    }
    /**
   * @returns {Document}
   */ function getDocument() {
        return document;
    }
    /**
   * @param {Node} elt
   * @param {boolean} global
   * @returns {Node|Document}
   */ function getRootNode(elt, global) {
        return elt.getRootNode ? elt.getRootNode({
            composed: global
        }) : getDocument();
    }
    /**
   * @param {Node} elt
   * @param {(e:Node) => boolean} condition
   * @returns {Node | null}
   */ function getClosestMatch(elt, condition) {
        while(elt && !condition(elt))elt = parentElt(elt);
        return elt || null;
    }
    /**
   * @param {Element} initialElement
   * @param {Element} ancestor
   * @param {string} attributeName
   * @returns {string|null}
   */ function getAttributeValueWithDisinheritance(initialElement, ancestor, attributeName) {
        const attributeValue = getAttributeValue(ancestor, attributeName);
        const disinherit = getAttributeValue(ancestor, 'hx-disinherit');
        var inherit = getAttributeValue(ancestor, 'hx-inherit');
        if (initialElement !== ancestor) {
            if (htmx.config.disableInheritance) {
                if (inherit && (inherit === '*' || inherit.split(' ').indexOf(attributeName) >= 0)) return attributeValue;
                else return null;
            }
            if (disinherit && (disinherit === '*' || disinherit.split(' ').indexOf(attributeName) >= 0)) return 'unset';
        }
        return attributeValue;
    }
    /**
   * @param {Element} elt
   * @param {string} attributeName
   * @returns {string | null}
   */ function getClosestAttributeValue(elt, attributeName) {
        let closestAttr = null;
        getClosestMatch(elt, function(e) {
            return !!(closestAttr = getAttributeValueWithDisinheritance(elt, asElement(e), attributeName));
        });
        if (closestAttr !== 'unset') return closestAttr;
    }
    /**
   * @param {Node} elt
   * @param {string} selector
   * @returns {boolean}
   */ function matches(elt, selector) {
        return elt instanceof Element && elt.matches(selector);
    }
    /**
   * @param {string} str
   * @returns {string}
   */ function getStartTag(str) {
        const tagMatcher = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
        const match = tagMatcher.exec(str);
        if (match) return match[1].toLowerCase();
        else return '';
    }
    /**
   * @param {string} resp
   * @returns {Document}
   */ function parseHTML(resp) {
        if ('parseHTMLUnsafe' in Document) return Document.parseHTMLUnsafe(resp);
        const parser = new DOMParser();
        return parser.parseFromString(resp, 'text/html');
    }
    /**
   * @param {DocumentFragment} fragment
   * @param {Node} elt
   */ function takeChildrenFor(fragment, elt) {
        while(elt.childNodes.length > 0)fragment.append(elt.childNodes[0]);
    }
    /**
   * @param {HTMLScriptElement} script
   * @returns {HTMLScriptElement}
   */ function duplicateScript(script) {
        const newScript = getDocument().createElement('script');
        forEach(script.attributes, function(attr) {
            newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = script.textContent;
        newScript.async = false;
        if (htmx.config.inlineScriptNonce) newScript.nonce = htmx.config.inlineScriptNonce;
        return newScript;
    }
    /**
   * @param {HTMLScriptElement} script
   * @returns {boolean}
   */ function isJavaScriptScriptNode(script) {
        return script.matches('script') && (script.type === 'text/javascript' || script.type === 'module' || script.type === '');
    }
    /**
   * we have to make new copies of script tags that we are going to insert because
   * SOME browsers (not saying who, but it involves an element and an animal) don't
   * execute scripts created in <template> tags when they are inserted into the DOM
   * and all the others do lmao
   * @param {DocumentFragment} fragment
   */ function normalizeScriptTags(fragment) {
        Array.from(fragment.querySelectorAll('script')).forEach(/** @param {HTMLScriptElement} script */ (script)=>{
            if (isJavaScriptScriptNode(script)) {
                const newScript = duplicateScript(script);
                const parent = script.parentNode;
                try {
                    parent.insertBefore(newScript, script);
                } catch (e) {
                    logError(e);
                } finally{
                    script.remove();
                }
            }
        });
    }
    /**
   * @typedef {DocumentFragment & {title?: string}} DocumentFragmentWithTitle
   * @description  a document fragment representing the response HTML, including
   * a `title` property for any title information found
   */ /**
   * @param {string} response HTML
   * @returns {DocumentFragmentWithTitle}
   */ function makeFragment(response) {
        // strip head tag to determine shape of response we are dealing with
        const responseWithNoHead = response.replace(/<head(\s[^>]*)?>[\s\S]*?<\/head>/i, '');
        const startTag = getStartTag(responseWithNoHead);
        /** @type DocumentFragmentWithTitle */ let fragment;
        if (startTag === 'html') {
            // if it is a full document, parse it and return the body
            fragment = /** @type DocumentFragmentWithTitle */ new DocumentFragment();
            const doc = parseHTML(response);
            takeChildrenFor(fragment, doc.body);
            fragment.title = doc.title;
        } else if (startTag === 'body') {
            // parse body w/o wrapping in template
            fragment = /** @type DocumentFragmentWithTitle */ new DocumentFragment();
            const doc = parseHTML(responseWithNoHead);
            takeChildrenFor(fragment, doc.body);
            fragment.title = doc.title;
        } else {
            // otherwise we have non-body partial HTML content, so wrap it in a template to maximize parsing flexibility
            const doc = parseHTML('<body><template class="internal-htmx-wrapper">' + responseWithNoHead + '</template></body>');
            fragment = /** @type DocumentFragmentWithTitle */ doc.querySelector('template').content;
            // extract title into fragment for later processing
            fragment.title = doc.title;
            // for legacy reasons we support a title tag at the root level of non-body responses, so we need to handle it
            var titleElement = fragment.querySelector('title');
            if (titleElement && titleElement.parentNode === fragment) {
                titleElement.remove();
                fragment.title = titleElement.innerText;
            }
        }
        if (fragment) {
            if (htmx.config.allowScriptTags) normalizeScriptTags(fragment);
            else // remove all script tags if scripts are disabled
            fragment.querySelectorAll('script').forEach((script)=>script.remove());
        }
        return fragment;
    }
    /**
   * @param {Function} func
   */ function maybeCall(func) {
        if (func) func();
    }
    /**
   * @param {any} o
   * @param {string} type
   * @returns
   */ function isType(o, type) {
        return Object.prototype.toString.call(o) === '[object ' + type + ']';
    }
    /**
   * @param {*} o
   * @returns {o is Function}
   */ function isFunction(o) {
        return typeof o === 'function';
    }
    /**
   * @param {*} o
   * @returns {o is Object}
   */ function isRawObject(o) {
        return isType(o, 'Object');
    }
    /**
   * @typedef {Object} OnHandler
   * @property {(keyof HTMLElementEventMap)|string} event
   * @property {EventListener} listener
   */ /**
   * @typedef {Object} ListenerInfo
   * @property {string} trigger
   * @property {EventListener} listener
   * @property {EventTarget} on
   */ /**
   * @typedef {Object} HtmxNodeInternalData
   * Element data
   * @property {number} [initHash]
   * @property {boolean} [boosted]
   * @property {OnHandler[]} [onHandlers]
   * @property {number} [timeout]
   * @property {ListenerInfo[]} [listenerInfos]
   * @property {boolean} [cancelled]
   * @property {boolean} [triggeredOnce]
   * @property {number} [delayed]
   * @property {number|null} [throttle]
   * @property {WeakMap<HtmxTriggerSpecification,WeakMap<EventTarget,string>>} [lastValue]
   * @property {boolean} [loaded]
   * @property {string} [path]
   * @property {string} [verb]
   * @property {boolean} [polling]
   * @property {HTMLButtonElement|HTMLInputElement|null} [lastButtonClicked]
   * @property {number} [requestCount]
   * @property {XMLHttpRequest} [xhr]
   * @property {(() => void)[]} [queuedRequests]
   * @property {boolean} [abortable]
   * @property {boolean} [firstInitCompleted]
   *
   * Event data
   * @property {HtmxTriggerSpecification} [triggerSpec]
   * @property {EventTarget[]} [handledFor]
   */ /**
   * getInternalData retrieves "private" data stored by htmx within an element
   * @param {EventTarget|Event} elt
   * @returns {HtmxNodeInternalData}
   */ function getInternalData(elt) {
        const dataProp = 'htmx-internal-data';
        let data = elt[dataProp];
        if (!data) data = elt[dataProp] = {};
        return data;
    }
    /**
   * toArray converts an ArrayLike object into a real array.
   * @template T
   * @param {ArrayLike<T>} arr
   * @returns {T[]}
   */ function toArray(arr) {
        const returnArr = [];
        if (arr) for(let i = 0; i < arr.length; i++)returnArr.push(arr[i]);
        return returnArr;
    }
    /**
   * @template T
   * @param {T[]|NamedNodeMap|HTMLCollection|HTMLFormControlsCollection|ArrayLike<T>} arr
   * @param {(T) => void} func
   */ function forEach(arr, func) {
        if (arr) for(let i = 0; i < arr.length; i++)func(arr[i]);
    }
    /**
   * @param {Element} el
   * @returns {boolean}
   */ function isScrolledIntoView(el) {
        const rect = el.getBoundingClientRect();
        const elemTop = rect.top;
        const elemBottom = rect.bottom;
        return elemTop < window.innerHeight && elemBottom >= 0;
    }
    /**
   * Checks whether the element is in the document (includes shadow roots).
   * This function this is a slight misnomer; it will return true even for elements in the head.
   *
   * @param {Node} elt
   * @returns {boolean}
   */ function bodyContains(elt) {
        return elt.getRootNode({
            composed: true
        }) === document;
    }
    /**
   * @param {string} trigger
   * @returns {string[]}
   */ function splitOnWhitespace(trigger) {
        return trigger.trim().split(/\s+/);
    }
    /**
   * mergeObjects takes all the keys from
   * obj2 and duplicates them into obj1
   * @template T1
   * @template T2
   * @param {T1} obj1
   * @param {T2} obj2
   * @returns {T1 & T2}
   */ function mergeObjects(obj1, obj2) {
        for(const key in obj2)if (obj2.hasOwnProperty(key)) // @ts-ignore tsc doesn't seem to properly handle types merging
        obj1[key] = obj2[key];
        // @ts-ignore tsc doesn't seem to properly handle types merging
        return obj1;
    }
    /**
   * @param {string} jString
   * @returns {any|null}
   */ function parseJSON(jString) {
        try {
            return JSON.parse(jString);
        } catch (error) {
            logError(error);
            return null;
        }
    }
    /**
   * @returns {boolean}
   */ function canAccessLocalStorage() {
        const test = 'htmx:sessionStorageTest';
        try {
            sessionStorage.setItem(test, test);
            sessionStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
   * @param {string} path
   * @returns {string}
   */ function normalizePath(path) {
        // use dummy base URL to allow normalize on path only
        const url = new URL(path, 'http://x');
        if (url) path = url.pathname + url.search;
        // remove trailing slash, unless index page
        if (path != '/') path = path.replace(/\/+$/, '');
        return path;
    }
    //= =========================================================================================
    // public API
    //= =========================================================================================
    /**
   * @param {string} str
   * @returns {any}
   */ function internalEval(str) {
        return maybeEval(getDocument().body, function() {
            return eval(str);
        });
    }
    /**
   * Adds a callback for the **htmx:load** event. This can be used to process new content, for example initializing the content with a javascript library
   *
   * @see https://htmx.org/api/#onLoad
   *
   * @param {(elt: Node) => void} callback the callback to call on newly loaded content
   * @returns {EventListener}
   */ function onLoadHelper(callback) {
        const value = htmx.on('htmx:load', /** @param {CustomEvent} evt */ function(evt) {
            callback(evt.detail.elt);
        });
        return value;
    }
    /**
   * Log all htmx events, useful for debugging.
   *
   * @see https://htmx.org/api/#logAll
   */ function logAll() {
        htmx.logger = function(elt, event, data) {
            if (console) console.log(event, elt, data);
        };
    }
    function logNone() {
        htmx.logger = null;
    }
    /**
   * Finds an element matching the selector
   *
   * @see https://htmx.org/api/#find
   *
   * @param {ParentNode|string} eltOrSelector  the root element to find the matching element in, inclusive | the selector to match
   * @param {string} [selector] the selector to match
   * @returns {Element|null}
   */ function find(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return eltOrSelector.querySelector(selector);
        else return find(getDocument(), eltOrSelector);
    }
    /**
   * Finds all elements matching the selector
   *
   * @see https://htmx.org/api/#findAll
   *
   * @param {ParentNode|string} eltOrSelector the root element to find the matching elements in, inclusive | the selector to match
   * @param {string} [selector] the selector to match
   * @returns {NodeListOf<Element>}
   */ function findAll(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return eltOrSelector.querySelectorAll(selector);
        else return findAll(getDocument(), eltOrSelector);
    }
    /**
   * @returns Window
   */ function getWindow() {
        return window;
    }
    /**
   * Removes an element from the DOM
   *
   * @see https://htmx.org/api/#remove
   *
   * @param {Node} elt
   * @param {number} [delay]
   */ function removeElement(elt, delay) {
        elt = resolveTarget(elt);
        if (delay) getWindow().setTimeout(function() {
            removeElement(elt);
            elt = null;
        }, delay);
        else parentElt(elt).removeChild(elt);
    }
    /**
   * @param {any} elt
   * @return {Element|null}
   */ function asElement(elt) {
        return elt instanceof Element ? elt : null;
    }
    /**
   * @param {any} elt
   * @return {HTMLElement|null}
   */ function asHtmlElement(elt) {
        return elt instanceof HTMLElement ? elt : null;
    }
    /**
   * @param {any} value
   * @return {string|null}
   */ function asString(value) {
        return typeof value === 'string' ? value : null;
    }
    /**
   * @param {EventTarget} elt
   * @return {ParentNode|null}
   */ function asParentNode(elt) {
        return elt instanceof Element || elt instanceof Document || elt instanceof DocumentFragment ? elt : null;
    }
    /**
   * This method adds a class to the given element.
   *
   * @see https://htmx.org/api/#addClass
   *
   * @param {Element|string} elt the element to add the class to
   * @param {string} clazz the class to add
   * @param {number} [delay] the delay (in milliseconds) before class is added
   */ function addClassToElement(elt, clazz, delay) {
        elt = asElement(resolveTarget(elt));
        if (!elt) return;
        if (delay) getWindow().setTimeout(function() {
            addClassToElement(elt, clazz);
            elt = null;
        }, delay);
        else elt.classList && elt.classList.add(clazz);
    }
    /**
   * Removes a class from the given element
   *
   * @see https://htmx.org/api/#removeClass
   *
   * @param {Node|string} node element to remove the class from
   * @param {string} clazz the class to remove
   * @param {number} [delay] the delay (in milliseconds before class is removed)
   */ function removeClassFromElement(node, clazz, delay) {
        let elt = asElement(resolveTarget(node));
        if (!elt) return;
        if (delay) getWindow().setTimeout(function() {
            removeClassFromElement(elt, clazz);
            elt = null;
        }, delay);
        else if (elt.classList) {
            elt.classList.remove(clazz);
            // if there are no classes left, remove the class attribute
            if (elt.classList.length === 0) elt.removeAttribute('class');
        }
    }
    /**
   * Toggles the given class on an element
   *
   * @see https://htmx.org/api/#toggleClass
   *
   * @param {Element|string} elt the element to toggle the class on
   * @param {string} clazz the class to toggle
   */ function toggleClassOnElement(elt, clazz) {
        elt = resolveTarget(elt);
        elt.classList.toggle(clazz);
    }
    /**
   * Takes the given class from its siblings, so that among its siblings, only the given element will have the class.
   *
   * @see https://htmx.org/api/#takeClass
   *
   * @param {Node|string} elt the element that will take the class
   * @param {string} clazz the class to take
   */ function takeClassForElement(elt, clazz) {
        elt = resolveTarget(elt);
        forEach(elt.parentElement.children, function(child) {
            removeClassFromElement(child, clazz);
        });
        addClassToElement(asElement(elt), clazz);
    }
    /**
   * Finds the closest matching element in the given elements parentage, inclusive of the element
   *
   * @see https://htmx.org/api/#closest
   *
   * @param {Element|string} elt the element to find the selector from
   * @param {string} selector the selector to find
   * @returns {Element|null}
   */ function closest(elt, selector) {
        elt = asElement(resolveTarget(elt));
        if (elt) return elt.closest(selector);
        return null;
    }
    /**
   * @param {string} str
   * @param {string} prefix
   * @returns {boolean}
   */ function startsWith(str, prefix) {
        return str.substring(0, prefix.length) === prefix;
    }
    /**
   * @param {string} str
   * @param {string} suffix
   * @returns {boolean}
   */ function endsWith(str, suffix) {
        return str.substring(str.length - suffix.length) === suffix;
    }
    /**
   * @param {string} selector
   * @returns {string}
   */ function normalizeSelector(selector) {
        const trimmedSelector = selector.trim();
        if (startsWith(trimmedSelector, '<') && endsWith(trimmedSelector, '/>')) return trimmedSelector.substring(1, trimmedSelector.length - 2);
        else return trimmedSelector;
    }
    /**
   * @param {Node|Element|Document|string} elt
   * @param {string} selector
   * @param {boolean=} global
   * @returns {(Node|Window)[]}
   */ function querySelectorAllExt(elt, selector, global) {
        if (selector.indexOf('global ') === 0) return querySelectorAllExt(elt, selector.slice(7), true);
        elt = resolveTarget(elt);
        const parts = [];
        {
            let chevronsCount = 0;
            let offset = 0;
            for(let i = 0; i < selector.length; i++){
                const char = selector[i];
                if (char === ',' && chevronsCount === 0) {
                    parts.push(selector.substring(offset, i));
                    offset = i + 1;
                    continue;
                }
                if (char === '<') chevronsCount++;
                else if (char === '/' && i < selector.length - 1 && selector[i + 1] === '>') chevronsCount--;
            }
            if (offset < selector.length) parts.push(selector.substring(offset));
        }
        const result = [];
        const unprocessedParts = [];
        while(parts.length > 0){
            const selector = normalizeSelector(parts.shift());
            let item;
            if (selector.indexOf('closest ') === 0) item = closest(asElement(elt), normalizeSelector(selector.slice(8)));
            else if (selector.indexOf('find ') === 0) item = find(asParentNode(elt), normalizeSelector(selector.slice(5)));
            else if (selector === 'next' || selector === 'nextElementSibling') item = asElement(elt).nextElementSibling;
            else if (selector.indexOf('next ') === 0) item = scanForwardQuery(elt, normalizeSelector(selector.slice(5)), !!global);
            else if (selector === 'previous' || selector === 'previousElementSibling') item = asElement(elt).previousElementSibling;
            else if (selector.indexOf('previous ') === 0) item = scanBackwardsQuery(elt, normalizeSelector(selector.slice(9)), !!global);
            else if (selector === 'document') item = document;
            else if (selector === 'window') item = window;
            else if (selector === 'body') item = document.body;
            else if (selector === 'root') item = getRootNode(elt, !!global);
            else if (selector === 'host') item = /** @type ShadowRoot */ elt.getRootNode().host;
            else unprocessedParts.push(selector);
            if (item) result.push(item);
        }
        if (unprocessedParts.length > 0) {
            const standardSelector = unprocessedParts.join(',');
            const rootNode = asParentNode(getRootNode(elt, !!global));
            result.push(...toArray(rootNode.querySelectorAll(standardSelector)));
        }
        return result;
    }
    /**
   * @param {Node} start
   * @param {string} match
   * @param {boolean} global
   * @returns {Element}
   */ var scanForwardQuery = function(start, match, global) {
        const results = asParentNode(getRootNode(start, global)).querySelectorAll(match);
        for(let i = 0; i < results.length; i++){
            const elt = results[i];
            if (elt.compareDocumentPosition(start) === Node.DOCUMENT_POSITION_PRECEDING) return elt;
        }
    };
    /**
   * @param {Node} start
   * @param {string} match
   * @param {boolean} global
   * @returns {Element}
   */ var scanBackwardsQuery = function(start, match, global) {
        const results = asParentNode(getRootNode(start, global)).querySelectorAll(match);
        for(let i = results.length - 1; i >= 0; i--){
            const elt = results[i];
            if (elt.compareDocumentPosition(start) === Node.DOCUMENT_POSITION_FOLLOWING) return elt;
        }
    };
    /**
   * @param {Node|string} eltOrSelector
   * @param {string=} selector
   * @returns {Node|Window}
   */ function querySelectorExt(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return querySelectorAllExt(eltOrSelector, selector)[0];
        else return querySelectorAllExt(getDocument().body, eltOrSelector)[0];
    }
    /**
   * @template {EventTarget} T
   * @param {T|string} eltOrSelector
   * @param {T} [context]
   * @returns {Element|T|null}
   */ function resolveTarget(eltOrSelector, context) {
        if (typeof eltOrSelector === 'string') return find(asParentNode(context) || document, eltOrSelector);
        else return eltOrSelector;
    }
    /**
   * @typedef {keyof HTMLElementEventMap|string} AnyEventName
   */ /**
   * @typedef {Object} EventArgs
   * @property {EventTarget} target
   * @property {AnyEventName} event
   * @property {EventListener} listener
   * @property {Object|boolean} options
   */ /**
   * @param {EventTarget|AnyEventName} arg1
   * @param {AnyEventName|EventListener} arg2
   * @param {EventListener|Object|boolean} [arg3]
   * @param {Object|boolean} [arg4]
   * @returns {EventArgs}
   */ function processEventArgs(arg1, arg2, arg3, arg4) {
        if (isFunction(arg2)) return {
            target: getDocument().body,
            event: asString(arg1),
            listener: arg2,
            options: arg3
        };
        else return {
            target: resolveTarget(arg1),
            event: asString(arg2),
            listener: arg3,
            options: arg4
        };
    }
    /**
   * Adds an event listener to an element
   *
   * @see https://htmx.org/api/#on
   *
   * @param {EventTarget|string} arg1 the element to add the listener to | the event name to add the listener for
   * @param {string|EventListener} arg2 the event name to add the listener for | the listener to add
   * @param {EventListener|Object|boolean} [arg3] the listener to add | options to add
   * @param {Object|boolean} [arg4] options to add
   * @returns {EventListener}
   */ function addEventListenerImpl(arg1, arg2, arg3, arg4) {
        ready(function() {
            const eventArgs = processEventArgs(arg1, arg2, arg3, arg4);
            eventArgs.target.addEventListener(eventArgs.event, eventArgs.listener, eventArgs.options);
        });
        const b = isFunction(arg2);
        return b ? arg2 : arg3;
    }
    /**
   * Removes an event listener from an element
   *
   * @see https://htmx.org/api/#off
   *
   * @param {EventTarget|string} arg1 the element to remove the listener from | the event name to remove the listener from
   * @param {string|EventListener} arg2 the event name to remove the listener from | the listener to remove
   * @param {EventListener} [arg3] the listener to remove
   * @returns {EventListener}
   */ function removeEventListenerImpl(arg1, arg2, arg3) {
        ready(function() {
            const eventArgs = processEventArgs(arg1, arg2, arg3);
            eventArgs.target.removeEventListener(eventArgs.event, eventArgs.listener);
        });
        return isFunction(arg2) ? arg2 : arg3;
    }
    //= ===================================================================
    // Node processing
    //= ===================================================================
    const DUMMY_ELT = getDocument().createElement('output') // dummy element for bad selectors
    ;
    /**
   * @param {Element} elt
   * @param {string} attrName
   * @returns {(Node|Window)[]}
   */ function findAttributeTargets(elt, attrName) {
        const attrTarget = getClosestAttributeValue(elt, attrName);
        if (attrTarget) {
            if (attrTarget === 'this') return [
                findThisElement(elt, attrName)
            ];
            else {
                const result = querySelectorAllExt(elt, attrTarget);
                // find `inherit` whole word in value, make sure it's surrounded by commas or is at the start/end of string
                const shouldInherit = /(^|,)(\s*)inherit(\s*)($|,)/.test(attrTarget);
                if (shouldInherit) {
                    const eltToInheritFrom = asElement(getClosestMatch(elt, function(parent) {
                        return parent !== elt && hasAttribute(asElement(parent), attrName);
                    }));
                    if (eltToInheritFrom) result.push(...findAttributeTargets(eltToInheritFrom, attrName));
                }
                if (result.length === 0) {
                    logError('The selector "' + attrTarget + '" on ' + attrName + ' returned no matches!');
                    return [
                        DUMMY_ELT
                    ];
                } else return result;
            }
        }
    }
    /**
   * @param {Element} elt
   * @param {string} attribute
   * @returns {Element|null}
   */ function findThisElement(elt, attribute) {
        return asElement(getClosestMatch(elt, function(elt) {
            return getAttributeValue(asElement(elt), attribute) != null;
        }));
    }
    /**
   * @param {Element} elt
   * @returns {Node|Window|null}
   */ function getTarget(elt) {
        const targetStr = getClosestAttributeValue(elt, 'hx-target');
        if (targetStr) {
            if (targetStr === 'this') return findThisElement(elt, 'hx-target');
            else return querySelectorExt(elt, targetStr);
        } else {
            const data = getInternalData(elt);
            if (data.boosted) return getDocument().body;
            else return elt;
        }
    }
    /**
   * @param {string} name
   * @returns {boolean}
   */ function shouldSettleAttribute(name) {
        return htmx.config.attributesToSettle.includes(name);
    }
    /**
   * @param {Element} mergeTo
   * @param {Element} mergeFrom
   */ function cloneAttributes(mergeTo, mergeFrom) {
        forEach(Array.from(mergeTo.attributes), function(attr) {
            if (!mergeFrom.hasAttribute(attr.name) && shouldSettleAttribute(attr.name)) mergeTo.removeAttribute(attr.name);
        });
        forEach(mergeFrom.attributes, function(attr) {
            if (shouldSettleAttribute(attr.name)) mergeTo.setAttribute(attr.name, attr.value);
        });
    }
    /**
   * @param {HtmxSwapStyle} swapStyle
   * @param {Element} target
   * @returns {boolean}
   */ function isInlineSwap(swapStyle, target) {
        const extensions = getExtensions(target);
        for(let i = 0; i < extensions.length; i++){
            const extension = extensions[i];
            try {
                if (extension.isInlineSwap(swapStyle)) return true;
            } catch (e) {
                logError(e);
            }
        }
        return swapStyle === 'outerHTML';
    }
    /**
   * @param {string} oobValue
   * @param {Element} oobElement
   * @param {HtmxSettleInfo} settleInfo
   * @param {Node|Document} [rootNode]
   * @returns
   */ function oobSwap(oobValue, oobElement, settleInfo, rootNode) {
        rootNode = rootNode || getDocument();
        let selector = '#' + CSS.escape(getRawAttribute(oobElement, 'id'));
        /** @type HtmxSwapStyle */ let swapStyle = 'outerHTML';
        if (oobValue === 'true') ;
        else if (oobValue.indexOf(':') > 0) {
            swapStyle = oobValue.substring(0, oobValue.indexOf(':'));
            selector = oobValue.substring(oobValue.indexOf(':') + 1);
        } else swapStyle = oobValue;
        oobElement.removeAttribute('hx-swap-oob');
        oobElement.removeAttribute('data-hx-swap-oob');
        const targets = querySelectorAllExt(rootNode, selector, false);
        if (targets.length) {
            forEach(targets, function(target) {
                let fragment;
                const oobElementClone = oobElement.cloneNode(true);
                fragment = getDocument().createDocumentFragment();
                fragment.appendChild(oobElementClone);
                if (!isInlineSwap(swapStyle, target)) fragment = asParentNode(oobElementClone) // if this is not an inline swap, we use the content of the node, not the node itself
                ;
                const beforeSwapDetails = {
                    shouldSwap: true,
                    target: target,
                    fragment: fragment
                };
                if (!triggerEvent(target, 'htmx:oobBeforeSwap', beforeSwapDetails)) return;
                target = beforeSwapDetails.target // allow re-targeting
                ;
                if (beforeSwapDetails.shouldSwap) {
                    handlePreservedElements(fragment);
                    swapWithStyle(swapStyle, target, target, fragment, settleInfo);
                    restorePreservedElements();
                }
                forEach(settleInfo.elts, function(elt) {
                    triggerEvent(elt, 'htmx:oobAfterSwap', beforeSwapDetails);
                });
            });
            oobElement.parentNode.removeChild(oobElement);
        } else {
            oobElement.parentNode.removeChild(oobElement);
            triggerErrorEvent(getDocument().body, 'htmx:oobErrorNoTarget', {
                content: oobElement
            });
        }
        return oobValue;
    }
    function restorePreservedElements() {
        const pantry = find('#--htmx-preserve-pantry--');
        if (pantry) {
            for (const preservedElt of [
                ...pantry.children
            ]){
                const existingElement = find('#' + preservedElt.id);
                // @ts-ignore - use proposed moveBefore feature
                existingElement.parentNode.moveBefore(preservedElt, existingElement);
                existingElement.remove();
            }
            pantry.remove();
        }
    }
    /**
   * @param {DocumentFragment|ParentNode} fragment
   */ function handlePreservedElements(fragment) {
        forEach(findAll(fragment, '[hx-preserve], [data-hx-preserve]'), function(preservedElt) {
            const id = getAttributeValue(preservedElt, 'id');
            const existingElement = getDocument().getElementById(id);
            if (existingElement != null) {
                if (preservedElt.moveBefore) {
                    // get or create a storage spot for stuff
                    let pantry = find('#--htmx-preserve-pantry--');
                    if (pantry == null) {
                        getDocument().body.insertAdjacentHTML('afterend', "<div id='--htmx-preserve-pantry--'></div>");
                        pantry = find('#--htmx-preserve-pantry--');
                    }
                    // @ts-ignore - use proposed moveBefore feature
                    pantry.moveBefore(existingElement, null);
                } else preservedElt.parentNode.replaceChild(existingElement, preservedElt);
            }
        });
    }
    /**
   * @param {Node} parentNode
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function handleAttributes(parentNode, fragment, settleInfo) {
        forEach(fragment.querySelectorAll('[id]'), function(newNode) {
            const id = getRawAttribute(newNode, 'id');
            if (id && id.length > 0) {
                const normalizedId = id.replace("'", "\\'");
                const normalizedTag = newNode.tagName.replace(':', '\\:');
                const parentElt = asParentNode(parentNode);
                const oldNode = parentElt && parentElt.querySelector(normalizedTag + "[id='" + normalizedId + "']");
                if (oldNode && oldNode !== parentElt) {
                    const newAttributes = newNode.cloneNode();
                    cloneAttributes(newNode, oldNode);
                    settleInfo.tasks.push(function() {
                        cloneAttributes(newNode, newAttributes);
                    });
                }
            }
        });
    }
    /**
   * @param {Node} child
   * @returns {HtmxSettleTask}
   */ function makeAjaxLoadTask(child) {
        return function() {
            removeClassFromElement(child, htmx.config.addedClass);
            processNode(asElement(child));
            processFocus(asParentNode(child));
            triggerEvent(child, 'htmx:load');
        };
    }
    /**
   * @param {ParentNode} child
   */ function processFocus(child) {
        const autofocus = '[autofocus]';
        const autoFocusedElt = asHtmlElement(matches(child, autofocus) ? child : child.querySelector(autofocus));
        if (autoFocusedElt != null) autoFocusedElt.focus();
    }
    /**
   * @param {Node} parentNode
   * @param {Node} insertBefore
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function insertNodesBefore(parentNode, insertBefore, fragment, settleInfo) {
        handleAttributes(parentNode, fragment, settleInfo);
        while(fragment.childNodes.length > 0){
            const child = fragment.firstChild;
            addClassToElement(asElement(child), htmx.config.addedClass);
            parentNode.insertBefore(child, insertBefore);
            if (child.nodeType !== Node.TEXT_NODE && child.nodeType !== Node.COMMENT_NODE) settleInfo.tasks.push(makeAjaxLoadTask(child));
        }
    }
    /**
   * based on https://gist.github.com/hyamamoto/fd435505d29ebfa3d9716fd2be8d42f0,
   * derived from Java's string hashcode implementation
   * @param {string} string
   * @param {number} hash
   * @returns {number}
   */ function stringHash(string, hash) {
        let char = 0;
        while(char < string.length)hash = (hash << 5) - hash + string.charCodeAt(char++) | 0 // bitwise or ensures we have a 32-bit int
        ;
        return hash;
    }
    /**
   * @param {Element} elt
   * @returns {number}
   */ function attributeHash(elt) {
        let hash = 0;
        for(let i = 0; i < elt.attributes.length; i++){
            const attribute = elt.attributes[i];
            if (attribute.value) {
                hash = stringHash(attribute.name, hash);
                hash = stringHash(attribute.value, hash);
            }
        }
        return hash;
    }
    /**
   * @param {EventTarget} elt
   */ function deInitOnHandlers(elt) {
        const internalData = getInternalData(elt);
        if (internalData.onHandlers) {
            for(let i = 0; i < internalData.onHandlers.length; i++){
                const handlerInfo = internalData.onHandlers[i];
                removeEventListenerImpl(elt, handlerInfo.event, handlerInfo.listener);
            }
            delete internalData.onHandlers;
        }
    }
    /**
   * @param {Node} element
   */ function deInitNode(element) {
        const internalData = getInternalData(element);
        if (internalData.timeout) clearTimeout(internalData.timeout);
        if (internalData.listenerInfos) forEach(internalData.listenerInfos, function(info) {
            if (info.on) removeEventListenerImpl(info.on, info.trigger, info.listener);
        });
        deInitOnHandlers(element);
        forEach(Object.keys(internalData), function(key) {
            if (key !== 'firstInitCompleted') delete internalData[key];
        });
    }
    /**
   * @param {Node} element
   */ function cleanUpElement(element) {
        triggerEvent(element, 'htmx:beforeCleanupElement');
        deInitNode(element);
        // @ts-ignore
        forEach(element.children, function(child) {
            cleanUpElement(child);
        });
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapOuterHTML(target, fragment, settleInfo) {
        if (target.tagName === 'BODY') return swapInnerHTML(target, fragment, settleInfo);
        /** @type {Node} */ let newElt;
        const eltBeforeNewContent = target.previousSibling;
        const parentNode = parentElt(target);
        if (!parentNode) return;
        insertNodesBefore(parentNode, target, fragment, settleInfo);
        if (eltBeforeNewContent == null) newElt = parentNode.firstChild;
        else newElt = eltBeforeNewContent.nextSibling;
        settleInfo.elts = settleInfo.elts.filter(function(e) {
            return e !== target;
        });
        // scan through all newly added content and add all elements to the settle info so we trigger
        // events properly on them
        while(newElt && newElt !== target){
            if (newElt instanceof Element) settleInfo.elts.push(newElt);
            newElt = newElt.nextSibling;
        }
        cleanUpElement(target);
        target.remove();
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapAfterBegin(target, fragment, settleInfo) {
        return insertNodesBefore(target, target.firstChild, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapBeforeBegin(target, fragment, settleInfo) {
        return insertNodesBefore(parentElt(target), target, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapBeforeEnd(target, fragment, settleInfo) {
        return insertNodesBefore(target, null, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapAfterEnd(target, fragment, settleInfo) {
        return insertNodesBefore(parentElt(target), target.nextSibling, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   */ function swapDelete(target) {
        cleanUpElement(target);
        const parent = parentElt(target);
        if (parent) return parent.removeChild(target);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapInnerHTML(target, fragment, settleInfo) {
        const firstChild = target.firstChild;
        insertNodesBefore(target, firstChild, fragment, settleInfo);
        if (firstChild) {
            while(firstChild.nextSibling){
                cleanUpElement(firstChild.nextSibling);
                target.removeChild(firstChild.nextSibling);
            }
            cleanUpElement(firstChild);
            target.removeChild(firstChild);
        }
    }
    /**
   * @param {HtmxSwapStyle} swapStyle
   * @param {Element} elt
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapWithStyle(swapStyle, elt, target, fragment, settleInfo) {
        switch(swapStyle){
            case 'none':
                return;
            case 'outerHTML':
                swapOuterHTML(target, fragment, settleInfo);
                return;
            case 'afterbegin':
                swapAfterBegin(target, fragment, settleInfo);
                return;
            case 'beforebegin':
                swapBeforeBegin(target, fragment, settleInfo);
                return;
            case 'beforeend':
                swapBeforeEnd(target, fragment, settleInfo);
                return;
            case 'afterend':
                swapAfterEnd(target, fragment, settleInfo);
                return;
            case 'delete':
                swapDelete(target);
                return;
            default:
                var extensions = getExtensions(elt);
                for(let i = 0; i < extensions.length; i++){
                    const ext = extensions[i];
                    try {
                        const newElements = ext.handleSwap(swapStyle, target, fragment, settleInfo);
                        if (newElements) {
                            if (Array.isArray(newElements)) // if handleSwap returns an array (like) of elements, we handle them
                            for(let j = 0; j < newElements.length; j++){
                                const child = newElements[j];
                                if (child.nodeType !== Node.TEXT_NODE && child.nodeType !== Node.COMMENT_NODE) settleInfo.tasks.push(makeAjaxLoadTask(child));
                            }
                            return;
                        }
                    } catch (e) {
                        logError(e);
                    }
                }
                if (swapStyle === 'innerHTML') swapInnerHTML(target, fragment, settleInfo);
                else swapWithStyle(htmx.config.defaultSwapStyle, elt, target, fragment, settleInfo);
        }
    }
    /**
   * @param {DocumentFragment} fragment
   * @param {HtmxSettleInfo} settleInfo
   * @param {Node|Document} [rootNode]
   */ function findAndSwapOobElements(fragment, settleInfo, rootNode) {
        var oobElts = findAll(fragment, '[hx-swap-oob], [data-hx-swap-oob]');
        forEach(oobElts, function(oobElement) {
            if (htmx.config.allowNestedOobSwaps || oobElement.parentElement === null) {
                const oobValue = getAttributeValue(oobElement, 'hx-swap-oob');
                if (oobValue != null) oobSwap(oobValue, oobElement, settleInfo, rootNode);
            } else {
                oobElement.removeAttribute('hx-swap-oob');
                oobElement.removeAttribute('data-hx-swap-oob');
            }
        });
        return oobElts.length > 0;
    }
    /**
   * Implements complete swapping pipeline, including: delay, view transitions, focus and selection preservation,
   * title updates, scroll, OOB swapping, normal swapping and settling
   * @param {string|Element} target
   * @param {string} content
   * @param {HtmxSwapSpecification} swapSpec
   * @param {SwapOptions} [swapOptions]
   */ function swap(target, content, swapSpec, swapOptions) {
        if (!swapOptions) swapOptions = {};
        // optional transition API promise callbacks
        let settleResolve = null;
        let settleReject = null;
        let doSwap = function() {
            maybeCall(swapOptions.beforeSwapCallback);
            target = resolveTarget(target);
            const rootNode = swapOptions.contextElement ? getRootNode(swapOptions.contextElement, false) : getDocument();
            // preserve focus and selection
            const activeElt = document.activeElement;
            let selectionInfo = {};
            selectionInfo = {
                elt: activeElt,
                // @ts-ignore
                start: activeElt ? activeElt.selectionStart : null,
                // @ts-ignore
                end: activeElt ? activeElt.selectionEnd : null
            };
            const settleInfo = makeSettleInfo(target);
            // For text content swaps, don't parse the response as HTML, just insert it
            if (swapSpec.swapStyle === 'textContent') target.textContent = content;
            else {
                let fragment = makeFragment(content);
                settleInfo.title = swapOptions.title || fragment.title;
                if (swapOptions.historyRequest) // @ts-ignore fragment can be a parentNode Element
                fragment = fragment.querySelector('[hx-history-elt],[data-hx-history-elt]') || fragment;
                // select-oob swaps
                if (swapOptions.selectOOB) {
                    const oobSelectValues = swapOptions.selectOOB.split(',');
                    for(let i = 0; i < oobSelectValues.length; i++){
                        const oobSelectValue = oobSelectValues[i].split(':', 2);
                        let id = oobSelectValue[0].trim();
                        if (id.indexOf('#') === 0) id = id.substring(1);
                        const oobValue = oobSelectValue[1] || 'true';
                        const oobElement = fragment.querySelector('#' + id);
                        if (oobElement) oobSwap(oobValue, oobElement, settleInfo, rootNode);
                    }
                }
                // oob swaps
                findAndSwapOobElements(fragment, settleInfo, rootNode);
                forEach(findAll(fragment, 'template'), /** @param {HTMLTemplateElement} template */ function(template) {
                    if (template.content && findAndSwapOobElements(template.content, settleInfo, rootNode)) // Avoid polluting the DOM with empty templates that were only used to encapsulate oob swap
                    template.remove();
                });
                // normal swap
                if (swapOptions.select) {
                    const newFragment = getDocument().createDocumentFragment();
                    forEach(fragment.querySelectorAll(swapOptions.select), function(node) {
                        newFragment.appendChild(node);
                    });
                    fragment = newFragment;
                }
                handlePreservedElements(fragment);
                swapWithStyle(swapSpec.swapStyle, swapOptions.contextElement, target, fragment, settleInfo);
                restorePreservedElements();
            }
            // apply saved focus and selection information to swapped content
            if (selectionInfo.elt && !bodyContains(selectionInfo.elt) && getRawAttribute(selectionInfo.elt, 'id')) {
                const newActiveElt = document.getElementById(getRawAttribute(selectionInfo.elt, 'id'));
                const focusOptions = {
                    preventScroll: swapSpec.focusScroll !== undefined ? !swapSpec.focusScroll : !htmx.config.defaultFocusScroll
                };
                if (newActiveElt) {
                    // @ts-ignore
                    if (selectionInfo.start && newActiveElt.setSelectionRange) try {
                        // @ts-ignore
                        newActiveElt.setSelectionRange(selectionInfo.start, selectionInfo.end);
                    } catch (e) {
                    // the setSelectionRange method is present on fields that don't support it, so just let this fail
                    }
                    newActiveElt.focus(focusOptions);
                }
            }
            target.classList.remove(htmx.config.swappingClass);
            forEach(settleInfo.elts, function(elt) {
                if (elt.classList) elt.classList.add(htmx.config.settlingClass);
                triggerEvent(elt, 'htmx:afterSwap', swapOptions.eventInfo);
            });
            maybeCall(swapOptions.afterSwapCallback);
            // merge in new title after swap but before settle
            if (!swapSpec.ignoreTitle) handleTitle(settleInfo.title);
            // settle
            const doSettle = function() {
                forEach(settleInfo.tasks, function(task) {
                    task.call();
                });
                forEach(settleInfo.elts, function(elt) {
                    if (elt.classList) elt.classList.remove(htmx.config.settlingClass);
                    triggerEvent(elt, 'htmx:afterSettle', swapOptions.eventInfo);
                });
                if (swapOptions.anchor) {
                    const anchorTarget = asElement(resolveTarget('#' + swapOptions.anchor));
                    if (anchorTarget) anchorTarget.scrollIntoView({
                        block: 'start',
                        behavior: 'auto'
                    });
                }
                updateScrollState(settleInfo.elts, swapSpec);
                maybeCall(swapOptions.afterSettleCallback);
                maybeCall(settleResolve);
            };
            if (swapSpec.settleDelay > 0) getWindow().setTimeout(doSettle, swapSpec.settleDelay);
            else doSettle();
        };
        let shouldTransition = htmx.config.globalViewTransitions;
        if (swapSpec.hasOwnProperty('transition')) shouldTransition = swapSpec.transition;
        const elt = swapOptions.contextElement || getDocument();
        if (shouldTransition && triggerEvent(elt, 'htmx:beforeTransition', swapOptions.eventInfo) && typeof Promise !== 'undefined' && // @ts-ignore experimental feature atm
        document.startViewTransition) {
            const settlePromise = new Promise(function(_resolve, _reject) {
                settleResolve = _resolve;
                settleReject = _reject;
            });
            // wrap the original doSwap() in a call to startViewTransition()
            const innerDoSwap = doSwap;
            doSwap = function() {
                // @ts-ignore experimental feature atm
                document.startViewTransition(function() {
                    innerDoSwap();
                    return settlePromise;
                });
            };
        }
        try {
            if (swapSpec?.swapDelay && swapSpec.swapDelay > 0) getWindow().setTimeout(doSwap, swapSpec.swapDelay);
            else doSwap();
        } catch (e) {
            triggerErrorEvent(elt, 'htmx:swapError', swapOptions.eventInfo);
            maybeCall(settleReject);
            throw e;
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {string} header
   * @param {EventTarget} elt
   */ function handleTriggerHeader(xhr, header, elt) {
        const triggerBody = xhr.getResponseHeader(header);
        if (triggerBody.indexOf('{') === 0) {
            const triggers = parseJSON(triggerBody);
            for(const eventName in triggers)if (triggers.hasOwnProperty(eventName)) {
                let detail = triggers[eventName];
                if (isRawObject(detail)) // @ts-ignore
                elt = detail.target !== undefined ? detail.target : elt;
                else detail = {
                    value: detail
                };
                triggerEvent(elt, eventName, detail);
            }
        } else {
            const eventNames = triggerBody.split(',');
            for(let i = 0; i < eventNames.length; i++)triggerEvent(elt, eventNames[i].trim(), []);
        }
    }
    const WHITESPACE = /\s/;
    const WHITESPACE_OR_COMMA = /[\s,]/;
    const SYMBOL_START = /[_$a-zA-Z]/;
    const SYMBOL_CONT = /[_$a-zA-Z0-9]/;
    const STRINGISH_START = [
        '"',
        "'",
        '/'
    ];
    const NOT_WHITESPACE = /[^\s]/;
    const COMBINED_SELECTOR_START = /[{(]/;
    const COMBINED_SELECTOR_END = /[})]/;
    /**
   * @param {string} str
   * @returns {string[]}
   */ function tokenizeString(str) {
        /** @type string[] */ const tokens = [];
        let position = 0;
        while(position < str.length){
            if (SYMBOL_START.exec(str.charAt(position))) {
                var startPosition = position;
                while(SYMBOL_CONT.exec(str.charAt(position + 1)))position++;
                tokens.push(str.substring(startPosition, position + 1));
            } else if (STRINGISH_START.indexOf(str.charAt(position)) !== -1) {
                const startChar = str.charAt(position);
                var startPosition = position;
                position++;
                while(position < str.length && str.charAt(position) !== startChar){
                    if (str.charAt(position) === '\\') position++;
                    position++;
                }
                tokens.push(str.substring(startPosition, position + 1));
            } else {
                const symbol = str.charAt(position);
                tokens.push(symbol);
            }
            position++;
        }
        return tokens;
    }
    /**
   * @param {string} token
   * @param {string|null} last
   * @param {string} paramName
   * @returns {boolean}
   */ function isPossibleRelativeReference(token, last, paramName) {
        return SYMBOL_START.exec(token.charAt(0)) && token !== 'true' && token !== 'false' && token !== 'this' && token !== paramName && last !== '.';
    }
    /**
   * @param {EventTarget|string} elt
   * @param {string[]} tokens
   * @param {string} paramName
   * @returns {ConditionalFunction|null}
   */ function maybeGenerateConditional(elt, tokens, paramName) {
        if (tokens[0] === '[') {
            tokens.shift();
            let bracketCount = 1;
            let conditionalSource = ' return (function(' + paramName + '){ return (';
            let last = null;
            while(tokens.length > 0){
                const token = tokens[0];
                // @ts-ignore For some reason tsc doesn't understand the shift call, and thinks we're comparing the same value here, i.e. '[' vs ']'
                if (token === ']') {
                    bracketCount--;
                    if (bracketCount === 0) {
                        if (last === null) conditionalSource = conditionalSource + 'true';
                        tokens.shift();
                        conditionalSource += ')})';
                        try {
                            const conditionFunction = maybeEval(elt, function() {
                                return Function(conditionalSource)();
                            }, function() {
                                return true;
                            });
                            conditionFunction.source = conditionalSource;
                            return conditionFunction;
                        } catch (e) {
                            triggerErrorEvent(getDocument().body, 'htmx:syntax:error', {
                                error: e,
                                source: conditionalSource
                            });
                            return null;
                        }
                    }
                } else if (token === '[') bracketCount++;
                if (isPossibleRelativeReference(token, last, paramName)) conditionalSource += '((' + paramName + '.' + token + ') ? (' + paramName + '.' + token + ') : (window.' + token + '))';
                else conditionalSource = conditionalSource + token;
                last = tokens.shift();
            }
        }
    }
    /**
   * @param {string[]} tokens
   * @param {RegExp} match
   * @returns {string}
   */ function consumeUntil(tokens, match) {
        let result = '';
        while(tokens.length > 0 && !match.test(tokens[0]))result += tokens.shift();
        return result;
    }
    /**
   * @param {string[]} tokens
   * @returns {string}
   */ function consumeCSSSelector(tokens) {
        let result;
        if (tokens.length > 0 && COMBINED_SELECTOR_START.test(tokens[0])) {
            tokens.shift();
            result = consumeUntil(tokens, COMBINED_SELECTOR_END).trim();
            tokens.shift();
        } else result = consumeUntil(tokens, WHITESPACE_OR_COMMA);
        return result;
    }
    const INPUT_SELECTOR = 'input, textarea, select';
    /**
   * @param {Element} elt
   * @param {string} explicitTrigger
   * @param {Object} cache for trigger specs
   * @returns {HtmxTriggerSpecification[]}
   */ function parseAndCacheTrigger(elt, explicitTrigger, cache) {
        /** @type HtmxTriggerSpecification[] */ const triggerSpecs = [];
        const tokens = tokenizeString(explicitTrigger);
        do {
            consumeUntil(tokens, NOT_WHITESPACE);
            const initialLength = tokens.length;
            const trigger = consumeUntil(tokens, /[,\[\s]/);
            if (trigger !== '') {
                if (trigger === 'every') {
                    /** @type HtmxTriggerSpecification */ const every = {
                        trigger: 'every'
                    };
                    consumeUntil(tokens, NOT_WHITESPACE);
                    every.pollInterval = parseInterval(consumeUntil(tokens, /[,\[\s]/));
                    consumeUntil(tokens, NOT_WHITESPACE);
                    var eventFilter = maybeGenerateConditional(elt, tokens, 'event');
                    if (eventFilter) every.eventFilter = eventFilter;
                    triggerSpecs.push(every);
                } else {
                    /** @type HtmxTriggerSpecification */ const triggerSpec = {
                        trigger: trigger
                    };
                    var eventFilter = maybeGenerateConditional(elt, tokens, 'event');
                    if (eventFilter) triggerSpec.eventFilter = eventFilter;
                    consumeUntil(tokens, NOT_WHITESPACE);
                    while(tokens.length > 0 && tokens[0] !== ','){
                        const token = tokens.shift();
                        if (token === 'changed') triggerSpec.changed = true;
                        else if (token === 'once') triggerSpec.once = true;
                        else if (token === 'consume') triggerSpec.consume = true;
                        else if (token === 'delay' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.delay = parseInterval(consumeUntil(tokens, WHITESPACE_OR_COMMA));
                        } else if (token === 'from' && tokens[0] === ':') {
                            tokens.shift();
                            if (COMBINED_SELECTOR_START.test(tokens[0])) var from_arg = consumeCSSSelector(tokens);
                            else {
                                var from_arg = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                                if (from_arg === 'closest' || from_arg === 'find' || from_arg === 'next' || from_arg === 'previous') {
                                    tokens.shift();
                                    const selector = consumeCSSSelector(tokens);
                                    // `next` and `previous` allow a selector-less syntax
                                    if (selector.length > 0) from_arg += ' ' + selector;
                                }
                            }
                            triggerSpec.from = from_arg;
                        } else if (token === 'target' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.target = consumeCSSSelector(tokens);
                        } else if (token === 'throttle' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.throttle = parseInterval(consumeUntil(tokens, WHITESPACE_OR_COMMA));
                        } else if (token === 'queue' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.queue = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                        } else if (token === 'root' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec[token] = consumeCSSSelector(tokens);
                        } else if (token === 'threshold' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec[token] = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                        } else triggerErrorEvent(elt, 'htmx:syntax:error', {
                            token: tokens.shift()
                        });
                        consumeUntil(tokens, NOT_WHITESPACE);
                    }
                    triggerSpecs.push(triggerSpec);
                }
            }
            if (tokens.length === initialLength) triggerErrorEvent(elt, 'htmx:syntax:error', {
                token: tokens.shift()
            });
            consumeUntil(tokens, NOT_WHITESPACE);
        }while (tokens[0] === ',' && tokens.shift());
        if (cache) cache[explicitTrigger] = triggerSpecs;
        return triggerSpecs;
    }
    /**
   * @param {Element} elt
   * @returns {HtmxTriggerSpecification[]}
   */ function getTriggerSpecs(elt) {
        const explicitTrigger = getAttributeValue(elt, 'hx-trigger');
        let triggerSpecs = [];
        if (explicitTrigger) {
            const cache = htmx.config.triggerSpecsCache;
            triggerSpecs = cache && cache[explicitTrigger] || parseAndCacheTrigger(elt, explicitTrigger, cache);
        }
        if (triggerSpecs.length > 0) return triggerSpecs;
        else if (matches(elt, 'form')) return [
            {
                trigger: 'submit'
            }
        ];
        else if (matches(elt, 'input[type="button"], input[type="submit"]')) return [
            {
                trigger: 'click'
            }
        ];
        else if (matches(elt, INPUT_SELECTOR)) return [
            {
                trigger: 'change'
            }
        ];
        else return [
            {
                trigger: 'click'
            }
        ];
    }
    /**
   * @param {Element} elt
   */ function cancelPolling(elt) {
        getInternalData(elt).cancelled = true;
    }
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxTriggerSpecification} spec
   */ function processPolling(elt, handler, spec) {
        const nodeData = getInternalData(elt);
        nodeData.timeout = getWindow().setTimeout(function() {
            if (bodyContains(elt) && nodeData.cancelled !== true) {
                if (!maybeFilterEvent(spec, elt, makeEvent('hx:poll:trigger', {
                    triggerSpec: spec,
                    target: elt
                }))) handler(elt);
                processPolling(elt, handler, spec);
            }
        }, spec.pollInterval);
    }
    /**
   * @param {HTMLAnchorElement} elt
   * @returns {boolean}
   */ function isLocalLink(elt) {
        return location.hostname === elt.hostname && getRawAttribute(elt, 'href') && getRawAttribute(elt, 'href').indexOf('#') !== 0;
    }
    /**
   * @param {Element} elt
   */ function eltIsDisabled(elt) {
        return closest(elt, htmx.config.disableSelector);
    }
    /**
   * @param {Element} elt
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification[]} triggerSpecs
   */ function boostElement(elt, nodeData, triggerSpecs) {
        if (elt instanceof HTMLAnchorElement && isLocalLink(elt) && (elt.target === '' || elt.target === '_self') || elt.tagName === 'FORM' && String(getRawAttribute(elt, 'method')).toLowerCase() !== 'dialog') {
            nodeData.boosted = true;
            let verb, path;
            if (elt.tagName === 'A') {
                verb = /** @type HttpVerb */ 'get';
                path = getRawAttribute(elt, 'href');
            } else {
                const rawAttribute = getRawAttribute(elt, 'method');
                verb = /** @type HttpVerb */ rawAttribute ? rawAttribute.toLowerCase() : 'get';
                path = getRawAttribute(elt, 'action');
                if (path == null || path === '') // if there is no action attribute on the form set path to current href before the
                // following logic to properly clear parameters on a GET (not on a POST!)
                path = location.href;
                if (verb === 'get' && path.includes('?')) path = path.replace(/\?[^#]+/, '');
            }
            triggerSpecs.forEach(function(triggerSpec) {
                addEventListener(elt, function(node, evt) {
                    const elt = asElement(node);
                    if (eltIsDisabled(elt)) {
                        cleanUpElement(elt);
                        return;
                    }
                    issueAjaxRequest(verb, path, elt, evt);
                }, nodeData, triggerSpec, true);
            });
        }
    }
    /**
   * @param {Event} evt
   * @param {Element} elt
   * @returns {boolean}
   */ function shouldCancel(evt, elt) {
        if (evt.type === 'submit' && elt.tagName === 'FORM') return true;
        else if (evt.type === 'click') {
            // find button wrapping the trigger element
            const btn = /** @type {HTMLButtonElement|HTMLInputElement|null} */ elt.closest('input[type="submit"], button');
            // Do not cancel on buttons that 1) don't have a related form or 2) have a type attribute of 'reset'/'button'.
            if (btn && btn.form && btn.type === 'submit') return true;
            // find link wrapping the trigger element
            const link = elt.closest('a');
            // Allow links with href="#fragment" (anchors with content after #) to perform normal fragment navigation.
            // Cancel default action for links with href="#" (bare hash) to prevent scrolling to top and unwanted URL changes.
            const samePageAnchor = /^#.+/;
            if (link && link.href && !samePageAnchor.test(link.getAttribute('href'))) return true;
        }
        return false;
    }
    /**
   * @param {Node} elt
   * @param {Event|MouseEvent|KeyboardEvent|TouchEvent} evt
   * @returns {boolean}
   */ function ignoreBoostedAnchorCtrlClick(elt, evt) {
        return getInternalData(elt).boosted && elt instanceof HTMLAnchorElement && evt.type === 'click' && // @ts-ignore this will resolve to undefined for events that don't define those properties, which is fine
        (evt.ctrlKey || evt.metaKey);
    }
    /**
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {Node} elt
   * @param {Event} evt
   * @returns {boolean}
   */ function maybeFilterEvent(triggerSpec, elt, evt) {
        const eventFilter = triggerSpec.eventFilter;
        if (eventFilter) try {
            return eventFilter.call(elt, evt) !== true;
        } catch (e) {
            const source = eventFilter.source;
            triggerErrorEvent(getDocument().body, 'htmx:eventFilter:error', {
                error: e,
                source: source
            });
            return true;
        }
        return false;
    }
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {boolean} [explicitCancel]
   */ function addEventListener(elt, handler, nodeData, triggerSpec, explicitCancel) {
        const elementData = getInternalData(elt);
        /** @type {(Node|Window)[]} */ let eltsToListenOn;
        if (triggerSpec.from) eltsToListenOn = querySelectorAllExt(elt, triggerSpec.from);
        else eltsToListenOn = [
            elt
        ];
        // store the initial values of the elements, so we can tell if they change
        if (triggerSpec.changed) {
            if (!('lastValue' in elementData)) elementData.lastValue = new WeakMap();
            eltsToListenOn.forEach(function(eltToListenOn) {
                if (!elementData.lastValue.has(triggerSpec)) elementData.lastValue.set(triggerSpec, new WeakMap());
                // @ts-ignore value will be undefined for non-input elements, which is fine
                elementData.lastValue.get(triggerSpec).set(eltToListenOn, eltToListenOn.value);
            });
        }
        forEach(eltsToListenOn, function(eltToListenOn) {
            /** @type EventListener */ const eventListener = function(evt) {
                if (!bodyContains(elt)) {
                    eltToListenOn.removeEventListener(triggerSpec.trigger, eventListener);
                    return;
                }
                if (ignoreBoostedAnchorCtrlClick(elt, evt)) return;
                if (explicitCancel || shouldCancel(evt, eltToListenOn)) evt.preventDefault();
                if (maybeFilterEvent(triggerSpec, elt, evt)) return;
                const eventData = getInternalData(evt);
                eventData.triggerSpec = triggerSpec;
                if (eventData.handledFor == null) eventData.handledFor = [];
                if (eventData.handledFor.indexOf(elt) < 0) {
                    eventData.handledFor.push(elt);
                    if (triggerSpec.consume) evt.stopPropagation();
                    if (triggerSpec.target && evt.target) {
                        if (!matches(asElement(evt.target), triggerSpec.target)) return;
                    }
                    if (triggerSpec.once) {
                        if (elementData.triggeredOnce) return;
                        else elementData.triggeredOnce = true;
                    }
                    if (triggerSpec.changed) {
                        const node = evt.target;
                        // @ts-ignore value will be undefined for non-input elements, which is fine
                        const value = node.value;
                        const lastValue = elementData.lastValue.get(triggerSpec);
                        if (lastValue.has(node) && lastValue.get(node) === value) return;
                        lastValue.set(node, value);
                    }
                    if (elementData.delayed) clearTimeout(elementData.delayed);
                    if (elementData.throttle) return;
                    if (triggerSpec.throttle > 0) {
                        if (!elementData.throttle) {
                            triggerEvent(elt, 'htmx:trigger');
                            handler(elt, evt);
                            elementData.throttle = getWindow().setTimeout(function() {
                                elementData.throttle = null;
                            }, triggerSpec.throttle);
                        }
                    } else if (triggerSpec.delay > 0) elementData.delayed = getWindow().setTimeout(function() {
                        triggerEvent(elt, 'htmx:trigger');
                        handler(elt, evt);
                    }, triggerSpec.delay);
                    else {
                        triggerEvent(elt, 'htmx:trigger');
                        handler(elt, evt);
                    }
                }
            };
            if (nodeData.listenerInfos == null) nodeData.listenerInfos = [];
            nodeData.listenerInfos.push({
                trigger: triggerSpec.trigger,
                listener: eventListener,
                on: eltToListenOn
            });
            eltToListenOn.addEventListener(triggerSpec.trigger, eventListener);
        });
    }
    let windowIsScrolling = false // used by initScrollHandler
    ;
    let scrollHandler = null;
    function initScrollHandler() {
        if (!scrollHandler) {
            scrollHandler = function() {
                windowIsScrolling = true;
            };
            window.addEventListener('scroll', scrollHandler);
            window.addEventListener('resize', scrollHandler);
            setInterval(function() {
                if (windowIsScrolling) {
                    windowIsScrolling = false;
                    forEach(getDocument().querySelectorAll("[hx-trigger*='revealed'],[data-hx-trigger*='revealed']"), function(elt) {
                        maybeReveal(elt);
                    });
                }
            }, 200);
        }
    }
    /**
   * @param {Element} elt
   */ function maybeReveal(elt) {
        if (!hasAttribute(elt, 'data-hx-revealed') && isScrolledIntoView(elt)) {
            elt.setAttribute('data-hx-revealed', 'true');
            const nodeData = getInternalData(elt);
            if (nodeData.initHash) triggerEvent(elt, 'revealed');
            else // if the node isn't initialized, wait for it before triggering the request
            elt.addEventListener('htmx:afterProcessNode', function() {
                triggerEvent(elt, 'revealed');
            }, {
                once: true
            });
        }
    }
    //= ===================================================================
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxNodeInternalData} nodeData
   * @param {number} delay
   */ function loadImmediately(elt, handler, nodeData, delay) {
        const load = function() {
            if (!nodeData.loaded) {
                nodeData.loaded = true;
                triggerEvent(elt, 'htmx:trigger');
                handler(elt);
            }
        };
        if (delay > 0) getWindow().setTimeout(load, delay);
        else load();
    }
    /**
   * @param {Element} elt
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification[]} triggerSpecs
   * @returns {boolean}
   */ function processVerbs(elt, nodeData, triggerSpecs) {
        let explicitAction = false;
        forEach(VERBS, function(verb) {
            if (hasAttribute(elt, 'hx-' + verb)) {
                const path = getAttributeValue(elt, 'hx-' + verb);
                explicitAction = true;
                nodeData.path = path;
                nodeData.verb = verb;
                triggerSpecs.forEach(function(triggerSpec) {
                    addTriggerHandler(elt, triggerSpec, nodeData, function(node, evt) {
                        const elt = asElement(node);
                        if (eltIsDisabled(elt)) {
                            cleanUpElement(elt);
                            return;
                        }
                        issueAjaxRequest(verb, path, elt, evt);
                    });
                });
            }
        });
        return explicitAction;
    }
    /**
   * @callback TriggerHandler
   * @param {Element} elt
   * @param {Event} [evt]
   */ /**
   * @param {Element} elt
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {HtmxNodeInternalData} nodeData
   * @param {TriggerHandler} handler
   */ function addTriggerHandler(elt, triggerSpec, nodeData, handler) {
        if (triggerSpec.trigger === 'revealed') {
            initScrollHandler();
            addEventListener(elt, handler, nodeData, triggerSpec);
            maybeReveal(asElement(elt));
        } else if (triggerSpec.trigger === 'intersect') {
            const observerOptions = {};
            if (triggerSpec.root) observerOptions.root = querySelectorExt(elt, triggerSpec.root);
            if (triggerSpec.threshold) observerOptions.threshold = parseFloat(triggerSpec.threshold);
            const observer = new IntersectionObserver(function(entries) {
                for(let i = 0; i < entries.length; i++){
                    const entry = entries[i];
                    if (entry.isIntersecting) {
                        triggerEvent(elt, 'intersect');
                        break;
                    }
                }
            }, observerOptions);
            observer.observe(asElement(elt));
            addEventListener(asElement(elt), handler, nodeData, triggerSpec);
        } else if (!nodeData.firstInitCompleted && triggerSpec.trigger === 'load') {
            if (!maybeFilterEvent(triggerSpec, elt, makeEvent('load', {
                elt: elt
            }))) loadImmediately(asElement(elt), handler, nodeData, triggerSpec.delay);
        } else if (triggerSpec.pollInterval > 0) {
            nodeData.polling = true;
            processPolling(asElement(elt), handler, triggerSpec);
        } else addEventListener(elt, handler, nodeData, triggerSpec);
    }
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function shouldProcessHxOn(node) {
        const elt = asElement(node);
        if (!elt) return false;
        const attributes = elt.attributes;
        for(let j = 0; j < attributes.length; j++){
            const attrName = attributes[j].name;
            if (startsWith(attrName, 'hx-on:') || startsWith(attrName, 'data-hx-on:') || startsWith(attrName, 'hx-on-') || startsWith(attrName, 'data-hx-on-')) return true;
        }
        return false;
    }
    /**
   * @param {Node} elt
   * @returns {Element[]}
   */ const HX_ON_QUERY = new XPathEvaluator().createExpression('.//*[@*[ starts-with(name(), "hx-on:") or starts-with(name(), "data-hx-on:") or starts-with(name(), "hx-on-") or starts-with(name(), "data-hx-on-") ]]');
    function processHXOnRoot(elt, elements) {
        if (shouldProcessHxOn(elt)) elements.push(asElement(elt));
        const iter = HX_ON_QUERY.evaluate(elt);
        let node = null;
        while(node = iter.iterateNext())elements.push(asElement(node));
    }
    function findHxOnWildcardElements(elt) {
        /** @type {Element[]} */ const elements = [];
        if (elt instanceof DocumentFragment) for (const child of elt.childNodes)processHXOnRoot(child, elements);
        else processHXOnRoot(elt, elements);
        return elements;
    }
    /**
   * @param {Element} elt
   * @returns {NodeListOf<Element>|[]}
   */ function findElementsToProcess(elt) {
        if (elt.querySelectorAll) {
            const boostedSelector = ', [hx-boost] a, [data-hx-boost] a, a[hx-boost], a[data-hx-boost]';
            const extensionSelectors = [];
            for(const e in extensions){
                const extension = extensions[e];
                if (extension.getSelectors) {
                    var selectors = extension.getSelectors();
                    if (selectors) extensionSelectors.push(selectors);
                }
            }
            const results = elt.querySelectorAll(VERB_SELECTOR + boostedSelector + ", form, [type='submit']," + ' [hx-ext], [data-hx-ext], [hx-trigger], [data-hx-trigger]' + extensionSelectors.flat().map((s)=>', ' + s).join(''));
            return results;
        } else return [];
    }
    /**
   * Handle submit buttons/inputs that have the form attribute set
   * see https://developer.mozilla.org/docs/Web/HTML/Element/button
   * @param {Event} evt
   */ function maybeSetLastButtonClicked(evt) {
        const elt = getTargetButton(evt.target);
        const internalData = getRelatedFormData(evt);
        if (internalData) internalData.lastButtonClicked = elt;
    }
    /**
   * @param {Event} evt
   */ function maybeUnsetLastButtonClicked(evt) {
        const internalData = getRelatedFormData(evt);
        if (internalData) internalData.lastButtonClicked = null;
    }
    /**
   * @param {EventTarget} target
   * @returns {HTMLButtonElement|HTMLInputElement|null}
   */ function getTargetButton(target) {
        return /** @type {HTMLButtonElement|HTMLInputElement|null} */ closest(asElement(target), "button, input[type='submit']");
    }
    /**
   * @param {Element} elt
   * @returns {HTMLFormElement|null}
   */ function getRelatedForm(elt) {
        // @ts-ignore Get the related form if available, else find the closest parent form
        return elt.form || closest(elt, 'form');
    }
    /**
   * @param {Event} evt
   * @returns {HtmxNodeInternalData|undefined}
   */ function getRelatedFormData(evt) {
        const elt = getTargetButton(evt.target);
        if (!elt) return;
        const form = getRelatedForm(elt);
        if (!form) return;
        return getInternalData(form);
    }
    /**
   * @param {EventTarget} elt
   */ function initButtonTracking(elt) {
        // need to handle both click and focus in:
        //   focusin - in case someone tabs in to a button and hits the space bar
        //   click - on OSX buttons do not focus on click see https://bugs.webkit.org/show_bug.cgi?id=13724
        elt.addEventListener('click', maybeSetLastButtonClicked);
        elt.addEventListener('focusin', maybeSetLastButtonClicked);
        elt.addEventListener('focusout', maybeUnsetLastButtonClicked);
    }
    /**
   * @param {Element} elt
   * @param {string} eventName
   * @param {string} code
   */ function addHxOnEventHandler(elt, eventName, code) {
        const nodeData = getInternalData(elt);
        if (!Array.isArray(nodeData.onHandlers)) nodeData.onHandlers = [];
        let func;
        /** @type EventListener */ const listener = function(e) {
            maybeEval(elt, function() {
                if (eltIsDisabled(elt)) return;
                if (!func) func = new Function('event', code);
                func.call(elt, e);
            });
        };
        elt.addEventListener(eventName, listener);
        nodeData.onHandlers.push({
            event: eventName,
            listener: listener
        });
    }
    /**
   * @param {Element} elt
   */ function processHxOnWildcard(elt) {
        // wipe any previous on handlers so that this function takes precedence
        deInitOnHandlers(elt);
        for(let i = 0; i < elt.attributes.length; i++){
            const name = elt.attributes[i].name;
            const value = elt.attributes[i].value;
            if (startsWith(name, 'hx-on') || startsWith(name, 'data-hx-on')) {
                const afterOnPosition = name.indexOf('-on') + 3;
                const nextChar = name.slice(afterOnPosition, afterOnPosition + 1);
                if (nextChar === '-' || nextChar === ':') {
                    let eventName = name.slice(afterOnPosition + 1);
                    // if the eventName starts with a colon or dash, prepend "htmx" for shorthand support
                    if (startsWith(eventName, ':')) eventName = 'htmx' + eventName;
                    else if (startsWith(eventName, '-')) eventName = 'htmx:' + eventName.slice(1);
                    else if (startsWith(eventName, 'htmx-')) eventName = 'htmx:' + eventName.slice(5);
                    addHxOnEventHandler(elt, eventName, value);
                }
            }
        }
    }
    /**
   * @param {Element|HTMLInputElement} elt
   */ function initNode(elt) {
        triggerEvent(elt, 'htmx:beforeProcessNode');
        const nodeData = getInternalData(elt);
        const triggerSpecs = getTriggerSpecs(elt);
        const hasExplicitHttpAction = processVerbs(elt, nodeData, triggerSpecs);
        if (!hasExplicitHttpAction) {
            if (getClosestAttributeValue(elt, 'hx-boost') === 'true') boostElement(elt, nodeData, triggerSpecs);
            else if (hasAttribute(elt, 'hx-trigger')) triggerSpecs.forEach(function(triggerSpec) {
                // For "naked" triggers, don't do anything at all
                addTriggerHandler(elt, triggerSpec, nodeData, function() {});
            });
        }
        // Handle submit buttons/inputs that have the form attribute set
        // see https://developer.mozilla.org/docs/Web/HTML/Element/button
        if (elt.tagName === 'FORM' || getRawAttribute(elt, 'type') === 'submit' && hasAttribute(elt, 'form')) initButtonTracking(elt);
        nodeData.firstInitCompleted = true;
        triggerEvent(elt, 'htmx:afterProcessNode');
    }
    /**
   * @param {Element} elt
   * @returns {boolean}
   */ function maybeDeInitAndHash(elt) {
        // Ensure only valid Elements and not shadow DOM roots are inited
        if (!(elt instanceof Element)) return false;
        const nodeData = getInternalData(elt);
        const hash = attributeHash(elt);
        if (nodeData.initHash !== hash) {
            deInitNode(elt);
            nodeData.initHash = hash;
            return true;
        }
        return false;
    }
    /**
   * Processes new content, enabling htmx behavior. This can be useful if you have content that is added to the DOM outside of the normal htmx request cycle but still want htmx attributes to work.
   *
   * @see https://htmx.org/api/#process
   *
   * @param {Element|string} elt element to process
   */ function processNode(elt) {
        elt = resolveTarget(elt);
        if (eltIsDisabled(elt)) {
            cleanUpElement(elt);
            return;
        }
        const elementsToInit = [];
        if (maybeDeInitAndHash(elt)) elementsToInit.push(elt);
        forEach(findElementsToProcess(elt), function(child) {
            if (eltIsDisabled(child)) {
                cleanUpElement(child);
                return;
            }
            if (maybeDeInitAndHash(child)) elementsToInit.push(child);
        });
        forEach(findHxOnWildcardElements(elt), processHxOnWildcard);
        forEach(elementsToInit, initNode);
    }
    //= ===================================================================
    // Event/Log Support
    //= ===================================================================
    /**
   * @param {string} str
   * @returns {string}
   */ function kebabEventName(str) {
        return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
    }
    /**
   * @param {string} eventName
   * @param {any} detail
   * @returns {CustomEvent}
   */ function makeEvent(eventName, detail) {
        // TODO: `composed: true` here is a hack to make global event handlers work with events in shadow DOM
        // This breaks expected encapsulation but needs to be here until decided otherwise by core devs
        return new CustomEvent(eventName, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: detail
        });
    }
    /**
   * @param {EventTarget|string} elt
   * @param {string} eventName
   * @param {any=} detail
   */ function triggerErrorEvent(elt, eventName, detail) {
        triggerEvent(elt, eventName, mergeObjects({
            error: eventName
        }, detail));
    }
    /**
   * @param {string} eventName
   * @returns {boolean}
   */ function ignoreEventForLogging(eventName) {
        return eventName === 'htmx:afterProcessNode';
    }
    /**
   * `withExtensions` locates all active extensions for a provided element, then
   * executes the provided function using each of the active extensions. You can filter
   * the element's extensions by giving it a list of extensions to ignore. It should
   * be called internally at every extendable execution point in htmx.
   *
   * @param {Element} elt
   * @param {(extension:HtmxExtension) => void} toDo
   * @param {string[]=} extensionsToIgnore
   * @returns void
   */ function withExtensions(elt, toDo, extensionsToIgnore) {
        forEach(getExtensions(elt, [], extensionsToIgnore), function(extension) {
            try {
                toDo(extension);
            } catch (e) {
                logError(e);
            }
        });
    }
    function logError(msg) {
        console.error(msg);
    }
    /**
   * Triggers a given event on an element
   *
   * @see https://htmx.org/api/#trigger
   *
   * @param {EventTarget|string} elt the element to trigger the event on
   * @param {string} eventName the name of the event to trigger
   * @param {any=} detail details for the event
   * @returns {boolean}
   */ function triggerEvent(elt, eventName, detail) {
        elt = resolveTarget(elt);
        if (detail == null) detail = {};
        detail.elt = elt;
        const event = makeEvent(eventName, detail);
        if (htmx.logger && !ignoreEventForLogging(eventName)) htmx.logger(elt, eventName, detail);
        if (detail.error) {
            logError(detail.error);
            triggerEvent(elt, 'htmx:error', {
                errorInfo: detail
            });
        }
        let eventResult = elt.dispatchEvent(event);
        const kebabName = kebabEventName(eventName);
        if (eventResult && kebabName !== eventName) {
            const kebabedEvent = makeEvent(kebabName, event.detail);
            eventResult = eventResult && elt.dispatchEvent(kebabedEvent);
        }
        withExtensions(asElement(elt), function(extension) {
            eventResult = eventResult && extension.onEvent(eventName, event) !== false && !event.defaultPrevented;
        });
        return eventResult;
    }
    //= ===================================================================
    // History Support
    //= ===================================================================
    let currentPathForHistory;
    /**
   * @param {string} path
   */ function setCurrentPathForHistory(path) {
        currentPathForHistory = path;
        if (canAccessLocalStorage()) sessionStorage.setItem('htmx-current-path-for-history', path);
    }
    setCurrentPathForHistory(location.pathname + location.search);
    /**
   * @returns {Element}
   */ function getHistoryElement() {
        const historyElt = getDocument().querySelector('[hx-history-elt],[data-hx-history-elt]');
        return historyElt || getDocument().body;
    }
    /**
   * @param {string} url
   * @param {Element} rootElt
   */ function saveToHistoryCache(url, rootElt) {
        if (!canAccessLocalStorage()) return;
        // get state to save
        const innerHTML = cleanInnerHtmlForHistory(rootElt);
        const title = getDocument().title;
        const scroll = window.scrollY;
        if (htmx.config.historyCacheSize <= 0) {
            // make sure that an eventually already existing cache is purged
            sessionStorage.removeItem('htmx-history-cache');
            return;
        }
        url = normalizePath(url);
        const historyCache = parseJSON(sessionStorage.getItem('htmx-history-cache')) || [];
        for(let i = 0; i < historyCache.length; i++)if (historyCache[i].url === url) {
            historyCache.splice(i, 1);
            break;
        }
        /** @type HtmxHistoryItem */ const newHistoryItem = {
            url: url,
            content: innerHTML,
            title: title,
            scroll: scroll
        };
        triggerEvent(getDocument().body, 'htmx:historyItemCreated', {
            item: newHistoryItem,
            cache: historyCache
        });
        historyCache.push(newHistoryItem);
        while(historyCache.length > htmx.config.historyCacheSize)historyCache.shift();
        // keep trying to save the cache until it succeeds or is empty
        while(historyCache.length > 0)try {
            sessionStorage.setItem('htmx-history-cache', JSON.stringify(historyCache));
            break;
        } catch (e) {
            triggerErrorEvent(getDocument().body, 'htmx:historyCacheError', {
                cause: e,
                cache: historyCache
            });
            historyCache.shift() // shrink the cache and retry
            ;
        }
    }
    /**
   * @typedef {Object} HtmxHistoryItem
   * @property {string} url
   * @property {string} content
   * @property {string} title
   * @property {number} scroll
   */ /**
   * @param {string} url
   * @returns {HtmxHistoryItem|null}
   */ function getCachedHistory(url) {
        if (!canAccessLocalStorage()) return null;
        url = normalizePath(url);
        const historyCache = parseJSON(sessionStorage.getItem('htmx-history-cache')) || [];
        for(let i = 0; i < historyCache.length; i++){
            if (historyCache[i].url === url) return historyCache[i];
        }
        return null;
    }
    /**
   * @param {Element} elt
   * @returns {string}
   */ function cleanInnerHtmlForHistory(elt) {
        const className = htmx.config.requestClass;
        const clone = /** @type Element */ elt.cloneNode(true);
        forEach(findAll(clone, '.' + className), function(child) {
            removeClassFromElement(child, className);
        });
        // remove the disabled attribute for any element disabled due to an htmx request
        forEach(findAll(clone, '[data-disabled-by-htmx]'), function(child) {
            child.removeAttribute('disabled');
        });
        return clone.innerHTML;
    }
    function saveCurrentPageToHistory() {
        const elt = getHistoryElement();
        let path = currentPathForHistory;
        if (canAccessLocalStorage()) path = sessionStorage.getItem('htmx-current-path-for-history');
        path = path || location.pathname + location.search;
        // Allow history snapshot feature to be disabled where hx-history="false"
        // is present *anywhere* in the current document we're about to save,
        // so we can prevent privileged data entering the cache.
        // The page will still be reachable as a history entry, but htmx will fetch it
        // live from the server onpopstate rather than look in the sessionStorage cache
        const disableHistoryCache = getDocument().querySelector('[hx-history="false" i],[data-hx-history="false" i]');
        if (!disableHistoryCache) {
            triggerEvent(getDocument().body, 'htmx:beforeHistorySave', {
                path: path,
                historyElt: elt
            });
            saveToHistoryCache(path, elt);
        }
        if (htmx.config.historyEnabled) history.replaceState({
            htmx: true
        }, getDocument().title, location.href);
    }
    /**
   * @param {string} path
   */ function pushUrlIntoHistory(path) {
        // remove the cache buster parameter, if any
        if (htmx.config.getCacheBusterParam) {
            path = path.replace(/org\.htmx\.cache-buster=[^&]*&?/, '');
            if (endsWith(path, '&') || endsWith(path, '?')) path = path.slice(0, -1);
        }
        if (htmx.config.historyEnabled) history.pushState({
            htmx: true
        }, '', path);
        setCurrentPathForHistory(path);
    }
    /**
   * @param {string} path
   */ function replaceUrlInHistory(path) {
        if (htmx.config.historyEnabled) history.replaceState({
            htmx: true
        }, '', path);
        setCurrentPathForHistory(path);
    }
    /**
   * @param {HtmxSettleTask[]} tasks
   */ function settleImmediately(tasks) {
        forEach(tasks, function(task) {
            task.call(undefined);
        });
    }
    /**
   * @param {string} path
   */ function loadHistoryFromServer(path) {
        const request = new XMLHttpRequest();
        const swapSpec = {
            swapStyle: 'innerHTML',
            swapDelay: 0,
            settleDelay: 0
        };
        const details = {
            path: path,
            xhr: request,
            historyElt: getHistoryElement(),
            swapSpec: swapSpec
        };
        request.open('GET', path, true);
        if (htmx.config.historyRestoreAsHxRequest) request.setRequestHeader('HX-Request', 'true');
        request.setRequestHeader('HX-History-Restore-Request', 'true');
        request.setRequestHeader('HX-Current-URL', location.href);
        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                details.response = this.response;
                triggerEvent(getDocument().body, 'htmx:historyCacheMissLoad', details);
                swap(details.historyElt, details.response, swapSpec, {
                    contextElement: details.historyElt,
                    historyRequest: true
                });
                setCurrentPathForHistory(details.path);
                triggerEvent(getDocument().body, 'htmx:historyRestore', {
                    path: path,
                    cacheMiss: true,
                    serverResponse: details.response
                });
            } else triggerErrorEvent(getDocument().body, 'htmx:historyCacheMissLoadError', details);
        };
        if (triggerEvent(getDocument().body, 'htmx:historyCacheMiss', details)) request.send() // only send request if event not prevented
        ;
    }
    /**
   * @param {string} [path]
   */ function restoreHistory(path) {
        saveCurrentPageToHistory();
        path = path || location.pathname + location.search;
        const cached = getCachedHistory(path);
        if (cached) {
            const swapSpec = {
                swapStyle: 'innerHTML',
                swapDelay: 0,
                settleDelay: 0,
                scroll: cached.scroll
            };
            const details = {
                path: path,
                item: cached,
                historyElt: getHistoryElement(),
                swapSpec: swapSpec
            };
            if (triggerEvent(getDocument().body, 'htmx:historyCacheHit', details)) {
                swap(details.historyElt, cached.content, swapSpec, {
                    contextElement: details.historyElt,
                    title: cached.title
                });
                setCurrentPathForHistory(details.path);
                triggerEvent(getDocument().body, 'htmx:historyRestore', details);
            }
        } else if (htmx.config.refreshOnHistoryMiss) // @ts-ignore: optional parameter in reload() function throws error
        // noinspection JSUnresolvedReference
        htmx.location.reload(true);
        else loadHistoryFromServer(path);
    }
    /**
   * @param {Element} elt
   * @returns {Element[]}
   */ function addRequestIndicatorClasses(elt) {
        let indicators = /** @type Element[] */ findAttributeTargets(elt, 'hx-indicator');
        if (indicators == null) indicators = [
            elt
        ];
        forEach(indicators, function(ic) {
            const internalData = getInternalData(ic);
            internalData.requestCount = (internalData.requestCount || 0) + 1;
            ic.classList.add.call(ic.classList, htmx.config.requestClass);
        });
        return indicators;
    }
    /**
   * @param {Element} elt
   * @returns {Element[]}
   */ function disableElements(elt) {
        let disabledElts = /** @type Element[] */ findAttributeTargets(elt, 'hx-disabled-elt');
        if (disabledElts == null) disabledElts = [];
        forEach(disabledElts, function(disabledElement) {
            const internalData = getInternalData(disabledElement);
            internalData.requestCount = (internalData.requestCount || 0) + 1;
            disabledElement.setAttribute('disabled', '');
            disabledElement.setAttribute('data-disabled-by-htmx', '');
        });
        return disabledElts;
    }
    /**
   * @param {Element[]} indicators
   * @param {Element[]} disabled
   */ function removeRequestIndicators(indicators, disabled) {
        forEach(indicators.concat(disabled), function(ele) {
            const internalData = getInternalData(ele);
            internalData.requestCount = (internalData.requestCount || 1) - 1;
        });
        forEach(indicators, function(ic) {
            const internalData = getInternalData(ic);
            if (internalData.requestCount === 0) ic.classList.remove.call(ic.classList, htmx.config.requestClass);
        });
        forEach(disabled, function(disabledElement) {
            const internalData = getInternalData(disabledElement);
            if (internalData.requestCount === 0) {
                disabledElement.removeAttribute('disabled');
                disabledElement.removeAttribute('data-disabled-by-htmx');
            }
        });
    }
    //= ===================================================================
    // Input Value Processing
    //= ===================================================================
    /**
   * @param {Element[]} processed
   * @param {Element} elt
   * @returns {boolean}
   */ function haveSeenNode(processed, elt) {
        for(let i = 0; i < processed.length; i++){
            const node = processed[i];
            if (node.isSameNode(elt)) return true;
        }
        return false;
    }
    /**
   * @param {Element} element
   * @return {boolean}
   */ function shouldInclude(element) {
        // Cast to trick tsc, undefined values will work fine here
        const elt = /** @type {HTMLInputElement} */ element;
        if (elt.name === '' || elt.name == null || elt.disabled || closest(elt, 'fieldset[disabled]')) return false;
        // ignore "submitter" types (see jQuery src/serialize.js)
        if (elt.type === 'button' || elt.type === 'submit' || elt.tagName === 'image' || elt.tagName === 'reset' || elt.tagName === 'file') return false;
        if (elt.type === 'checkbox' || elt.type === 'radio') return elt.checked;
        return true;
    }
    /**
   * @param {string} name
   * @param {string|Array|FormDataEntryValue} value
   * @param {FormData} formData */ function addValueToFormData(name, value, formData) {
        if (name != null && value != null) {
            if (Array.isArray(value)) value.forEach(function(v) {
                formData.append(name, v);
            });
            else formData.append(name, value);
        }
    }
    /**
   * @param {string} name
   * @param {string|Array} value
   * @param {FormData} formData */ function removeValueFromFormData(name, value, formData) {
        if (name != null && value != null) {
            let values = formData.getAll(name);
            if (Array.isArray(value)) values = values.filter((v)=>value.indexOf(v) < 0);
            else values = values.filter((v)=>v !== value);
            formData.delete(name);
            forEach(values, (v)=>formData.append(name, v));
        }
    }
    /**
   * @param {Element} elt
   * @returns {string|Array}
   */ function getValueFromInput(elt) {
        if (elt instanceof HTMLSelectElement && elt.multiple) return toArray(elt.querySelectorAll('option:checked')).map(function(e) {
            return /** @type HTMLOptionElement */ e.value;
        });
        // include file inputs
        if (elt instanceof HTMLInputElement && elt.files) return toArray(elt.files);
        // @ts-ignore value will be undefined for non-input elements, which is fine
        return elt.value;
    }
    /**
   * @param {Element[]} processed
   * @param {FormData} formData
   * @param {HtmxElementValidationError[]} errors
   * @param {Element|HTMLInputElement|HTMLSelectElement|HTMLFormElement} elt
   * @param {boolean} validate
   */ function processInputValue(processed, formData, errors, elt, validate) {
        if (elt == null || haveSeenNode(processed, elt)) return;
        else processed.push(elt);
        if (shouldInclude(elt)) {
            const name = getRawAttribute(elt, 'name');
            addValueToFormData(name, getValueFromInput(elt), formData);
            if (validate) validateElement(elt, errors);
        }
        if (elt instanceof HTMLFormElement) {
            forEach(elt.elements, function(input) {
                if (processed.indexOf(input) >= 0) // The input has already been processed and added to the values, but the FormData that will be
                //  constructed right after on the form, will include it once again. So remove that input's value
                //  now to avoid duplicates
                removeValueFromFormData(input.name, getValueFromInput(input), formData);
                else processed.push(input);
                if (validate) validateElement(input, errors);
            });
            new FormData(elt).forEach(function(value, name) {
                if (value instanceof File && value.name === '') return; // ignore no-name files
                addValueToFormData(name, value, formData);
            });
        }
    }
    /**
   * @param {Element} elt
   * @param {HtmxElementValidationError[]} errors
   */ function validateElement(elt, errors) {
        const element = /** @type {HTMLElement & ElementInternals} */ elt;
        if (element.willValidate) {
            triggerEvent(element, 'htmx:validation:validate');
            if (!element.checkValidity()) {
                if (triggerEvent(element, 'htmx:validation:failed', {
                    message: element.validationMessage,
                    validity: element.validity
                }) && !errors.length && htmx.config.reportValidityOfForms) element.reportValidity();
                errors.push({
                    elt: element,
                    message: element.validationMessage,
                    validity: element.validity
                });
            }
        }
    }
    /**
   * Override values in the one FormData with those from another.
   * @param {FormData} receiver the formdata that will be mutated
   * @param {FormData} donor the formdata that will provide the overriding values
   * @returns {FormData} the {@linkcode receiver}
   */ function overrideFormData(receiver, donor) {
        for (const key of donor.keys())receiver.delete(key);
        donor.forEach(function(value, key) {
            receiver.append(key, value);
        });
        return receiver;
    }
    /**
 * @param {Element|HTMLFormElement} elt
 * @param {HttpVerb} verb
 * @returns {{errors: HtmxElementValidationError[], formData: FormData, values: Object}}
 */ function getInputValues(elt, verb) {
        /** @type Element[] */ const processed = [];
        const formData = new FormData();
        const priorityFormData = new FormData();
        /** @type HtmxElementValidationError[] */ const errors = [];
        const internalData = getInternalData(elt);
        if (internalData.lastButtonClicked && !bodyContains(internalData.lastButtonClicked)) internalData.lastButtonClicked = null;
        // only validate when form is directly submitted and novalidate or formnovalidate are not set
        // or if the element has an explicit hx-validate="true" on it
        let validate = elt instanceof HTMLFormElement && elt.noValidate !== true || getAttributeValue(elt, 'hx-validate') === 'true';
        if (internalData.lastButtonClicked) validate = validate && internalData.lastButtonClicked.formNoValidate !== true;
        // for a non-GET include the related form, which may or may not be a parent element of elt
        if (verb !== 'get') processInputValue(processed, priorityFormData, errors, getRelatedForm(elt), validate);
        // include the element itself
        processInputValue(processed, formData, errors, elt, validate);
        // if a button or submit was clicked last, include its value
        if (internalData.lastButtonClicked || elt.tagName === 'BUTTON' || elt.tagName === 'INPUT' && getRawAttribute(elt, 'type') === 'submit') {
            const button = internalData.lastButtonClicked || /** @type HTMLInputElement|HTMLButtonElement */ elt;
            const name = getRawAttribute(button, 'name');
            addValueToFormData(name, button.value, priorityFormData);
        }
        // include any explicit includes
        const includes = findAttributeTargets(elt, 'hx-include');
        forEach(includes, function(node) {
            processInputValue(processed, formData, errors, asElement(node), validate);
            // if a non-form is included, include any input values within it
            if (!matches(node, 'form')) forEach(asParentNode(node).querySelectorAll(INPUT_SELECTOR), function(descendant) {
                processInputValue(processed, formData, errors, descendant, validate);
            });
        });
        // values from a <form> take precedence, overriding the regular values
        overrideFormData(formData, priorityFormData);
        return {
            errors: errors,
            formData: formData,
            values: formDataProxy(formData)
        };
    }
    /**
   * @param {string} returnStr
   * @param {string} name
   * @param {any} realValue
   * @returns {string}
   */ function appendParam(returnStr, name, realValue) {
        if (returnStr !== '') returnStr += '&';
        if (String(realValue) === '[object Object]') realValue = JSON.stringify(realValue);
        const s = encodeURIComponent(realValue);
        returnStr += encodeURIComponent(name) + '=' + s;
        return returnStr;
    }
    /**
   * @param {FormData|Object} values
   * @returns string
   */ function urlEncode(values) {
        values = formDataFromObject(values);
        let returnStr = '';
        values.forEach(function(value, key) {
            returnStr = appendParam(returnStr, key, value);
        });
        return returnStr;
    }
    //= ===================================================================
    // Ajax
    //= ===================================================================
    /**
 * @param {Element} elt
 * @param {Element} target
 * @param {string} prompt
 * @returns {HtmxHeaderSpecification}
 */ function getHeaders(elt, target, prompt1) {
        /** @type HtmxHeaderSpecification */ const headers = {
            'HX-Request': 'true',
            'HX-Trigger': getRawAttribute(elt, 'id'),
            'HX-Trigger-Name': getRawAttribute(elt, 'name'),
            'HX-Target': getAttributeValue(target, 'id'),
            'HX-Current-URL': location.href
        };
        getValuesForElement(elt, 'hx-headers', false, headers);
        if (prompt1 !== undefined) headers['HX-Prompt'] = prompt1;
        if (getInternalData(elt).boosted) headers['HX-Boosted'] = 'true';
        return headers;
    }
    /**
 * filterValues takes an object containing form input values
 * and returns a new object that only contains keys that are
 * specified by the closest "hx-params" attribute
 * @param {FormData} inputValues
 * @param {Element} elt
 * @returns {FormData}
 */ function filterValues(inputValues, elt) {
        const paramsValue = getClosestAttributeValue(elt, 'hx-params');
        if (paramsValue) {
            if (paramsValue === 'none') return new FormData();
            else if (paramsValue === '*') return inputValues;
            else if (paramsValue.indexOf('not ') === 0) {
                forEach(paramsValue.slice(4).split(','), function(name) {
                    name = name.trim();
                    inputValues.delete(name);
                });
                return inputValues;
            } else {
                const newValues = new FormData();
                forEach(paramsValue.split(','), function(name) {
                    name = name.trim();
                    if (inputValues.has(name)) inputValues.getAll(name).forEach(function(value) {
                        newValues.append(name, value);
                    });
                });
                return newValues;
            }
        } else return inputValues;
    }
    /**
   * @param {Element} elt
   * @return {boolean}
   */ function isAnchorLink(elt) {
        return !!getRawAttribute(elt, 'href') && getRawAttribute(elt, 'href').indexOf('#') >= 0;
    }
    /**
 * @param {Element} elt
 * @param {HtmxSwapStyle} [swapInfoOverride]
 * @returns {HtmxSwapSpecification}
 */ function getSwapSpecification(elt, swapInfoOverride) {
        const swapInfo = swapInfoOverride || getClosestAttributeValue(elt, 'hx-swap');
        /** @type HtmxSwapSpecification */ const swapSpec = {
            swapStyle: getInternalData(elt).boosted ? 'innerHTML' : htmx.config.defaultSwapStyle,
            swapDelay: htmx.config.defaultSwapDelay,
            settleDelay: htmx.config.defaultSettleDelay
        };
        if (htmx.config.scrollIntoViewOnBoost && getInternalData(elt).boosted && !isAnchorLink(elt)) swapSpec.show = 'top';
        if (swapInfo) {
            const split = splitOnWhitespace(swapInfo);
            if (split.length > 0) for(let i = 0; i < split.length; i++){
                const value = split[i];
                if (value.indexOf('swap:') === 0) swapSpec.swapDelay = parseInterval(value.slice(5));
                else if (value.indexOf('settle:') === 0) swapSpec.settleDelay = parseInterval(value.slice(7));
                else if (value.indexOf('transition:') === 0) swapSpec.transition = value.slice(11) === 'true';
                else if (value.indexOf('ignoreTitle:') === 0) swapSpec.ignoreTitle = value.slice(12) === 'true';
                else if (value.indexOf('scroll:') === 0) {
                    const scrollSpec = value.slice(7);
                    var splitSpec = scrollSpec.split(':');
                    const scrollVal = splitSpec.pop();
                    var selectorVal = splitSpec.length > 0 ? splitSpec.join(':') : null;
                    // @ts-ignore
                    swapSpec.scroll = scrollVal;
                    swapSpec.scrollTarget = selectorVal;
                } else if (value.indexOf('show:') === 0) {
                    const showSpec = value.slice(5);
                    var splitSpec = showSpec.split(':');
                    const showVal = splitSpec.pop();
                    var selectorVal = splitSpec.length > 0 ? splitSpec.join(':') : null;
                    swapSpec.show = showVal;
                    swapSpec.showTarget = selectorVal;
                } else if (value.indexOf('focus-scroll:') === 0) {
                    const focusScrollVal = value.slice(13);
                    swapSpec.focusScroll = focusScrollVal == 'true';
                } else if (i == 0) swapSpec.swapStyle = value;
                else logError('Unknown modifier in hx-swap: ' + value);
            }
        }
        return swapSpec;
    }
    /**
   * @param {Element} elt
   * @return {boolean}
   */ function usesFormData(elt) {
        return getClosestAttributeValue(elt, 'hx-encoding') === 'multipart/form-data' || matches(elt, 'form') && getRawAttribute(elt, 'enctype') === 'multipart/form-data';
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {Element} elt
   * @param {FormData} filteredParameters
   * @returns {*|string|null}
   */ function encodeParamsForBody(xhr, elt, filteredParameters) {
        let encodedParameters = null;
        withExtensions(elt, function(extension) {
            if (encodedParameters == null) encodedParameters = extension.encodeParameters(xhr, filteredParameters, elt);
        });
        if (encodedParameters != null) return encodedParameters;
        else {
            if (usesFormData(elt)) // Force conversion to an actual FormData object in case filteredParameters is a formDataProxy
            // See https://github.com/bigskysoftware/htmx/issues/2317
            return overrideFormData(new FormData(), formDataFromObject(filteredParameters));
            else return urlEncode(filteredParameters);
        }
    }
    /**
 *
 * @param {Element} target
 * @returns {HtmxSettleInfo}
 */ function makeSettleInfo(target) {
        return {
            tasks: [],
            elts: [
                target
            ]
        };
    }
    /**
   * @param {Element[]} content
   * @param {HtmxSwapSpecification} swapSpec
   */ function updateScrollState(content, swapSpec) {
        const first = content[0];
        const last = content[content.length - 1];
        if (swapSpec.scroll) {
            var target = null;
            if (swapSpec.scrollTarget) target = asElement(querySelectorExt(first, swapSpec.scrollTarget));
            if (swapSpec.scroll === 'top' && (first || target)) {
                target = target || first;
                target.scrollTop = 0;
            }
            if (swapSpec.scroll === 'bottom' && (last || target)) {
                target = target || last;
                target.scrollTop = target.scrollHeight;
            }
            if (typeof swapSpec.scroll === 'number') getWindow().setTimeout(function() {
                window.scrollTo(0, /** @type number */ swapSpec.scroll);
            }, 0) // next 'tick', so browser has time to render layout
            ;
        }
        if (swapSpec.show) {
            var target = null;
            if (swapSpec.showTarget) {
                let targetStr = swapSpec.showTarget;
                if (swapSpec.showTarget === 'window') targetStr = 'body';
                target = asElement(querySelectorExt(first, targetStr));
            }
            if (swapSpec.show === 'top' && (first || target)) {
                target = target || first;
                // @ts-ignore For some reason tsc doesn't recognize "instant" as a valid option for now
                target.scrollIntoView({
                    block: 'start',
                    behavior: htmx.config.scrollBehavior
                });
            }
            if (swapSpec.show === 'bottom' && (last || target)) {
                target = target || last;
                // @ts-ignore For some reason tsc doesn't recognize "instant" as a valid option for now
                target.scrollIntoView({
                    block: 'end',
                    behavior: htmx.config.scrollBehavior
                });
            }
        }
    }
    /**
 * @param {Element} elt
 * @param {string} attr
 * @param {boolean=} evalAsDefault
 * @param {Object=} values
 * @param {Event=} event
 * @returns {Object}
 */ function getValuesForElement(elt, attr, evalAsDefault, values, event) {
        if (values == null) values = {};
        if (elt == null) return values;
        const attributeValue = getAttributeValue(elt, attr);
        if (attributeValue) {
            let str = attributeValue.trim();
            let evaluateValue = evalAsDefault;
            if (str === 'unset') return null;
            if (str.indexOf('javascript:') === 0) {
                str = str.slice(11);
                evaluateValue = true;
            } else if (str.indexOf('js:') === 0) {
                str = str.slice(3);
                evaluateValue = true;
            }
            if (str.indexOf('{') !== 0) str = '{' + str + '}';
            let varsValues;
            if (evaluateValue) varsValues = maybeEval(elt, function() {
                if (event) return Function('event', 'return (' + str + ')').call(elt, event);
                else return Function('return (' + str + ')').call(elt);
            }, {});
            else varsValues = parseJSON(str);
            for(const key in varsValues){
                if (varsValues.hasOwnProperty(key)) {
                    if (values[key] == null) values[key] = varsValues[key];
                }
            }
        }
        return getValuesForElement(asElement(parentElt(elt)), attr, evalAsDefault, values, event);
    }
    /**
   * @param {EventTarget|string} elt
   * @param {() => any} toEval
   * @param {any=} defaultVal
   * @returns {any}
   */ function maybeEval(elt, toEval, defaultVal) {
        if (htmx.config.allowEval) return toEval();
        else {
            triggerErrorEvent(elt, 'htmx:evalDisallowedError');
            return defaultVal;
        }
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @param {*?=} expressionVars
 * @returns
 */ function getHXVarsForElement(elt, event, expressionVars) {
        return getValuesForElement(elt, 'hx-vars', true, expressionVars, event);
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @param {*?=} expressionVars
 * @returns
 */ function getHXValsForElement(elt, event, expressionVars) {
        return getValuesForElement(elt, 'hx-vals', false, expressionVars, event);
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @returns {FormData}
 */ function getExpressionVars(elt, event) {
        return mergeObjects(getHXVarsForElement(elt, event), getHXValsForElement(elt, event));
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {string} header
   * @param {string|null} headerValue
   */ function safelySetHeaderValue(xhr, header, headerValue) {
        if (headerValue !== null) try {
            xhr.setRequestHeader(header, headerValue);
        } catch (e) {
            // On an exception, try to set the header URI encoded instead
            xhr.setRequestHeader(header, encodeURIComponent(headerValue));
            xhr.setRequestHeader(header + '-URI-AutoEncoded', 'true');
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @return {string}
   */ function getPathFromResponse(xhr) {
        if (xhr.responseURL) try {
            const url = new URL(xhr.responseURL);
            return url.pathname + url.search;
        } catch (e) {
            triggerErrorEvent(getDocument().body, 'htmx:badResponseUrl', {
                url: xhr.responseURL
            });
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {RegExp} regexp
   * @return {boolean}
   */ function hasHeader(xhr, regexp) {
        return regexp.test(xhr.getAllResponseHeaders());
    }
    /**
   * Issues an htmx-style AJAX request
   *
   * @see https://htmx.org/api/#ajax
   *
   * @param {HttpVerb} verb
   * @param {string} path the URL path to make the AJAX
   * @param {Element|string|HtmxAjaxHelperContext} context the element to target (defaults to the **body**) | a selector for the target | a context object that contains any of the following
   * @return {Promise<void>} Promise that resolves immediately if no request is sent, or when the request is complete
   */ function ajaxHelper(verb, path, context) {
        verb = /** @type HttpVerb */ verb.toLowerCase();
        if (context) {
            if (context instanceof Element || typeof context === 'string') return issueAjaxRequest(verb, path, null, null, {
                targetOverride: resolveTarget(context) || DUMMY_ELT,
                returnPromise: true
            });
            else {
                let resolvedTarget = resolveTarget(context.target);
                // If target is supplied but can't resolve OR source is supplied but both target and source can't be resolved
                // then use DUMMY_ELT to abort the request with htmx:targetError to avoid it replacing body by mistake
                if (context.target && !resolvedTarget || context.source && !resolvedTarget && !resolveTarget(context.source)) resolvedTarget = DUMMY_ELT;
                return issueAjaxRequest(verb, path, resolveTarget(context.source), context.event, {
                    handler: context.handler,
                    headers: context.headers,
                    values: context.values,
                    targetOverride: resolvedTarget,
                    swapOverride: context.swap,
                    select: context.select,
                    returnPromise: true,
                    push: context.push,
                    replace: context.replace,
                    selectOOB: context.selectOOB
                });
            }
        } else return issueAjaxRequest(verb, path, null, null, {
            returnPromise: true
        });
    }
    /**
   * @param {Element} elt
   * @return {Element[]}
   */ function hierarchyForElt(elt) {
        const arr = [];
        while(elt){
            arr.push(elt);
            elt = elt.parentElement;
        }
        return arr;
    }
    /**
   * @param {Element} elt
   * @param {string} path
   * @param {HtmxRequestConfig} requestConfig
   * @return {boolean}
   */ function verifyPath(elt, path, requestConfig) {
        const url = new URL(path, location.protocol !== 'about:' ? location.href : window.origin);
        const origin = location.protocol !== 'about:' ? location.origin : window.origin;
        const sameHost = origin === url.origin;
        if (htmx.config.selfRequestsOnly) {
            if (!sameHost) return false;
        }
        return triggerEvent(elt, 'htmx:validateUrl', mergeObjects({
            url: url,
            sameHost: sameHost
        }, requestConfig));
    }
    /**
   * @param {Object|FormData} obj
   * @return {FormData}
   */ function formDataFromObject(obj) {
        if (obj instanceof FormData) return obj;
        const formData = new FormData();
        for(const key in obj)if (obj.hasOwnProperty(key)) {
            if (obj[key] && typeof obj[key].forEach === 'function') obj[key].forEach(function(v) {
                formData.append(key, v);
            });
            else if (typeof obj[key] === 'object' && !(obj[key] instanceof Blob)) formData.append(key, JSON.stringify(obj[key]));
            else formData.append(key, obj[key]);
        }
        return formData;
    }
    /**
   * @param {FormData} formData
   * @param {string} name
   * @param {Array} array
   * @returns {Array}
   */ function formDataArrayProxy(formData, name, array) {
        // mutating the array should mutate the underlying form data
        return new Proxy(array, {
            get: function(target, key) {
                if (typeof key === 'number') return target[key];
                if (key === 'length') return target.length;
                if (key === 'push') return function(value) {
                    target.push(value);
                    formData.append(name, value);
                };
                if (typeof target[key] === 'function') return function() {
                    target[key].apply(target, arguments);
                    formData.delete(name);
                    target.forEach(function(v) {
                        formData.append(name, v);
                    });
                };
                if (target[key] && target[key].length === 1) return target[key][0];
                else return target[key];
            },
            set: function(target, index, value) {
                target[index] = value;
                formData.delete(name);
                target.forEach(function(v) {
                    formData.append(name, v);
                });
                return true;
            }
        });
    }
    /**
   * @param {FormData} formData
   * @returns {Object}
   */ function formDataProxy(formData) {
        return new Proxy(formData, {
            get: function(target, name) {
                if (typeof name === 'symbol') {
                    // Forward symbol calls to the FormData itself directly
                    const result = Reflect.get(target, name);
                    // Wrap in function with apply to correctly bind the FormData context, as a direct call would result in an illegal invocation error
                    if (typeof result === 'function') return function() {
                        return result.apply(formData, arguments);
                    };
                    else return result;
                }
                if (name === 'toJSON') // Support JSON.stringify call on proxy
                return ()=>Object.fromEntries(formData);
                if (name in target) {
                    // Wrap in function with apply to correctly bind the FormData context, as a direct call would result in an illegal invocation error
                    if (typeof target[name] === 'function') return function() {
                        return formData[name].apply(formData, arguments);
                    };
                }
                const array = formData.getAll(name);
                // Those 2 undefined & single value returns are for retro-compatibility as we weren't using FormData before
                if (array.length === 0) return undefined;
                else if (array.length === 1) return array[0];
                else return formDataArrayProxy(target, name, array);
            },
            set: function(target, name, value) {
                if (typeof name !== 'string') return false;
                target.delete(name);
                if (value && typeof value.forEach === 'function') value.forEach(function(v) {
                    target.append(name, v);
                });
                else if (typeof value === 'object' && !(value instanceof Blob)) target.append(name, JSON.stringify(value));
                else target.append(name, value);
                return true;
            },
            deleteProperty: function(target, name) {
                if (typeof name === 'string') target.delete(name);
                return true;
            },
            // Support Object.assign call from proxy
            ownKeys: function(target) {
                return Reflect.ownKeys(Object.fromEntries(target));
            },
            getOwnPropertyDescriptor: function(target, prop) {
                return Reflect.getOwnPropertyDescriptor(Object.fromEntries(target), prop);
            }
        });
    }
    /**
   * @param {HttpVerb} verb
   * @param {string} path
   * @param {Element} elt
   * @param {Event} event
   * @param {HtmxAjaxEtc} [etc]
   * @param {boolean} [confirmed]
   * @return {Promise<void>}
   */ function issueAjaxRequest(verb, path, elt, event, etc, confirmed) {
        let resolve = null;
        let reject = null;
        etc = etc != null ? etc : {};
        if (etc.returnPromise && typeof Promise !== 'undefined') var promise = new Promise(function(_resolve, _reject) {
            resolve = _resolve;
            reject = _reject;
        });
        if (elt == null) elt = getDocument().body;
        const responseHandler = etc.handler || handleAjaxResponse;
        const select = etc.select || null;
        if (!bodyContains(elt)) {
            // do not issue requests for elements removed from the DOM
            maybeCall(resolve);
            return promise;
        }
        const target = etc.targetOverride || asElement(getTarget(elt));
        if (target == null || target == DUMMY_ELT) {
            triggerErrorEvent(elt, 'htmx:targetError', {
                target: getClosestAttributeValue(elt, 'hx-target')
            });
            maybeCall(reject);
            return promise;
        }
        let eltData = getInternalData(elt);
        const submitter = eltData.lastButtonClicked;
        if (submitter) {
            const buttonPath = getRawAttribute(submitter, 'formaction');
            if (buttonPath != null) path = buttonPath;
            const buttonVerb = getRawAttribute(submitter, 'formmethod');
            if (buttonVerb != null) {
                if (VERBS.includes(buttonVerb.toLowerCase())) verb = /** @type HttpVerb */ buttonVerb;
                else {
                    maybeCall(resolve);
                    return promise;
                }
            }
        }
        const confirmQuestion = getClosestAttributeValue(elt, 'hx-confirm');
        // allow event-based confirmation w/ a callback
        if (confirmed === undefined) {
            const issueRequest = function(skipConfirmation) {
                return issueAjaxRequest(verb, path, elt, event, etc, !!skipConfirmation);
            };
            const confirmDetails = {
                target: target,
                elt: elt,
                path: path,
                verb: verb,
                triggeringEvent: event,
                etc: etc,
                issueRequest: issueRequest,
                question: confirmQuestion
            };
            if (triggerEvent(elt, 'htmx:confirm', confirmDetails) === false) {
                maybeCall(resolve);
                return promise;
            }
        }
        let syncElt = elt;
        let syncStrategy = getClosestAttributeValue(elt, 'hx-sync');
        let queueStrategy = null;
        let abortable = false;
        if (syncStrategy) {
            const syncStrings = syncStrategy.split(':');
            const selector = syncStrings[0].trim();
            if (selector === 'this') syncElt = findThisElement(elt, 'hx-sync');
            else syncElt = asElement(querySelectorExt(elt, selector));
            // default to the drop strategy
            syncStrategy = (syncStrings[1] || 'drop').trim();
            eltData = getInternalData(syncElt);
            if (syncStrategy === 'drop' && eltData.xhr && eltData.abortable !== true) {
                maybeCall(resolve);
                return promise;
            } else if (syncStrategy === 'abort') {
                if (eltData.xhr) {
                    maybeCall(resolve);
                    return promise;
                } else abortable = true;
            } else if (syncStrategy === 'replace') triggerEvent(syncElt, 'htmx:abort') // abort the current request and continue
            ;
            else if (syncStrategy.indexOf('queue') === 0) {
                const queueStrArray = syncStrategy.split(' ');
                queueStrategy = (queueStrArray[1] || 'last').trim();
            }
        }
        if (eltData.xhr) {
            if (eltData.abortable) triggerEvent(syncElt, 'htmx:abort') // abort the current request and continue
            ;
            else {
                if (queueStrategy == null) {
                    if (event) {
                        const eventData = getInternalData(event);
                        if (eventData && eventData.triggerSpec && eventData.triggerSpec.queue) queueStrategy = eventData.triggerSpec.queue;
                    }
                    if (queueStrategy == null) queueStrategy = 'last';
                }
                if (eltData.queuedRequests == null) eltData.queuedRequests = [];
                if (queueStrategy === 'first' && eltData.queuedRequests.length === 0) eltData.queuedRequests.push(function() {
                    issueAjaxRequest(verb, path, elt, event, etc);
                });
                else if (queueStrategy === 'all') eltData.queuedRequests.push(function() {
                    issueAjaxRequest(verb, path, elt, event, etc);
                });
                else if (queueStrategy === 'last') {
                    eltData.queuedRequests = [] // dump existing queue
                    ;
                    eltData.queuedRequests.push(function() {
                        issueAjaxRequest(verb, path, elt, event, etc);
                    });
                }
                maybeCall(resolve);
                return promise;
            }
        }
        const xhr = new XMLHttpRequest();
        eltData.xhr = xhr;
        eltData.abortable = abortable;
        const endRequestLock = function() {
            eltData.xhr = null;
            eltData.abortable = false;
            if (eltData.queuedRequests != null && eltData.queuedRequests.length > 0) {
                const queuedRequest = eltData.queuedRequests.shift();
                queuedRequest();
            }
        };
        const promptQuestion = getClosestAttributeValue(elt, 'hx-prompt');
        if (promptQuestion) {
            var promptResponse = prompt(promptQuestion);
            // prompt returns null if cancelled and empty string if accepted with no entry
            if (promptResponse === null || !triggerEvent(elt, 'htmx:prompt', {
                prompt: promptResponse,
                target: target
            })) {
                maybeCall(resolve);
                endRequestLock();
                return promise;
            }
        }
        if (confirmQuestion && !confirmed) {
            if (!confirm(confirmQuestion)) {
                maybeCall(resolve);
                endRequestLock();
                return promise;
            }
        }
        let headers = getHeaders(elt, target, promptResponse);
        if (verb !== 'get' && !usesFormData(elt)) headers['Content-Type'] = 'application/x-www-form-urlencoded';
        if (etc.headers) headers = mergeObjects(headers, etc.headers);
        const results = getInputValues(elt, verb);
        let errors = results.errors;
        const rawFormData = results.formData;
        if (etc.values) overrideFormData(rawFormData, formDataFromObject(etc.values));
        const expressionVars = formDataFromObject(getExpressionVars(elt, event));
        const allFormData = overrideFormData(rawFormData, expressionVars);
        let filteredFormData = filterValues(allFormData, elt);
        if (htmx.config.getCacheBusterParam && verb === 'get') filteredFormData.set('org.htmx.cache-buster', getRawAttribute(target, 'id') || 'true');
        // behavior of anchors w/ empty href is to use the current URL
        if (path == null || path === '') path = location.href;
        /**
     * @type {Object}
     * @property {boolean} [credentials]
     * @property {number} [timeout]
     * @property {boolean} [noHeaders]
     */ const requestAttrValues = getValuesForElement(elt, 'hx-request');
        const eltIsBoosted = getInternalData(elt).boosted;
        let useUrlParams = htmx.config.methodsThatUseUrlParams.indexOf(verb) >= 0;
        /** @type HtmxRequestConfig */ const requestConfig = {
            boosted: eltIsBoosted,
            useUrlParams: useUrlParams,
            formData: filteredFormData,
            parameters: formDataProxy(filteredFormData),
            unfilteredFormData: allFormData,
            unfilteredParameters: formDataProxy(allFormData),
            headers: headers,
            elt: elt,
            target: target,
            verb: verb,
            errors: errors,
            withCredentials: etc.credentials || requestAttrValues.credentials || htmx.config.withCredentials,
            timeout: etc.timeout || requestAttrValues.timeout || htmx.config.timeout,
            path: path,
            triggeringEvent: event
        };
        if (!triggerEvent(elt, 'htmx:configRequest', requestConfig)) {
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        // copy out in case the object was overwritten
        path = requestConfig.path;
        verb = requestConfig.verb;
        headers = requestConfig.headers;
        filteredFormData = formDataFromObject(requestConfig.parameters);
        errors = requestConfig.errors;
        useUrlParams = requestConfig.useUrlParams;
        if (errors && errors.length > 0) {
            triggerEvent(elt, 'htmx:validation:halted', requestConfig);
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        const splitPath = path.split('#');
        const pathNoAnchor = splitPath[0];
        const anchor = splitPath[1];
        let finalPath = path;
        if (useUrlParams) {
            finalPath = pathNoAnchor;
            const hasValues = !filteredFormData.keys().next().done;
            if (hasValues) {
                if (finalPath.indexOf('?') < 0) finalPath += '?';
                else finalPath += '&';
                finalPath += urlEncode(filteredFormData);
                if (anchor) finalPath += '#' + anchor;
            }
        }
        if (!verifyPath(elt, finalPath, requestConfig)) {
            triggerErrorEvent(elt, 'htmx:invalidPath', requestConfig);
            maybeCall(reject);
            endRequestLock();
            return promise;
        }
        xhr.open(verb.toUpperCase(), finalPath, true);
        xhr.overrideMimeType('text/html');
        xhr.withCredentials = requestConfig.withCredentials;
        xhr.timeout = requestConfig.timeout;
        // request headers
        if (requestAttrValues.noHeaders) ;
        else {
            for(const header in headers)if (headers.hasOwnProperty(header)) {
                const headerValue = headers[header];
                safelySetHeaderValue(xhr, header, headerValue);
            }
        }
        /** @type {HtmxResponseInfo} */ const responseInfo = {
            xhr: xhr,
            target: target,
            requestConfig: requestConfig,
            etc: etc,
            boosted: eltIsBoosted,
            select: select,
            pathInfo: {
                requestPath: path,
                finalRequestPath: finalPath,
                responsePath: null,
                anchor: anchor
            }
        };
        xhr.onload = function() {
            try {
                const hierarchy = hierarchyForElt(elt);
                responseInfo.pathInfo.responsePath = getPathFromResponse(xhr);
                responseHandler(elt, responseInfo);
                if (responseInfo.keepIndicators !== true) removeRequestIndicators(indicators, disableElts);
                triggerEvent(elt, 'htmx:afterRequest', responseInfo);
                triggerEvent(elt, 'htmx:afterOnLoad', responseInfo);
                // if the body no longer contains the element, trigger the event on the closest parent
                // remaining in the DOM
                if (!bodyContains(elt)) {
                    let secondaryTriggerElt = null;
                    while(hierarchy.length > 0 && secondaryTriggerElt == null){
                        const parentEltInHierarchy = hierarchy.shift();
                        if (bodyContains(parentEltInHierarchy)) secondaryTriggerElt = parentEltInHierarchy;
                    }
                    if (secondaryTriggerElt) {
                        triggerEvent(secondaryTriggerElt, 'htmx:afterRequest', responseInfo);
                        triggerEvent(secondaryTriggerElt, 'htmx:afterOnLoad', responseInfo);
                    }
                }
                maybeCall(resolve);
            } catch (e) {
                triggerErrorEvent(elt, 'htmx:onLoadError', mergeObjects({
                    error: e
                }, responseInfo));
                throw e;
            } finally{
                endRequestLock();
            }
        };
        xhr.onerror = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:sendError', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        xhr.onabort = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:sendAbort', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        xhr.ontimeout = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:timeout', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        if (!triggerEvent(elt, 'htmx:beforeRequest', responseInfo)) {
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        var indicators = addRequestIndicatorClasses(elt);
        var disableElts = disableElements(elt);
        forEach([
            'loadstart',
            'loadend',
            'progress',
            'abort'
        ], function(eventName) {
            forEach([
                xhr,
                xhr.upload
            ], function(target) {
                target.addEventListener(eventName, function(event) {
                    triggerEvent(elt, 'htmx:xhr:' + eventName, {
                        lengthComputable: event.lengthComputable,
                        loaded: event.loaded,
                        total: event.total
                    });
                });
            });
        });
        triggerEvent(elt, 'htmx:beforeSend', responseInfo);
        const params = useUrlParams ? null : encodeParamsForBody(xhr, elt, filteredFormData);
        xhr.send(params);
        return promise;
    }
    /**
   * @typedef {Object} HtmxHistoryUpdate
   * @property {string|null} [type]
   * @property {string|null} [path]
   */ /**
   * @param {Element} elt
   * @param {HtmxResponseInfo} responseInfo
   * @return {HtmxHistoryUpdate}
   */ function determineHistoryUpdates(elt, responseInfo) {
        const xhr = responseInfo.xhr;
        //= ==========================================
        // First consult response headers
        //= ==========================================
        let pathFromHeaders = null;
        let typeFromHeaders = null;
        if (hasHeader(xhr, /HX-Push:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Push');
            typeFromHeaders = 'push';
        } else if (hasHeader(xhr, /HX-Push-Url:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Push-Url');
            typeFromHeaders = 'push';
        } else if (hasHeader(xhr, /HX-Replace-Url:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Replace-Url');
            typeFromHeaders = 'replace';
        }
        // if there was a response header, that has priority
        if (pathFromHeaders) {
            if (pathFromHeaders === 'false') return {};
            else return {
                type: typeFromHeaders,
                path: pathFromHeaders
            };
        }
        //= ==========================================
        // Next resolve via DOM values
        //= ==========================================
        const requestPath = responseInfo.pathInfo.finalRequestPath;
        const responsePath = responseInfo.pathInfo.responsePath;
        const pushUrl = responseInfo.etc.push || getClosestAttributeValue(elt, 'hx-push-url');
        const replaceUrl = responseInfo.etc.replace || getClosestAttributeValue(elt, 'hx-replace-url');
        const elementIsBoosted = getInternalData(elt).boosted;
        let saveType = null;
        let path = null;
        if (pushUrl) {
            saveType = 'push';
            path = pushUrl;
        } else if (replaceUrl) {
            saveType = 'replace';
            path = replaceUrl;
        } else if (elementIsBoosted) {
            saveType = 'push';
            path = responsePath || requestPath // if there is no response path, go with the original request path
            ;
        }
        if (path) {
            // false indicates no push, return empty object
            if (path === 'false') return {};
            // true indicates we want to follow wherever the server ended up sending us
            if (path === 'true') path = responsePath || requestPath // if there is no response path, go with the original request path
            ;
            // restore any anchor associated with the request
            if (responseInfo.pathInfo.anchor && path.indexOf('#') === -1) path = path + '#' + responseInfo.pathInfo.anchor;
            return {
                type: saveType,
                path: path
            };
        } else return {};
    }
    /**
   * @param {HtmxResponseHandlingConfig} responseHandlingConfig
   * @param {number} status
   * @return {boolean}
   */ function codeMatches(responseHandlingConfig, status) {
        var regExp = new RegExp(responseHandlingConfig.code);
        return regExp.test(status.toString(10));
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @return {HtmxResponseHandlingConfig}
   */ function resolveResponseHandling(xhr) {
        for(var i = 0; i < htmx.config.responseHandling.length; i++){
            /** @type HtmxResponseHandlingConfig */ var responseHandlingElement = htmx.config.responseHandling[i];
            if (codeMatches(responseHandlingElement, xhr.status)) return responseHandlingElement;
        }
        // no matches, return no swap
        return {
            swap: false
        };
    }
    /**
   * @param {string} title
   */ function handleTitle(title) {
        if (title) {
            const titleElt = find('title');
            if (titleElt) titleElt.textContent = title;
            else window.document.title = title;
        }
    }
    /**
   * Resove the Retarget selector and throw if not found
   * @param {Element} elt
   * @param {String} target
   * @returns {Element}
   */ function resolveRetarget(elt, target) {
        if (target === 'this') return elt;
        const resolvedTarget = asElement(querySelectorExt(elt, target));
        if (resolvedTarget == null) {
            triggerErrorEvent(elt, 'htmx:targetError', {
                target: target
            });
            throw new Error(`Invalid re-target ${target}`);
        }
        return resolvedTarget;
    }
    /**
   * @param {Element} elt
   * @param {HtmxResponseInfo} responseInfo
   */ function handleAjaxResponse(elt, responseInfo) {
        const xhr = responseInfo.xhr;
        let target = responseInfo.target;
        const etc = responseInfo.etc;
        const responseInfoSelect = responseInfo.select;
        if (!triggerEvent(elt, 'htmx:beforeOnLoad', responseInfo)) return;
        if (hasHeader(xhr, /HX-Trigger:/i)) handleTriggerHeader(xhr, 'HX-Trigger', elt);
        if (hasHeader(xhr, /HX-Location:/i)) {
            let redirectPath = xhr.getResponseHeader('HX-Location');
            /** @type {HtmxAjaxHelperContext&{path?:string}} */ var redirectSwapSpec = {};
            if (redirectPath.indexOf('{') === 0) {
                redirectSwapSpec = parseJSON(redirectPath);
                // what's the best way to throw an error if the user didn't include this
                redirectPath = redirectSwapSpec.path;
                delete redirectSwapSpec.path;
            }
            redirectSwapSpec.push = redirectSwapSpec.push || 'true';
            ajaxHelper('get', redirectPath, redirectSwapSpec);
            return;
        }
        const shouldRefresh = hasHeader(xhr, /HX-Refresh:/i) && xhr.getResponseHeader('HX-Refresh') === 'true';
        if (hasHeader(xhr, /HX-Redirect:/i)) {
            responseInfo.keepIndicators = true;
            htmx.location.href = xhr.getResponseHeader('HX-Redirect');
            shouldRefresh && htmx.location.reload();
            return;
        }
        if (shouldRefresh) {
            responseInfo.keepIndicators = true;
            htmx.location.reload();
            return;
        }
        const historyUpdate = determineHistoryUpdates(elt, responseInfo);
        const responseHandling = resolveResponseHandling(xhr);
        const shouldSwap = responseHandling.swap;
        let isError = !!responseHandling.error;
        let ignoreTitle = htmx.config.ignoreTitle || responseHandling.ignoreTitle;
        let selectOverride = responseHandling.select;
        if (responseHandling.target) responseInfo.target = resolveRetarget(elt, responseHandling.target);
        var swapOverride = etc.swapOverride;
        if (swapOverride == null && responseHandling.swapOverride) swapOverride = responseHandling.swapOverride;
        // response headers override response handling config
        if (hasHeader(xhr, /HX-Retarget:/i)) responseInfo.target = resolveRetarget(elt, xhr.getResponseHeader('HX-Retarget'));
        if (hasHeader(xhr, /HX-Reswap:/i)) swapOverride = xhr.getResponseHeader('HX-Reswap');
        var serverResponse = xhr.response;
        /** @type HtmxBeforeSwapDetails */ var beforeSwapDetails = mergeObjects({
            shouldSwap: shouldSwap,
            serverResponse: serverResponse,
            isError: isError,
            ignoreTitle: ignoreTitle,
            selectOverride: selectOverride,
            swapOverride: swapOverride
        }, responseInfo);
        if (responseHandling.event && !triggerEvent(target, responseHandling.event, beforeSwapDetails)) return;
        if (!triggerEvent(target, 'htmx:beforeSwap', beforeSwapDetails)) return;
        target = beforeSwapDetails.target // allow re-targeting
        ;
        serverResponse = beforeSwapDetails.serverResponse // allow updating content
        ;
        isError = beforeSwapDetails.isError // allow updating error
        ;
        ignoreTitle = beforeSwapDetails.ignoreTitle // allow updating ignoring title
        ;
        selectOverride = beforeSwapDetails.selectOverride // allow updating select override
        ;
        swapOverride = beforeSwapDetails.swapOverride // allow updating swap override
        ;
        responseInfo.target = target // Make updated target available to response events
        ;
        responseInfo.failed = isError // Make failed property available to response events
        ;
        responseInfo.successful = !isError // Make successful property available to response events
        ;
        if (beforeSwapDetails.shouldSwap) {
            if (xhr.status === 286) cancelPolling(elt);
            withExtensions(elt, function(extension) {
                serverResponse = extension.transformResponse(serverResponse, xhr, elt);
            });
            // Save current page if there will be a history update
            if (historyUpdate.type) saveCurrentPageToHistory();
            var swapSpec = getSwapSpecification(elt, swapOverride);
            if (!swapSpec.hasOwnProperty('ignoreTitle')) swapSpec.ignoreTitle = ignoreTitle;
            target.classList.add(htmx.config.swappingClass);
            if (responseInfoSelect) selectOverride = responseInfoSelect;
            if (hasHeader(xhr, /HX-Reselect:/i)) selectOverride = xhr.getResponseHeader('HX-Reselect');
            const selectOOB = etc.selectOOB || getClosestAttributeValue(elt, 'hx-select-oob');
            const select = getClosestAttributeValue(elt, 'hx-select');
            swap(target, serverResponse, swapSpec, {
                select: selectOverride === 'unset' ? null : selectOverride || select,
                selectOOB: selectOOB,
                eventInfo: responseInfo,
                anchor: responseInfo.pathInfo.anchor,
                contextElement: elt,
                afterSwapCallback: function() {
                    if (hasHeader(xhr, /HX-Trigger-After-Swap:/i)) {
                        let finalElt = elt;
                        if (!bodyContains(elt)) finalElt = getDocument().body;
                        handleTriggerHeader(xhr, 'HX-Trigger-After-Swap', finalElt);
                    }
                },
                afterSettleCallback: function() {
                    if (hasHeader(xhr, /HX-Trigger-After-Settle:/i)) {
                        let finalElt = elt;
                        if (!bodyContains(elt)) finalElt = getDocument().body;
                        handleTriggerHeader(xhr, 'HX-Trigger-After-Settle', finalElt);
                    }
                },
                beforeSwapCallback: function() {
                    // if we need to save history, do so, before swapping so that relative resources have the correct base URL
                    if (historyUpdate.type) {
                        triggerEvent(getDocument().body, 'htmx:beforeHistoryUpdate', mergeObjects({
                            history: historyUpdate
                        }, responseInfo));
                        if (historyUpdate.type === 'push') {
                            pushUrlIntoHistory(historyUpdate.path);
                            triggerEvent(getDocument().body, 'htmx:pushedIntoHistory', {
                                path: historyUpdate.path
                            });
                        } else {
                            replaceUrlInHistory(historyUpdate.path);
                            triggerEvent(getDocument().body, 'htmx:replacedInHistory', {
                                path: historyUpdate.path
                            });
                        }
                    }
                }
            });
        }
        if (isError) triggerErrorEvent(elt, 'htmx:responseError', mergeObjects({
            error: 'Response Status Error Code ' + xhr.status + ' from ' + responseInfo.pathInfo.requestPath
        }, responseInfo));
    }
    //= ===================================================================
    // Extensions API
    //= ===================================================================
    /** @type {Object<string, HtmxExtension>} */ const extensions = {};
    /**
   * extensionBase defines the default functions for all extensions.
   * @returns {HtmxExtension}
   */ function extensionBase() {
        return {
            init: function(api) {
                return null;
            },
            getSelectors: function() {
                return null;
            },
            onEvent: function(name, evt) {
                return true;
            },
            transformResponse: function(text, xhr, elt) {
                return text;
            },
            isInlineSwap: function(swapStyle) {
                return false;
            },
            handleSwap: function(swapStyle, target, fragment, settleInfo) {
                return false;
            },
            encodeParameters: function(xhr, parameters, elt) {
                return null;
            }
        };
    }
    /**
   * defineExtension initializes the extension and adds it to the htmx registry
   *
   * @see https://htmx.org/api/#defineExtension
   *
   * @param {string} name the extension name
   * @param {Partial<HtmxExtension>} extension the extension definition
   */ function defineExtension(name, extension) {
        if (extension.init) extension.init(internalAPI);
        extensions[name] = mergeObjects(extensionBase(), extension);
    }
    /**
   * removeExtension removes an extension from the htmx registry
   *
   * @see https://htmx.org/api/#removeExtension
   *
   * @param {string} name
   */ function removeExtension(name) {
        delete extensions[name];
    }
    /**
   * getExtensions searches up the DOM tree to return all extensions that can be applied to a given element
   *
   * @param {Element} elt
   * @param {HtmxExtension[]=} extensionsToReturn
   * @param {string[]=} extensionsToIgnore
   * @returns {HtmxExtension[]}
   */ function getExtensions(elt, extensionsToReturn, extensionsToIgnore) {
        if (extensionsToReturn == undefined) extensionsToReturn = [];
        if (elt == undefined) return extensionsToReturn;
        if (extensionsToIgnore == undefined) extensionsToIgnore = [];
        const extensionsForElement = getAttributeValue(elt, 'hx-ext');
        if (extensionsForElement) forEach(extensionsForElement.split(','), function(extensionName) {
            extensionName = extensionName.replace(/ /g, '');
            if (extensionName.slice(0, 7) == 'ignore:') {
                extensionsToIgnore.push(extensionName.slice(7));
                return;
            }
            if (extensionsToIgnore.indexOf(extensionName) < 0) {
                const extension = extensions[extensionName];
                if (extension && extensionsToReturn.indexOf(extension) < 0) extensionsToReturn.push(extension);
            }
        });
        return getExtensions(asElement(parentElt(elt)), extensionsToReturn, extensionsToIgnore);
    }
    //= ===================================================================
    // Initialization
    //= ===================================================================
    var isReady = false;
    getDocument().addEventListener('DOMContentLoaded', function() {
        isReady = true;
    });
    /**
   * Execute a function now if DOMContentLoaded has fired, otherwise listen for it.
   *
   * This function uses isReady because there is no reliable way to ask the browser whether
   * the DOMContentLoaded event has already been fired; there's a gap between DOMContentLoaded
   * firing and readystate=complete.
   */ function ready(fn) {
        // Checking readyState here is a failsafe in case the htmx script tag entered the DOM by
        // some means other than the initial page load.
        if (isReady || getDocument().readyState === 'complete') fn();
        else getDocument().addEventListener('DOMContentLoaded', fn);
    }
    function insertIndicatorStyles() {
        if (htmx.config.includeIndicatorStyles !== false) {
            const nonceAttribute = htmx.config.inlineStyleNonce ? ` nonce="${htmx.config.inlineStyleNonce}"` : '';
            const indicator = htmx.config.indicatorClass;
            const request = htmx.config.requestClass;
            getDocument().head.insertAdjacentHTML('beforeend', `<style${nonceAttribute}>` + `.${indicator}{opacity:0;visibility: hidden} ` + `.${request} .${indicator}, .${request}.${indicator}{opacity:1;visibility: visible;transition: opacity 200ms ease-in}` + '</style>');
        }
    }
    function getMetaConfig() {
        /** @type HTMLMetaElement */ const element = getDocument().querySelector('meta[name="htmx-config"]');
        if (element) return parseJSON(element.content);
        else return null;
    }
    function mergeMetaConfig() {
        const metaConfig = getMetaConfig();
        if (metaConfig) htmx.config = mergeObjects(htmx.config, metaConfig);
    }
    // initialize the document
    ready(function() {
        mergeMetaConfig();
        insertIndicatorStyles();
        let body = getDocument().body;
        processNode(body);
        const restoredElts = getDocument().querySelectorAll("[hx-trigger='restored'],[data-hx-trigger='restored']");
        body.addEventListener('htmx:abort', function(evt) {
            const target = /** @type {CustomEvent} */ evt.detail.elt || evt.target;
            const internalData = getInternalData(target);
            if (internalData && internalData.xhr) internalData.xhr.abort();
        });
        /** @type {(ev: PopStateEvent) => any} */ const originalPopstate = window.onpopstate ? window.onpopstate.bind(window) : null;
        /** @type {(ev: PopStateEvent) => any} */ window.onpopstate = function(event) {
            if (event.state && event.state.htmx) {
                restoreHistory();
                forEach(restoredElts, function(elt) {
                    triggerEvent(elt, 'htmx:restored', {
                        document: getDocument(),
                        triggerEvent: triggerEvent
                    });
                });
            } else if (originalPopstate) originalPopstate(event);
        };
        getWindow().setTimeout(function() {
            triggerEvent(body, 'htmx:load', {}) // give ready handlers a chance to load up before firing this event
            ;
            body = null // kill reference for gc
            ;
        }, 0);
    });
    return htmx;
}();
var /** @typedef {'get'|'head'|'post'|'put'|'delete'|'connect'|'options'|'trace'|'patch'} HttpVerb */ /**
 * @typedef {Object} SwapOptions
 * @property {string} [select]
 * @property {string} [selectOOB]
 * @property {*} [eventInfo]
 * @property {string} [anchor]
 * @property {Element} [contextElement]
 * @property {swapCallback} [afterSwapCallback]
 * @property {swapCallback} [afterSettleCallback]
 * @property {swapCallback} [beforeSwapCallback]
 * @property {string} [title]
 * @property {boolean} [historyRequest]
 */ /**
 * @callback swapCallback
 */ /**
 * @typedef {'innerHTML' | 'outerHTML' | 'beforebegin' | 'afterbegin' | 'beforeend' | 'afterend' | 'delete' | 'none' | string} HtmxSwapStyle
 */ /**
 * @typedef HtmxSwapSpecification
 * @property {HtmxSwapStyle} swapStyle
 * @property {number} swapDelay
 * @property {number} settleDelay
 * @property {boolean} [transition]
 * @property {boolean} [ignoreTitle]
 * @property {string} [head]
 * @property {'top' | 'bottom' | number } [scroll]
 * @property {string} [scrollTarget]
 * @property {string} [show]
 * @property {string} [showTarget]
 * @property {boolean} [focusScroll]
 */ /**
 * @typedef {((this:Node, evt:Event) => boolean) & {source: string}} ConditionalFunction
 */ /**
 * @typedef {Object} HtmxTriggerSpecification
 * @property {string} trigger
 * @property {number} [pollInterval]
 * @property {ConditionalFunction} [eventFilter]
 * @property {boolean} [changed]
 * @property {boolean} [once]
 * @property {boolean} [consume]
 * @property {number} [delay]
 * @property {string} [from]
 * @property {string} [target]
 * @property {number} [throttle]
 * @property {string} [queue]
 * @property {string} [root]
 * @property {string} [threshold]
 */ /**
 * @typedef {{elt: Element, message: string, validity: ValidityState}} HtmxElementValidationError
 */ /**
 * @typedef {Record<string, string>} HtmxHeaderSpecification
 * @property {'true'} HX-Request
 * @property {string|null} HX-Trigger
 * @property {string|null} HX-Trigger-Name
 * @property {string|null} HX-Target
 * @property {string} HX-Current-URL
 * @property {string} [HX-Prompt]
 * @property {'true'} [HX-Boosted]
 * @property {string} [Content-Type]
 * @property {'true'} [HX-History-Restore-Request]
 */ /**
 * @typedef HtmxAjaxHelperContext
 * @property {Element|string} [source]
 * @property {Event} [event]
 * @property {HtmxAjaxHandler} [handler]
 * @property {Element|string} [target]
 * @property {HtmxSwapStyle} [swap]
 * @property {Object|FormData} [values]
 * @property {Record<string,string>} [headers]
 * @property {string} [select]
 * @property {string} [push]
 * @property {string} [replace]
 * @property {string} [selectOOB]
 */ /**
 * @typedef {Object} HtmxRequestConfig
 * @property {boolean} boosted
 * @property {boolean} useUrlParams
 * @property {FormData} formData
 * @property {Object} parameters formData proxy
 * @property {FormData} unfilteredFormData
 * @property {Object} unfilteredParameters unfilteredFormData proxy
 * @property {HtmxHeaderSpecification} headers
 * @property {Element} elt
 * @property {Element} target
 * @property {HttpVerb} verb
 * @property {HtmxElementValidationError[]} errors
 * @property {boolean} withCredentials
 * @property {number} timeout
 * @property {string} path
 * @property {Event} triggeringEvent
 */ /**
 * @typedef {Object} HtmxResponseInfo
 * @property {XMLHttpRequest} xhr
 * @property {Element} target
 * @property {HtmxRequestConfig} requestConfig
 * @property {HtmxAjaxEtc} etc
 * @property {boolean} boosted
 * @property {string} select
 * @property {{requestPath: string, finalRequestPath: string, responsePath: string|null, anchor: string}} pathInfo
 * @property {boolean} [failed]
 * @property {boolean} [successful]
 * @property {boolean} [keepIndicators]
 */ /**
 * @typedef {Object} HtmxAjaxEtc
 * @property {boolean} [returnPromise]
 * @property {HtmxAjaxHandler} [handler]
 * @property {string} [select]
 * @property {Element} [targetOverride]
 * @property {HtmxSwapStyle} [swapOverride]
 * @property {Record<string,string>} [headers]
 * @property {Object|FormData} [values]
 * @property {boolean} [credentials]
 * @property {number} [timeout]
 * @property {string} [push]
 * @property {string} [replace]
 * @property {string} [selectOOB]
 */ /**
 * @typedef {Object} HtmxResponseHandlingConfig
 * @property {string} [code]
 * @property {boolean} swap
 * @property {boolean} [error]
 * @property {boolean} [ignoreTitle]
 * @property {string} [select]
 * @property {string} [target]
 * @property {string} [swapOverride]
 * @property {string} [event]
 */ /**
 * @typedef {HtmxResponseInfo & {shouldSwap: boolean, serverResponse: any, isError: boolean, ignoreTitle: boolean, selectOverride:string, swapOverride:string}} HtmxBeforeSwapDetails
 */ /**
 * @callback HtmxAjaxHandler
 * @param {Element} elt
 * @param {HtmxResponseInfo} responseInfo
 */ /**
 * @typedef {(() => void)} HtmxSettleTask
 */ /**
 * @typedef {Object} HtmxSettleInfo
 * @property {HtmxSettleTask[]} tasks
 * @property {Element[]} elts
 * @property {string} [title]
 */ /**
 * @see https://github.com/bigskysoftware/htmx-extensions/blob/main/README.md
 * @typedef {Object} HtmxExtension
 * @property {(api: any) => void} init
 * @property {(name: string, event: CustomEvent) => boolean} onEvent
 * @property {(text: string, xhr: XMLHttpRequest, elt: Element) => string} transformResponse
 * @property {(swapStyle: HtmxSwapStyle) => boolean} isInlineSwap
 * @property {(swapStyle: HtmxSwapStyle, target: Node, fragment: Node, settleInfo: HtmxSettleInfo) => boolean|Node[]} handleSwap
 * @property {(xhr: XMLHttpRequest, parameters: FormData, elt: Node) => *|string|null} encodeParameters
 * @property {() => string[]|null} getSelectors
 */ $7c2793e944d55f2d$export$2e2bcd8739ae039 = htmx;

});


var $aES44 = parcelRequire("aES44");
// packages/persist/src/index.js
function $2c8b7f21ee529b26$export$9a6132153fba2e0(Alpine) {
    let persist = ()=>{
        let alias;
        let storage;
        try {
            storage = localStorage;
        } catch (e) {
            console.error(e);
            console.warn("Alpine: $persist is using temporary storage since localStorage is unavailable.");
            let dummy = /* @__PURE__ */ new Map();
            storage = {
                getItem: dummy.get.bind(dummy),
                setItem: dummy.set.bind(dummy)
            };
        }
        return Alpine.interceptor((initialValue, getter, setter, path, key)=>{
            let lookup = alias || `_x_${path}`;
            let initial = $2c8b7f21ee529b26$var$storageHas(lookup, storage) ? $2c8b7f21ee529b26$var$storageGet(lookup, storage) : initialValue;
            setter(initial);
            Alpine.effect(()=>{
                let value = getter();
                $2c8b7f21ee529b26$var$storageSet(lookup, value, storage);
                setter(value);
            });
            return initial;
        }, (func)=>{
            func.as = (key)=>{
                alias = key;
                return func;
            }, func.using = (target)=>{
                storage = target;
                return func;
            };
        });
    };
    Object.defineProperty(Alpine, "$persist", {
        get: ()=>persist()
    });
    Alpine.magic("persist", persist);
    Alpine.persist = (key, { get: get, set: set }, storage = localStorage)=>{
        let initial = $2c8b7f21ee529b26$var$storageHas(key, storage) ? $2c8b7f21ee529b26$var$storageGet(key, storage) : get();
        set(initial);
        Alpine.effect(()=>{
            let value = get();
            $2c8b7f21ee529b26$var$storageSet(key, value, storage);
            set(value);
        });
    };
}
function $2c8b7f21ee529b26$var$storageHas(key, storage) {
    return storage.getItem(key) !== null;
}
function $2c8b7f21ee529b26$var$storageGet(key, storage) {
    let value = storage.getItem(key);
    if (value === void 0) return;
    return JSON.parse(value);
}
function $2c8b7f21ee529b26$var$storageSet(key, value, storage) {
    storage.setItem(key, JSON.stringify(value));
}
// packages/persist/builds/module.js
var $2c8b7f21ee529b26$export$2e2bcd8739ae039 = $2c8b7f21ee529b26$export$9a6132153fba2e0;


// packages/collapse/src/index.js
function $565f2ff3230c1cc6$export$ec45920981e0ca9b(Alpine) {
    Alpine.directive("collapse", collapse);
    collapse.inline = (el, { modifiers: modifiers })=>{
        if (!modifiers.includes("min")) return;
        el._x_doShow = ()=>{};
        el._x_doHide = ()=>{};
    };
    function collapse(el, { modifiers: modifiers }) {
        let duration = $565f2ff3230c1cc6$var$modifierValue(modifiers, "duration", 250) / 1e3;
        let floor = $565f2ff3230c1cc6$var$modifierValue(modifiers, "min", 0);
        let fullyHide = !modifiers.includes("min");
        if (!el._x_isShown) el.style.height = `${floor}px`;
        if (!el._x_isShown && fullyHide) el.hidden = true;
        if (!el._x_isShown) el.style.overflow = "hidden";
        let setFunction = (el2, styles)=>{
            let revertFunction = Alpine.setStyles(el2, styles);
            return styles.height ? ()=>{} : revertFunction;
        };
        let transitionStyles = {
            transitionProperty: "height",
            transitionDuration: `${duration}s`,
            transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
        };
        el._x_transition = {
            in (before = ()=>{}, after = ()=>{}) {
                if (fullyHide) el.hidden = false;
                if (fullyHide) el.style.display = null;
                let current = el.getBoundingClientRect().height;
                el.style.height = "auto";
                let full = el.getBoundingClientRect().height;
                if (current === full) current = floor;
                Alpine.transition(el, Alpine.setStyles, {
                    during: transitionStyles,
                    start: {
                        height: current + "px"
                    },
                    end: {
                        height: full + "px"
                    }
                }, ()=>el._x_isShown = true, ()=>{
                    if (Math.abs(el.getBoundingClientRect().height - full) < 1) el.style.overflow = null;
                });
            },
            out (before = ()=>{}, after = ()=>{}) {
                let full = el.getBoundingClientRect().height;
                Alpine.transition(el, setFunction, {
                    during: transitionStyles,
                    start: {
                        height: full + "px"
                    },
                    end: {
                        height: floor + "px"
                    }
                }, ()=>el.style.overflow = "hidden", ()=>{
                    el._x_isShown = false;
                    if (el.style.height == `${floor}px` && fullyHide) {
                        el.style.display = "none";
                        el.hidden = true;
                    }
                });
            }
        };
    }
}
function $565f2ff3230c1cc6$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "duration") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "min") {
        let match = rawValue.match(/([0-9]+)px/);
        if (match) return match[1];
    }
    return rawValue;
}
// packages/collapse/builds/module.js
var $565f2ff3230c1cc6$export$2e2bcd8739ae039 = $565f2ff3230c1cc6$export$ec45920981e0ca9b;


// packages/alpinejs/src/scheduler.js
var $1995762e80cda67d$var$flushPending = false;
var $1995762e80cda67d$var$flushing = false;
var $1995762e80cda67d$var$queue = [];
var $1995762e80cda67d$var$lastFlushedIndex = -1;
function $1995762e80cda67d$var$scheduler(callback) {
    $1995762e80cda67d$var$queueJob(callback);
}
function $1995762e80cda67d$var$queueJob(job) {
    if (!$1995762e80cda67d$var$queue.includes(job)) $1995762e80cda67d$var$queue.push(job);
    $1995762e80cda67d$var$queueFlush();
}
function $1995762e80cda67d$var$dequeueJob(job) {
    let index = $1995762e80cda67d$var$queue.indexOf(job);
    if (index !== -1 && index > $1995762e80cda67d$var$lastFlushedIndex) $1995762e80cda67d$var$queue.splice(index, 1);
}
function $1995762e80cda67d$var$queueFlush() {
    if (!$1995762e80cda67d$var$flushing && !$1995762e80cda67d$var$flushPending) {
        $1995762e80cda67d$var$flushPending = true;
        queueMicrotask($1995762e80cda67d$var$flushJobs);
    }
}
function $1995762e80cda67d$var$flushJobs() {
    $1995762e80cda67d$var$flushPending = false;
    $1995762e80cda67d$var$flushing = true;
    for(let i = 0; i < $1995762e80cda67d$var$queue.length; i++){
        $1995762e80cda67d$var$queue[i]();
        $1995762e80cda67d$var$lastFlushedIndex = i;
    }
    $1995762e80cda67d$var$queue.length = 0;
    $1995762e80cda67d$var$lastFlushedIndex = -1;
    $1995762e80cda67d$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $1995762e80cda67d$var$reactive;
var $1995762e80cda67d$var$effect;
var $1995762e80cda67d$var$release;
var $1995762e80cda67d$var$raw;
var $1995762e80cda67d$var$shouldSchedule = true;
function $1995762e80cda67d$var$disableEffectScheduling(callback) {
    $1995762e80cda67d$var$shouldSchedule = false;
    callback();
    $1995762e80cda67d$var$shouldSchedule = true;
}
function $1995762e80cda67d$var$setReactivityEngine(engine) {
    $1995762e80cda67d$var$reactive = engine.reactive;
    $1995762e80cda67d$var$release = engine.release;
    $1995762e80cda67d$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($1995762e80cda67d$var$shouldSchedule) $1995762e80cda67d$var$scheduler(task);
                else task();
            }
        });
    $1995762e80cda67d$var$raw = engine.raw;
}
function $1995762e80cda67d$var$overrideEffect(override) {
    $1995762e80cda67d$var$effect = override;
}
function $1995762e80cda67d$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $1995762e80cda67d$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $1995762e80cda67d$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $1995762e80cda67d$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $1995762e80cda67d$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$1995762e80cda67d$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $1995762e80cda67d$var$onAttributeAddeds = [];
var $1995762e80cda67d$var$onElRemoveds = [];
var $1995762e80cda67d$var$onElAddeds = [];
function $1995762e80cda67d$var$onElAdded(callback) {
    $1995762e80cda67d$var$onElAddeds.push(callback);
}
function $1995762e80cda67d$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $1995762e80cda67d$var$onElRemoveds.push(callback);
    }
}
function $1995762e80cda67d$var$onAttributesAdded(callback) {
    $1995762e80cda67d$var$onAttributeAddeds.push(callback);
}
function $1995762e80cda67d$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $1995762e80cda67d$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $1995762e80cda67d$var$cleanupElement(el) {
    el._x_effects?.forEach($1995762e80cda67d$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $1995762e80cda67d$var$observer = new MutationObserver($1995762e80cda67d$var$onMutate);
var $1995762e80cda67d$var$currentlyObserving = false;
function $1995762e80cda67d$var$startObservingMutations() {
    $1995762e80cda67d$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $1995762e80cda67d$var$currentlyObserving = true;
}
function $1995762e80cda67d$var$stopObservingMutations() {
    $1995762e80cda67d$var$flushObserver();
    $1995762e80cda67d$var$observer.disconnect();
    $1995762e80cda67d$var$currentlyObserving = false;
}
var $1995762e80cda67d$var$queuedMutations = [];
function $1995762e80cda67d$var$flushObserver() {
    let records = $1995762e80cda67d$var$observer.takeRecords();
    $1995762e80cda67d$var$queuedMutations.push(()=>records.length > 0 && $1995762e80cda67d$var$onMutate(records));
    let queueLengthWhenTriggered = $1995762e80cda67d$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($1995762e80cda67d$var$queuedMutations.length === queueLengthWhenTriggered) while($1995762e80cda67d$var$queuedMutations.length > 0)$1995762e80cda67d$var$queuedMutations.shift()();
    });
}
function $1995762e80cda67d$var$mutateDom(callback) {
    if (!$1995762e80cda67d$var$currentlyObserving) return callback();
    $1995762e80cda67d$var$stopObservingMutations();
    let result = callback();
    $1995762e80cda67d$var$startObservingMutations();
    return result;
}
var $1995762e80cda67d$var$isCollecting = false;
var $1995762e80cda67d$var$deferredMutations = [];
function $1995762e80cda67d$var$deferMutations() {
    $1995762e80cda67d$var$isCollecting = true;
}
function $1995762e80cda67d$var$flushAndStopDeferringMutations() {
    $1995762e80cda67d$var$isCollecting = false;
    $1995762e80cda67d$var$onMutate($1995762e80cda67d$var$deferredMutations);
    $1995762e80cda67d$var$deferredMutations = [];
}
function $1995762e80cda67d$var$onMutate(mutations) {
    if ($1995762e80cda67d$var$isCollecting) {
        $1995762e80cda67d$var$deferredMutations = $1995762e80cda67d$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $1995762e80cda67d$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $1995762e80cda67d$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $1995762e80cda67d$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $1995762e80cda67d$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $1995762e80cda67d$var$scope(node) {
    return $1995762e80cda67d$var$mergeProxies($1995762e80cda67d$var$closestDataStack(node));
}
function $1995762e80cda67d$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$1995762e80cda67d$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $1995762e80cda67d$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $1995762e80cda67d$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $1995762e80cda67d$var$closestDataStack(node.parentNode);
}
function $1995762e80cda67d$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $1995762e80cda67d$var$mergeProxyTrap);
}
var $1995762e80cda67d$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $1995762e80cda67d$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $1995762e80cda67d$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $1995762e80cda67d$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $1995762e80cda67d$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$1995762e80cda67d$var$get(data2, path), (value)=>$1995762e80cda67d$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $1995762e80cda67d$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $1995762e80cda67d$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $1995762e80cda67d$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $1995762e80cda67d$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $1995762e80cda67d$var$magics = {};
function $1995762e80cda67d$var$magic(name, callback) {
    $1995762e80cda67d$var$magics[name] = callback;
}
function $1995762e80cda67d$var$injectMagics(obj, el) {
    let memoizedUtilities = $1995762e80cda67d$var$getUtilities(el);
    Object.entries($1995762e80cda67d$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $1995762e80cda67d$var$getUtilities(el) {
    let [utilities, cleanup2] = $1995762e80cda67d$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $1995762e80cda67d$var$interceptor,
        ...utilities
    };
    $1995762e80cda67d$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $1995762e80cda67d$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $1995762e80cda67d$var$handleError(e, el, expression);
    }
}
function $1995762e80cda67d$var$handleError(...args) {
    return $1995762e80cda67d$var$errorHandler(...args);
}
var $1995762e80cda67d$var$errorHandler = $1995762e80cda67d$var$normalErrorHandler;
function $1995762e80cda67d$var$setErrorHandler(handler4) {
    $1995762e80cda67d$var$errorHandler = handler4;
}
function $1995762e80cda67d$var$normalErrorHandler(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $1995762e80cda67d$var$shouldAutoEvaluateFunctions = true;
function $1995762e80cda67d$var$dontAutoEvaluateFunctions(callback) {
    let cache = $1995762e80cda67d$var$shouldAutoEvaluateFunctions;
    $1995762e80cda67d$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $1995762e80cda67d$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $1995762e80cda67d$var$evaluate(el, expression, extras = {}) {
    let result;
    $1995762e80cda67d$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $1995762e80cda67d$var$evaluateLater(...args) {
    return $1995762e80cda67d$var$theEvaluatorFunction(...args);
}
var $1995762e80cda67d$var$theEvaluatorFunction = $1995762e80cda67d$var$normalEvaluator;
function $1995762e80cda67d$var$setEvaluator(newEvaluator) {
    $1995762e80cda67d$var$theEvaluatorFunction = newEvaluator;
}
function $1995762e80cda67d$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $1995762e80cda67d$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$1995762e80cda67d$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $1995762e80cda67d$var$generateEvaluatorFromFunction(dataStack, expression) : $1995762e80cda67d$var$generateEvaluatorFromString(dataStack, expression, el);
    return $1995762e80cda67d$var$tryCatch.bind(null, el, expression, evaluator);
}
function $1995762e80cda67d$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        let result = func.apply($1995762e80cda67d$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $1995762e80cda67d$var$runIfTypeOfFunction(receiver, result);
    };
}
var $1995762e80cda67d$var$evaluatorMemo = {};
function $1995762e80cda67d$var$generateFunctionFromString(expression, el) {
    if ($1995762e80cda67d$var$evaluatorMemo[expression]) return $1995762e80cda67d$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $1995762e80cda67d$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $1995762e80cda67d$var$evaluatorMemo[expression] = func;
    return func;
}
function $1995762e80cda67d$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $1995762e80cda67d$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $1995762e80cda67d$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func.call(context, func, completeScope).catch((error2)=>$1995762e80cda67d$var$handleError(error2, el, expression));
            if (func.finished) {
                $1995762e80cda67d$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $1995762e80cda67d$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$1995762e80cda67d$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $1995762e80cda67d$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($1995762e80cda67d$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$1995762e80cda67d$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$1995762e80cda67d$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $1995762e80cda67d$var$prefixAsString = "x-";
function $1995762e80cda67d$var$prefix(subject = "") {
    return $1995762e80cda67d$var$prefixAsString + subject;
}
function $1995762e80cda67d$var$setPrefix(newPrefix) {
    $1995762e80cda67d$var$prefixAsString = newPrefix;
}
var $1995762e80cda67d$var$directiveHandlers = {};
function $1995762e80cda67d$var$directive(name, callback) {
    $1995762e80cda67d$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$1995762e80cda67d$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $1995762e80cda67d$var$directiveOrder.indexOf(directive2);
            $1995762e80cda67d$var$directiveOrder.splice(pos >= 0 ? pos : $1995762e80cda67d$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $1995762e80cda67d$var$directiveExists(name) {
    return Object.keys($1995762e80cda67d$var$directiveHandlers).includes(name);
}
function $1995762e80cda67d$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $1995762e80cda67d$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($1995762e80cda67d$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($1995762e80cda67d$var$outNonAlpineAttributes).map($1995762e80cda67d$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($1995762e80cda67d$var$byPriority);
    return directives2.map((directive2)=>{
        return $1995762e80cda67d$var$getDirectiveHandler(el, directive2);
    });
}
function $1995762e80cda67d$var$attributesOnly(attributes) {
    return Array.from(attributes).map($1995762e80cda67d$var$toTransformedAttributes()).filter((attr)=>!$1995762e80cda67d$var$outNonAlpineAttributes(attr));
}
var $1995762e80cda67d$var$isDeferringHandlers = false;
var $1995762e80cda67d$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $1995762e80cda67d$var$currentHandlerStackKey = Symbol();
function $1995762e80cda67d$var$deferHandlingDirectives(callback) {
    $1995762e80cda67d$var$isDeferringHandlers = true;
    let key = Symbol();
    $1995762e80cda67d$var$currentHandlerStackKey = key;
    $1995762e80cda67d$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($1995762e80cda67d$var$directiveHandlerStacks.get(key).length)$1995762e80cda67d$var$directiveHandlerStacks.get(key).shift()();
        $1995762e80cda67d$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $1995762e80cda67d$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $1995762e80cda67d$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $1995762e80cda67d$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $1995762e80cda67d$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $1995762e80cda67d$var$evaluateLater.bind($1995762e80cda67d$var$evaluateLater, el),
        evaluate: $1995762e80cda67d$var$evaluate.bind($1995762e80cda67d$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $1995762e80cda67d$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $1995762e80cda67d$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $1995762e80cda67d$var$getElementBoundUtilities(el);
    $1995762e80cda67d$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $1995762e80cda67d$var$isDeferringHandlers ? $1995762e80cda67d$var$directiveHandlerStacks.get($1995762e80cda67d$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $1995762e80cda67d$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $1995762e80cda67d$var$into = (i)=>i;
function $1995762e80cda67d$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $1995762e80cda67d$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $1995762e80cda67d$var$attributeTransformers = [];
function $1995762e80cda67d$var$mapAttributes(callback) {
    $1995762e80cda67d$var$attributeTransformers.push(callback);
}
function $1995762e80cda67d$var$outNonAlpineAttributes({ name: name }) {
    return $1995762e80cda67d$var$alpineAttributeRegex().test(name);
}
var $1995762e80cda67d$var$alpineAttributeRegex = ()=>new RegExp(`^${$1995762e80cda67d$var$prefixAsString}([^:^.]+)\\b`);
function $1995762e80cda67d$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($1995762e80cda67d$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $1995762e80cda67d$var$DEFAULT = "DEFAULT";
var $1995762e80cda67d$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $1995762e80cda67d$var$DEFAULT,
    "teleport"
];
function $1995762e80cda67d$var$byPriority(a, b) {
    let typeA = $1995762e80cda67d$var$directiveOrder.indexOf(a.type) === -1 ? $1995762e80cda67d$var$DEFAULT : a.type;
    let typeB = $1995762e80cda67d$var$directiveOrder.indexOf(b.type) === -1 ? $1995762e80cda67d$var$DEFAULT : b.type;
    return $1995762e80cda67d$var$directiveOrder.indexOf(typeA) - $1995762e80cda67d$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $1995762e80cda67d$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $1995762e80cda67d$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$1995762e80cda67d$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $1995762e80cda67d$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $1995762e80cda67d$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $1995762e80cda67d$var$started = false;
function $1995762e80cda67d$var$start() {
    if ($1995762e80cda67d$var$started) $1995762e80cda67d$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $1995762e80cda67d$var$started = true;
    if (!document.body) $1995762e80cda67d$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $1995762e80cda67d$var$dispatch(document, "alpine:init");
    $1995762e80cda67d$var$dispatch(document, "alpine:initializing");
    $1995762e80cda67d$var$startObservingMutations();
    $1995762e80cda67d$var$onElAdded((el)=>$1995762e80cda67d$var$initTree(el, $1995762e80cda67d$var$walk));
    $1995762e80cda67d$var$onElRemoved((el)=>$1995762e80cda67d$var$destroyTree(el));
    $1995762e80cda67d$var$onAttributesAdded((el, attrs)=>{
        $1995762e80cda67d$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$1995762e80cda67d$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($1995762e80cda67d$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $1995762e80cda67d$var$initTree(el);
    });
    $1995762e80cda67d$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $1995762e80cda67d$var$warnAboutMissingPlugins();
    });
}
var $1995762e80cda67d$var$rootSelectorCallbacks = [];
var $1995762e80cda67d$var$initSelectorCallbacks = [];
function $1995762e80cda67d$var$rootSelectors() {
    return $1995762e80cda67d$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $1995762e80cda67d$var$allSelectors() {
    return $1995762e80cda67d$var$rootSelectorCallbacks.concat($1995762e80cda67d$var$initSelectorCallbacks).map((fn)=>fn());
}
function $1995762e80cda67d$var$addRootSelector(selectorCallback) {
    $1995762e80cda67d$var$rootSelectorCallbacks.push(selectorCallback);
}
function $1995762e80cda67d$var$addInitSelector(selectorCallback) {
    $1995762e80cda67d$var$initSelectorCallbacks.push(selectorCallback);
}
function $1995762e80cda67d$var$closestRoot(el, includeInitSelectors = false) {
    return $1995762e80cda67d$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $1995762e80cda67d$var$allSelectors() : $1995762e80cda67d$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $1995762e80cda67d$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $1995762e80cda67d$var$findClosest(el.parentElement, callback);
}
function $1995762e80cda67d$var$isRoot(el) {
    return $1995762e80cda67d$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $1995762e80cda67d$var$initInterceptors2 = [];
function $1995762e80cda67d$var$interceptInit(callback) {
    $1995762e80cda67d$var$initInterceptors2.push(callback);
}
var $1995762e80cda67d$var$markerDispenser = 1;
function $1995762e80cda67d$var$initTree(el, walker = $1995762e80cda67d$var$walk, intercept = ()=>{}) {
    if ($1995762e80cda67d$var$findClosest(el, (i)=>i._x_ignore)) return;
    $1995762e80cda67d$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $1995762e80cda67d$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $1995762e80cda67d$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $1995762e80cda67d$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $1995762e80cda67d$var$destroyTree(root, walker = $1995762e80cda67d$var$walk) {
    walker(root, (el)=>{
        $1995762e80cda67d$var$cleanupElement(el);
        $1995762e80cda67d$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $1995762e80cda67d$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($1995762e80cda67d$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $1995762e80cda67d$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $1995762e80cda67d$var$tickStack = [];
var $1995762e80cda67d$var$isHolding = false;
function $1995762e80cda67d$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $1995762e80cda67d$var$isHolding || setTimeout(()=>{
            $1995762e80cda67d$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $1995762e80cda67d$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $1995762e80cda67d$var$releaseNextTicks() {
    $1995762e80cda67d$var$isHolding = false;
    while($1995762e80cda67d$var$tickStack.length)$1995762e80cda67d$var$tickStack.shift()();
}
function $1995762e80cda67d$var$holdNextTicks() {
    $1995762e80cda67d$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $1995762e80cda67d$var$setClasses(el, value) {
    if (Array.isArray(value)) return $1995762e80cda67d$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $1995762e80cda67d$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $1995762e80cda67d$var$setClasses(el, value());
    return $1995762e80cda67d$var$setClassesFromString(el, value);
}
function $1995762e80cda67d$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $1995762e80cda67d$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $1995762e80cda67d$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $1995762e80cda67d$var$setStylesFromObject(el, value);
    return $1995762e80cda67d$var$setStylesFromString(el, value);
}
function $1995762e80cda67d$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $1995762e80cda67d$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $1995762e80cda67d$var$setStyles(el, previousStyles);
    };
}
function $1995762e80cda67d$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $1995762e80cda67d$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $1995762e80cda67d$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$1995762e80cda67d$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $1995762e80cda67d$var$registerTransitionsFromHelper(el, modifiers, value);
    else $1995762e80cda67d$var$registerTransitionsFromClassString(el, expression, value);
});
function $1995762e80cda67d$var$registerTransitionsFromClassString(el, classString, stage) {
    $1995762e80cda67d$var$registerTransitionObject(el, $1995762e80cda67d$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $1995762e80cda67d$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $1995762e80cda67d$var$registerTransitionObject(el, $1995762e80cda67d$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $1995762e80cda67d$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $1995762e80cda67d$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $1995762e80cda67d$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $1995762e80cda67d$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $1995762e80cda67d$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $1995762e80cda67d$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $1995762e80cda67d$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $1995762e80cda67d$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $1995762e80cda67d$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $1995762e80cda67d$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $1995762e80cda67d$var$closestHide(parent);
}
function $1995762e80cda67d$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $1995762e80cda67d$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $1995762e80cda67d$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $1995762e80cda67d$var$once(()=>{
        $1995762e80cda67d$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $1995762e80cda67d$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $1995762e80cda67d$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $1995762e80cda67d$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $1995762e80cda67d$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $1995762e80cda67d$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $1995762e80cda67d$var$mutateDom(()=>{
                stages.end();
            });
            $1995762e80cda67d$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $1995762e80cda67d$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $1995762e80cda67d$var$isCloning = false;
function $1995762e80cda67d$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$1995762e80cda67d$var$isCloning ? fallback(...args) : callback(...args);
}
function $1995762e80cda67d$var$onlyDuringClone(callback) {
    return (...args)=>$1995762e80cda67d$var$isCloning && callback(...args);
}
var $1995762e80cda67d$var$interceptors = [];
function $1995762e80cda67d$var$interceptClone(callback) {
    $1995762e80cda67d$var$interceptors.push(callback);
}
function $1995762e80cda67d$var$cloneNode(from, to) {
    $1995762e80cda67d$var$interceptors.forEach((i)=>i(from, to));
    $1995762e80cda67d$var$isCloning = true;
    $1995762e80cda67d$var$dontRegisterReactiveSideEffects(()=>{
        $1995762e80cda67d$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $1995762e80cda67d$var$isCloning = false;
}
var $1995762e80cda67d$var$isCloningLegacy = false;
function $1995762e80cda67d$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $1995762e80cda67d$var$isCloning = true;
    $1995762e80cda67d$var$isCloningLegacy = true;
    $1995762e80cda67d$var$dontRegisterReactiveSideEffects(()=>{
        $1995762e80cda67d$var$cloneTree(newEl);
    });
    $1995762e80cda67d$var$isCloning = false;
    $1995762e80cda67d$var$isCloningLegacy = false;
}
function $1995762e80cda67d$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $1995762e80cda67d$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $1995762e80cda67d$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $1995762e80cda67d$var$initTree(el, shallowWalker);
}
function $1995762e80cda67d$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $1995762e80cda67d$var$effect;
    $1995762e80cda67d$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $1995762e80cda67d$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $1995762e80cda67d$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $1995762e80cda67d$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $1995762e80cda67d$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $1995762e80cda67d$var$camelCase(name) : name;
    switch(name){
        case "value":
            $1995762e80cda67d$var$bindInputValue(el, value);
            break;
        case "style":
            $1995762e80cda67d$var$bindStyles(el, value);
            break;
        case "class":
            $1995762e80cda67d$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $1995762e80cda67d$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $1995762e80cda67d$var$bindAttribute(el, name, value);
            break;
    }
}
function $1995762e80cda67d$var$bindInputValue(el, value) {
    if ($1995762e80cda67d$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $1995762e80cda67d$var$safeParseBoolean(el.value) === value;
            else el.checked = $1995762e80cda67d$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($1995762e80cda67d$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$1995762e80cda67d$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $1995762e80cda67d$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $1995762e80cda67d$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $1995762e80cda67d$var$setClasses(el, value);
}
function $1995762e80cda67d$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $1995762e80cda67d$var$setStyles(el, value);
}
function $1995762e80cda67d$var$bindAttributeAndProperty(el, name, value) {
    $1995762e80cda67d$var$bindAttribute(el, name, value);
    $1995762e80cda67d$var$setPropertyIfChanged(el, name, value);
}
function $1995762e80cda67d$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $1995762e80cda67d$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($1995762e80cda67d$var$isBooleanAttr(name)) value = name;
        $1995762e80cda67d$var$setIfChanged(el, name, value);
    }
}
function $1995762e80cda67d$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $1995762e80cda67d$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $1995762e80cda67d$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $1995762e80cda67d$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $1995762e80cda67d$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $1995762e80cda67d$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $1995762e80cda67d$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $1995762e80cda67d$var$isBooleanAttr(attrName) {
    return $1995762e80cda67d$var$booleanAttributes.has(attrName);
}
function $1995762e80cda67d$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $1995762e80cda67d$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $1995762e80cda67d$var$getAttributeBinding(el, name, fallback);
}
function $1995762e80cda67d$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $1995762e80cda67d$var$dontAutoEvaluateFunctions(()=>{
            return $1995762e80cda67d$var$evaluate(el, binding.expression);
        });
    }
    return $1995762e80cda67d$var$getAttributeBinding(el, name, fallback);
}
function $1995762e80cda67d$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($1995762e80cda67d$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $1995762e80cda67d$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $1995762e80cda67d$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $1995762e80cda67d$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $1995762e80cda67d$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $1995762e80cda67d$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $1995762e80cda67d$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($1995762e80cda67d$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($1995762e80cda67d$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($1995762e80cda67d$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $1995762e80cda67d$var$release(reference);
    };
}
function $1995762e80cda67d$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $1995762e80cda67d$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($1995762e80cda67d$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $1995762e80cda67d$var$stores = {};
var $1995762e80cda67d$var$isReactive = false;
function $1995762e80cda67d$var$store(name, value) {
    if (!$1995762e80cda67d$var$isReactive) {
        $1995762e80cda67d$var$stores = $1995762e80cda67d$var$reactive($1995762e80cda67d$var$stores);
        $1995762e80cda67d$var$isReactive = true;
    }
    if (value === void 0) return $1995762e80cda67d$var$stores[name];
    $1995762e80cda67d$var$stores[name] = value;
    $1995762e80cda67d$var$initInterceptors($1995762e80cda67d$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $1995762e80cda67d$var$stores[name].init();
}
function $1995762e80cda67d$var$getStores() {
    return $1995762e80cda67d$var$stores;
}
// packages/alpinejs/src/binds.js
var $1995762e80cda67d$var$binds = {};
function $1995762e80cda67d$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $1995762e80cda67d$var$applyBindingsObject(name, getBindings());
    else $1995762e80cda67d$var$binds[name] = getBindings;
    return ()=>{};
}
function $1995762e80cda67d$var$injectBindingProviders(obj) {
    Object.entries($1995762e80cda67d$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $1995762e80cda67d$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $1995762e80cda67d$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $1995762e80cda67d$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $1995762e80cda67d$var$datas = {};
function $1995762e80cda67d$var$data(name, callback) {
    $1995762e80cda67d$var$datas[name] = callback;
}
function $1995762e80cda67d$var$injectDataProviders(obj, context) {
    Object.entries($1995762e80cda67d$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $1995762e80cda67d$var$Alpine = {
    get reactive () {
        return $1995762e80cda67d$var$reactive;
    },
    get release () {
        return $1995762e80cda67d$var$release;
    },
    get effect () {
        return $1995762e80cda67d$var$effect;
    },
    get raw () {
        return $1995762e80cda67d$var$raw;
    },
    version: "3.15.2",
    flushAndStopDeferringMutations: $1995762e80cda67d$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $1995762e80cda67d$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $1995762e80cda67d$var$disableEffectScheduling,
    startObservingMutations: $1995762e80cda67d$var$startObservingMutations,
    stopObservingMutations: $1995762e80cda67d$var$stopObservingMutations,
    setReactivityEngine: $1995762e80cda67d$var$setReactivityEngine,
    onAttributeRemoved: $1995762e80cda67d$var$onAttributeRemoved,
    onAttributesAdded: $1995762e80cda67d$var$onAttributesAdded,
    closestDataStack: $1995762e80cda67d$var$closestDataStack,
    skipDuringClone: $1995762e80cda67d$var$skipDuringClone,
    onlyDuringClone: $1995762e80cda67d$var$onlyDuringClone,
    addRootSelector: $1995762e80cda67d$var$addRootSelector,
    addInitSelector: $1995762e80cda67d$var$addInitSelector,
    setErrorHandler: $1995762e80cda67d$var$setErrorHandler,
    interceptClone: $1995762e80cda67d$var$interceptClone,
    addScopeToNode: $1995762e80cda67d$var$addScopeToNode,
    deferMutations: $1995762e80cda67d$var$deferMutations,
    mapAttributes: $1995762e80cda67d$var$mapAttributes,
    evaluateLater: $1995762e80cda67d$var$evaluateLater,
    interceptInit: $1995762e80cda67d$var$interceptInit,
    setEvaluator: $1995762e80cda67d$var$setEvaluator,
    mergeProxies: $1995762e80cda67d$var$mergeProxies,
    extractProp: $1995762e80cda67d$var$extractProp,
    findClosest: $1995762e80cda67d$var$findClosest,
    onElRemoved: $1995762e80cda67d$var$onElRemoved,
    closestRoot: $1995762e80cda67d$var$closestRoot,
    destroyTree: $1995762e80cda67d$var$destroyTree,
    interceptor: $1995762e80cda67d$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $1995762e80cda67d$var$transition,
    setStyles: // INTERNAL
    $1995762e80cda67d$var$setStyles,
    mutateDom: // INTERNAL
    $1995762e80cda67d$var$mutateDom,
    directive: $1995762e80cda67d$var$directive,
    entangle: $1995762e80cda67d$var$entangle,
    throttle: $1995762e80cda67d$var$throttle,
    debounce: $1995762e80cda67d$var$debounce,
    evaluate: $1995762e80cda67d$var$evaluate,
    initTree: $1995762e80cda67d$var$initTree,
    nextTick: $1995762e80cda67d$var$nextTick,
    prefixed: $1995762e80cda67d$var$prefix,
    prefix: $1995762e80cda67d$var$setPrefix,
    plugin: $1995762e80cda67d$var$plugin,
    magic: $1995762e80cda67d$var$magic,
    store: $1995762e80cda67d$var$store,
    start: $1995762e80cda67d$var$start,
    clone: $1995762e80cda67d$var$clone,
    cloneNode: // INTERNAL
    $1995762e80cda67d$var$cloneNode,
    // INTERNAL
    bound: $1995762e80cda67d$var$getBinding,
    $data: $1995762e80cda67d$var$scope,
    watch: $1995762e80cda67d$var$watch,
    walk: $1995762e80cda67d$var$walk,
    data: $1995762e80cda67d$var$data,
    bind: $1995762e80cda67d$var$bind2
};
var $1995762e80cda67d$var$alpine_default = $1995762e80cda67d$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $1995762e80cda67d$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $1995762e80cda67d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $1995762e80cda67d$var$isBooleanAttr2 = /* @__PURE__ */ $1995762e80cda67d$var$makeMap($1995762e80cda67d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $1995762e80cda67d$var$EMPTY_OBJ = Object.freeze({});
var $1995762e80cda67d$var$EMPTY_ARR = Object.freeze([]);
var $1995762e80cda67d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $1995762e80cda67d$var$hasOwn = (val, key)=>$1995762e80cda67d$var$hasOwnProperty.call(val, key);
var $1995762e80cda67d$var$isArray = Array.isArray;
var $1995762e80cda67d$var$isMap = (val)=>$1995762e80cda67d$var$toTypeString(val) === "[object Map]";
var $1995762e80cda67d$var$isString = (val)=>typeof val === "string";
var $1995762e80cda67d$var$isSymbol = (val)=>typeof val === "symbol";
var $1995762e80cda67d$var$isObject = (val)=>val !== null && typeof val === "object";
var $1995762e80cda67d$var$objectToString = Object.prototype.toString;
var $1995762e80cda67d$var$toTypeString = (value)=>$1995762e80cda67d$var$objectToString.call(value);
var $1995762e80cda67d$var$toRawType = (value)=>{
    return $1995762e80cda67d$var$toTypeString(value).slice(8, -1);
};
var $1995762e80cda67d$var$isIntegerKey = (key)=>$1995762e80cda67d$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $1995762e80cda67d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $1995762e80cda67d$var$camelizeRE = /-(\w)/g;
var $1995762e80cda67d$var$camelize = $1995762e80cda67d$var$cacheStringFunction((str)=>{
    return str.replace($1995762e80cda67d$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $1995762e80cda67d$var$hyphenateRE = /\B([A-Z])/g;
var $1995762e80cda67d$var$hyphenate = $1995762e80cda67d$var$cacheStringFunction((str)=>str.replace($1995762e80cda67d$var$hyphenateRE, "-$1").toLowerCase());
var $1995762e80cda67d$var$capitalize = $1995762e80cda67d$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $1995762e80cda67d$var$toHandlerKey = $1995762e80cda67d$var$cacheStringFunction((str)=>str ? `on${$1995762e80cda67d$var$capitalize(str)}` : ``);
var $1995762e80cda67d$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $1995762e80cda67d$var$targetMap = /* @__PURE__ */ new WeakMap();
var $1995762e80cda67d$var$effectStack = [];
var $1995762e80cda67d$var$activeEffect;
var $1995762e80cda67d$var$ITERATE_KEY = Symbol("iterate");
var $1995762e80cda67d$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $1995762e80cda67d$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $1995762e80cda67d$var$effect2(fn, options = $1995762e80cda67d$var$EMPTY_OBJ) {
    if ($1995762e80cda67d$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $1995762e80cda67d$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $1995762e80cda67d$var$stop(effect3) {
    if (effect3.active) {
        $1995762e80cda67d$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $1995762e80cda67d$var$uid = 0;
function $1995762e80cda67d$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$1995762e80cda67d$var$effectStack.includes(effect3)) {
            $1995762e80cda67d$var$cleanup(effect3);
            try {
                $1995762e80cda67d$var$enableTracking();
                $1995762e80cda67d$var$effectStack.push(effect3);
                $1995762e80cda67d$var$activeEffect = effect3;
                return fn();
            } finally{
                $1995762e80cda67d$var$effectStack.pop();
                $1995762e80cda67d$var$resetTracking();
                $1995762e80cda67d$var$activeEffect = $1995762e80cda67d$var$effectStack[$1995762e80cda67d$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $1995762e80cda67d$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $1995762e80cda67d$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $1995762e80cda67d$var$shouldTrack = true;
var $1995762e80cda67d$var$trackStack = [];
function $1995762e80cda67d$var$pauseTracking() {
    $1995762e80cda67d$var$trackStack.push($1995762e80cda67d$var$shouldTrack);
    $1995762e80cda67d$var$shouldTrack = false;
}
function $1995762e80cda67d$var$enableTracking() {
    $1995762e80cda67d$var$trackStack.push($1995762e80cda67d$var$shouldTrack);
    $1995762e80cda67d$var$shouldTrack = true;
}
function $1995762e80cda67d$var$resetTracking() {
    const last = $1995762e80cda67d$var$trackStack.pop();
    $1995762e80cda67d$var$shouldTrack = last === void 0 ? true : last;
}
function $1995762e80cda67d$var$track(target, type, key) {
    if (!$1995762e80cda67d$var$shouldTrack || $1995762e80cda67d$var$activeEffect === void 0) return;
    let depsMap = $1995762e80cda67d$var$targetMap.get(target);
    if (!depsMap) $1995762e80cda67d$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($1995762e80cda67d$var$activeEffect)) {
        dep.add($1995762e80cda67d$var$activeEffect);
        $1995762e80cda67d$var$activeEffect.deps.push(dep);
        if ($1995762e80cda67d$var$activeEffect.options.onTrack) $1995762e80cda67d$var$activeEffect.options.onTrack({
            effect: $1995762e80cda67d$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $1995762e80cda67d$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $1995762e80cda67d$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $1995762e80cda67d$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $1995762e80cda67d$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$1995762e80cda67d$var$isArray(target)) {
                    add2(depsMap.get($1995762e80cda67d$var$ITERATE_KEY));
                    if ($1995762e80cda67d$var$isMap(target)) add2(depsMap.get($1995762e80cda67d$var$MAP_KEY_ITERATE_KEY));
                } else if ($1995762e80cda67d$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$1995762e80cda67d$var$isArray(target)) {
                    add2(depsMap.get($1995762e80cda67d$var$ITERATE_KEY));
                    if ($1995762e80cda67d$var$isMap(target)) add2(depsMap.get($1995762e80cda67d$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($1995762e80cda67d$var$isMap(target)) add2(depsMap.get($1995762e80cda67d$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $1995762e80cda67d$var$isNonTrackableKeys = /* @__PURE__ */ $1995762e80cda67d$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $1995762e80cda67d$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($1995762e80cda67d$var$isSymbol));
var $1995762e80cda67d$var$get2 = /* @__PURE__ */ $1995762e80cda67d$var$createGetter();
var $1995762e80cda67d$var$readonlyGet = /* @__PURE__ */ $1995762e80cda67d$var$createGetter(true);
var $1995762e80cda67d$var$arrayInstrumentations = /* @__PURE__ */ $1995762e80cda67d$var$createArrayInstrumentations();
function $1995762e80cda67d$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $1995762e80cda67d$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$1995762e80cda67d$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($1995762e80cda67d$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $1995762e80cda67d$var$pauseTracking();
            const res = $1995762e80cda67d$var$toRaw(this)[key].apply(this, args);
            $1995762e80cda67d$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $1995762e80cda67d$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $1995762e80cda67d$var$shallowReadonlyMap : $1995762e80cda67d$var$readonlyMap : shallow ? $1995762e80cda67d$var$shallowReactiveMap : $1995762e80cda67d$var$reactiveMap).get(target)) return target;
        const targetIsArray = $1995762e80cda67d$var$isArray(target);
        if (!isReadonly && targetIsArray && $1995762e80cda67d$var$hasOwn($1995762e80cda67d$var$arrayInstrumentations, key)) return Reflect.get($1995762e80cda67d$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($1995762e80cda67d$var$isSymbol(key) ? $1995762e80cda67d$var$builtInSymbols.has(key) : $1995762e80cda67d$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $1995762e80cda67d$var$track(target, "get", key);
        if (shallow) return res;
        if ($1995762e80cda67d$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$1995762e80cda67d$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($1995762e80cda67d$var$isObject(res)) return isReadonly ? $1995762e80cda67d$var$readonly(res) : $1995762e80cda67d$var$reactive2(res);
        return res;
    };
}
var $1995762e80cda67d$var$set2 = /* @__PURE__ */ $1995762e80cda67d$var$createSetter();
function $1995762e80cda67d$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $1995762e80cda67d$var$toRaw(value);
            oldValue = $1995762e80cda67d$var$toRaw(oldValue);
            if (!$1995762e80cda67d$var$isArray(target) && $1995762e80cda67d$var$isRef(oldValue) && !$1995762e80cda67d$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $1995762e80cda67d$var$isArray(target) && $1995762e80cda67d$var$isIntegerKey(key) ? Number(key) < target.length : $1995762e80cda67d$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $1995762e80cda67d$var$toRaw(receiver)) {
            if (!hadKey) $1995762e80cda67d$var$trigger(target, "add", key, value);
            else if ($1995762e80cda67d$var$hasChanged(value, oldValue)) $1995762e80cda67d$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $1995762e80cda67d$var$deleteProperty(target, key) {
    const hadKey = $1995762e80cda67d$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $1995762e80cda67d$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $1995762e80cda67d$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$1995762e80cda67d$var$isSymbol(key) || !$1995762e80cda67d$var$builtInSymbols.has(key)) $1995762e80cda67d$var$track(target, "has", key);
    return result;
}
function $1995762e80cda67d$var$ownKeys(target) {
    $1995762e80cda67d$var$track(target, "iterate", $1995762e80cda67d$var$isArray(target) ? "length" : $1995762e80cda67d$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $1995762e80cda67d$var$mutableHandlers = {
    get: $1995762e80cda67d$var$get2,
    set: $1995762e80cda67d$var$set2,
    deleteProperty: $1995762e80cda67d$var$deleteProperty,
    has: $1995762e80cda67d$var$has,
    ownKeys: $1995762e80cda67d$var$ownKeys
};
var $1995762e80cda67d$var$readonlyHandlers = {
    get: $1995762e80cda67d$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $1995762e80cda67d$var$toReactive = (value)=>$1995762e80cda67d$var$isObject(value) ? $1995762e80cda67d$var$reactive2(value) : value;
var $1995762e80cda67d$var$toReadonly = (value)=>$1995762e80cda67d$var$isObject(value) ? $1995762e80cda67d$var$readonly(value) : value;
var $1995762e80cda67d$var$toShallow = (value)=>value;
var $1995762e80cda67d$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $1995762e80cda67d$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $1995762e80cda67d$var$toRaw(target);
    const rawKey = $1995762e80cda67d$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $1995762e80cda67d$var$track(rawTarget, "get", key);
    !isReadonly && $1995762e80cda67d$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $1995762e80cda67d$var$getProto(rawTarget);
    const wrap = isShallow ? $1995762e80cda67d$var$toShallow : isReadonly ? $1995762e80cda67d$var$toReadonly : $1995762e80cda67d$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $1995762e80cda67d$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $1995762e80cda67d$var$toRaw(target);
    const rawKey = $1995762e80cda67d$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $1995762e80cda67d$var$track(rawTarget, "has", key);
    !isReadonly && $1995762e80cda67d$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $1995762e80cda67d$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $1995762e80cda67d$var$track($1995762e80cda67d$var$toRaw(target), "iterate", $1995762e80cda67d$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $1995762e80cda67d$var$add(value) {
    value = $1995762e80cda67d$var$toRaw(value);
    const target = $1995762e80cda67d$var$toRaw(this);
    const proto = $1995762e80cda67d$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $1995762e80cda67d$var$trigger(target, "add", value, value);
    }
    return this;
}
function $1995762e80cda67d$var$set$1(key, value) {
    value = $1995762e80cda67d$var$toRaw(value);
    const target = $1995762e80cda67d$var$toRaw(this);
    const { has: has2, get: get3 } = $1995762e80cda67d$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $1995762e80cda67d$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $1995762e80cda67d$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $1995762e80cda67d$var$trigger(target, "add", key, value);
    else if ($1995762e80cda67d$var$hasChanged(value, oldValue)) $1995762e80cda67d$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $1995762e80cda67d$var$deleteEntry(key) {
    const target = $1995762e80cda67d$var$toRaw(this);
    const { has: has2, get: get3 } = $1995762e80cda67d$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $1995762e80cda67d$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $1995762e80cda67d$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $1995762e80cda67d$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $1995762e80cda67d$var$clear() {
    const target = $1995762e80cda67d$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $1995762e80cda67d$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $1995762e80cda67d$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $1995762e80cda67d$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $1995762e80cda67d$var$toRaw(target);
        const wrap = isShallow ? $1995762e80cda67d$var$toShallow : isReadonly ? $1995762e80cda67d$var$toReadonly : $1995762e80cda67d$var$toReactive;
        !isReadonly && $1995762e80cda67d$var$track(rawTarget, "iterate", $1995762e80cda67d$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $1995762e80cda67d$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $1995762e80cda67d$var$toRaw(target);
        const targetIsMap = $1995762e80cda67d$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $1995762e80cda67d$var$toShallow : isReadonly ? $1995762e80cda67d$var$toReadonly : $1995762e80cda67d$var$toReactive;
        !isReadonly && $1995762e80cda67d$var$track(rawTarget, "iterate", isKeyOnly ? $1995762e80cda67d$var$MAP_KEY_ITERATE_KEY : $1995762e80cda67d$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $1995762e80cda67d$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$1995762e80cda67d$var$capitalize(type)} operation ${key}failed: target is readonly.`, $1995762e80cda67d$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $1995762e80cda67d$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $1995762e80cda67d$var$get$1(this, key);
        },
        get size () {
            return $1995762e80cda67d$var$size(this);
        },
        has: $1995762e80cda67d$var$has$1,
        add: $1995762e80cda67d$var$add,
        set: $1995762e80cda67d$var$set$1,
        delete: $1995762e80cda67d$var$deleteEntry,
        clear: $1995762e80cda67d$var$clear,
        forEach: $1995762e80cda67d$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $1995762e80cda67d$var$get$1(this, key, false, true);
        },
        get size () {
            return $1995762e80cda67d$var$size(this);
        },
        has: $1995762e80cda67d$var$has$1,
        add: $1995762e80cda67d$var$add,
        set: $1995762e80cda67d$var$set$1,
        delete: $1995762e80cda67d$var$deleteEntry,
        clear: $1995762e80cda67d$var$clear,
        forEach: $1995762e80cda67d$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $1995762e80cda67d$var$get$1(this, key, true);
        },
        get size () {
            return $1995762e80cda67d$var$size(this, true);
        },
        has (key) {
            return $1995762e80cda67d$var$has$1.call(this, key, true);
        },
        add: $1995762e80cda67d$var$createReadonlyMethod("add"),
        set: $1995762e80cda67d$var$createReadonlyMethod("set"),
        delete: $1995762e80cda67d$var$createReadonlyMethod("delete"),
        clear: $1995762e80cda67d$var$createReadonlyMethod("clear"),
        forEach: $1995762e80cda67d$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $1995762e80cda67d$var$get$1(this, key, true, true);
        },
        get size () {
            return $1995762e80cda67d$var$size(this, true);
        },
        has (key) {
            return $1995762e80cda67d$var$has$1.call(this, key, true);
        },
        add: $1995762e80cda67d$var$createReadonlyMethod("add"),
        set: $1995762e80cda67d$var$createReadonlyMethod("set"),
        delete: $1995762e80cda67d$var$createReadonlyMethod("delete"),
        clear: $1995762e80cda67d$var$createReadonlyMethod("clear"),
        forEach: $1995762e80cda67d$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $1995762e80cda67d$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $1995762e80cda67d$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $1995762e80cda67d$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $1995762e80cda67d$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$1995762e80cda67d$var$mutableInstrumentations, $1995762e80cda67d$var$readonlyInstrumentations, $1995762e80cda67d$var$shallowInstrumentations, $1995762e80cda67d$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $1995762e80cda67d$var$createInstrumentations();
function $1995762e80cda67d$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $1995762e80cda67d$var$shallowReadonlyInstrumentations : $1995762e80cda67d$var$shallowInstrumentations : isReadonly ? $1995762e80cda67d$var$readonlyInstrumentations : $1995762e80cda67d$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($1995762e80cda67d$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $1995762e80cda67d$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $1995762e80cda67d$var$createInstrumentationGetter(false, false)
};
var $1995762e80cda67d$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $1995762e80cda67d$var$createInstrumentationGetter(true, false)
};
function $1995762e80cda67d$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $1995762e80cda67d$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $1995762e80cda67d$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $1995762e80cda67d$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $1995762e80cda67d$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $1995762e80cda67d$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $1995762e80cda67d$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $1995762e80cda67d$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $1995762e80cda67d$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $1995762e80cda67d$var$targetTypeMap($1995762e80cda67d$var$toRawType(value));
}
function $1995762e80cda67d$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $1995762e80cda67d$var$createReactiveObject(target, false, $1995762e80cda67d$var$mutableHandlers, $1995762e80cda67d$var$mutableCollectionHandlers, $1995762e80cda67d$var$reactiveMap);
}
function $1995762e80cda67d$var$readonly(target) {
    return $1995762e80cda67d$var$createReactiveObject(target, true, $1995762e80cda67d$var$readonlyHandlers, $1995762e80cda67d$var$readonlyCollectionHandlers, $1995762e80cda67d$var$readonlyMap);
}
function $1995762e80cda67d$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$1995762e80cda67d$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $1995762e80cda67d$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $1995762e80cda67d$var$toRaw(observed) {
    return observed && $1995762e80cda67d$var$toRaw(observed["__v_raw"]) || observed;
}
function $1995762e80cda67d$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$1995762e80cda67d$var$magic("nextTick", ()=>$1995762e80cda67d$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$1995762e80cda67d$var$magic("dispatch", (el)=>$1995762e80cda67d$var$dispatch.bind($1995762e80cda67d$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$1995762e80cda67d$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $1995762e80cda67d$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$1995762e80cda67d$var$magic("store", $1995762e80cda67d$var$getStores);
// packages/alpinejs/src/magics/$data.js
$1995762e80cda67d$var$magic("data", (el)=>$1995762e80cda67d$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$1995762e80cda67d$var$magic("root", (el)=>$1995762e80cda67d$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$1995762e80cda67d$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $1995762e80cda67d$var$mergeProxies($1995762e80cda67d$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $1995762e80cda67d$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $1995762e80cda67d$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $1995762e80cda67d$var$globalIdMemo = {};
function $1995762e80cda67d$var$findAndIncrementId(name) {
    if (!$1995762e80cda67d$var$globalIdMemo[name]) $1995762e80cda67d$var$globalIdMemo[name] = 0;
    return ++$1995762e80cda67d$var$globalIdMemo[name];
}
function $1995762e80cda67d$var$closestIdRoot(el, name) {
    return $1995762e80cda67d$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $1995762e80cda67d$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $1995762e80cda67d$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$1995762e80cda67d$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $1995762e80cda67d$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $1995762e80cda67d$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $1995762e80cda67d$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$1995762e80cda67d$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $1995762e80cda67d$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$1995762e80cda67d$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$1995762e80cda67d$var$warnMissingPluginMagic("Focus", "focus", "focus");
$1995762e80cda67d$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $1995762e80cda67d$var$warnMissingPluginMagic(name, magicName, slug) {
    $1995762e80cda67d$var$magic(magicName, (el)=>$1995762e80cda67d$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$1995762e80cda67d$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $1995762e80cda67d$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$1995762e80cda67d$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $1995762e80cda67d$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $1995762e80cda67d$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $1995762e80cda67d$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $1995762e80cda67d$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $1995762e80cda67d$var$skipDuringClone(()=>{
            $1995762e80cda67d$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $1995762e80cda67d$var$getTarget(expression);
        $1995762e80cda67d$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$1995762e80cda67d$var$mutateDom(()=>{
            clone2.remove();
            $1995762e80cda67d$var$destroyTree(clone2);
        }));
});
var $1995762e80cda67d$var$teleportContainerDuringClone = document.createElement("div");
function $1995762e80cda67d$var$getTarget(expression) {
    let target = $1995762e80cda67d$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $1995762e80cda67d$var$teleportContainerDuringClone;
    })();
    if (!target) $1995762e80cda67d$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $1995762e80cda67d$var$handler = ()=>{};
$1995762e80cda67d$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$1995762e80cda67d$var$directive("ignore", $1995762e80cda67d$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$1995762e80cda67d$var$directive("effect", $1995762e80cda67d$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($1995762e80cda67d$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $1995762e80cda67d$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $1995762e80cda67d$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $1995762e80cda67d$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $1995762e80cda67d$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $1995762e80cda67d$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $1995762e80cda67d$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $1995762e80cda67d$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($1995762e80cda67d$var$isKeyEvent(event) || $1995762e80cda67d$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($1995762e80cda67d$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $1995762e80cda67d$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $1995762e80cda67d$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $1995762e80cda67d$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $1995762e80cda67d$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $1995762e80cda67d$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $1995762e80cda67d$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $1995762e80cda67d$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive",
            "preserve-scroll"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $1995762e80cda67d$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $1995762e80cda67d$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $1995762e80cda67d$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($1995762e80cda67d$var$isClickEvent(e.type)) return false;
            if ($1995762e80cda67d$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $1995762e80cda67d$var$keyToModifiers(key) {
    if (!key) return [];
    key = $1995762e80cda67d$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$1995762e80cda67d$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $1995762e80cda67d$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $1995762e80cda67d$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $1995762e80cda67d$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $1995762e80cda67d$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($1995762e80cda67d$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $1995762e80cda67d$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $1995762e80cda67d$var$isCloning ? ()=>{} : $1995762e80cda67d$var$on(el, event, modifiers, (e)=>{
        setValue($1995762e80cda67d$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $1995762e80cda67d$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($1995762e80cda67d$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $1995762e80cda67d$var$on(el.form, "reset", [], (e)=>{
            $1995762e80cda67d$var$nextTick(()=>el._x_model && el._x_model.set($1995762e80cda67d$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $1995762e80cda67d$var$mutateDom(()=>$1995762e80cda67d$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $1995762e80cda67d$var$getInputValue(el, modifiers, event, currentValue) {
    return $1995762e80cda67d$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($1995762e80cda67d$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $1995762e80cda67d$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $1995762e80cda67d$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$1995762e80cda67d$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $1995762e80cda67d$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $1995762e80cda67d$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($1995762e80cda67d$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $1995762e80cda67d$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $1995762e80cda67d$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $1995762e80cda67d$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $1995762e80cda67d$var$isNumeric2(number) ? number : rawValue;
}
function $1995762e80cda67d$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $1995762e80cda67d$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $1995762e80cda67d$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$1995762e80cda67d$var$directive("cloak", (el)=>queueMicrotask(()=>$1995762e80cda67d$var$mutateDom(()=>el.removeAttribute($1995762e80cda67d$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$1995762e80cda67d$var$addInitSelector(()=>`[${$1995762e80cda67d$var$prefix("init")}]`);
$1995762e80cda67d$var$directive("init", $1995762e80cda67d$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$1995762e80cda67d$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $1995762e80cda67d$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$1995762e80cda67d$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $1995762e80cda67d$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $1995762e80cda67d$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$1995762e80cda67d$var$mapAttributes($1995762e80cda67d$var$startingWith(":", $1995762e80cda67d$var$into($1995762e80cda67d$var$prefix("bind:"))));
var $1995762e80cda67d$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $1995762e80cda67d$var$injectBindingProviders(bindingProviders);
        let getBindings = $1995762e80cda67d$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $1995762e80cda67d$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $1995762e80cda67d$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $1995762e80cda67d$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $1995762e80cda67d$var$mutateDom(()=>$1995762e80cda67d$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$1995762e80cda67d$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$1995762e80cda67d$var$directive("bind", $1995762e80cda67d$var$handler2);
function $1995762e80cda67d$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$1995762e80cda67d$var$addRootSelector(()=>`[${$1995762e80cda67d$var$prefix("data")}]`);
$1995762e80cda67d$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($1995762e80cda67d$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $1995762e80cda67d$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $1995762e80cda67d$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $1995762e80cda67d$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $1995762e80cda67d$var$injectMagics(data2, el);
    let reactiveData = $1995762e80cda67d$var$reactive(data2);
    $1995762e80cda67d$var$initInterceptors(reactiveData);
    let undo = $1995762e80cda67d$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $1995762e80cda67d$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $1995762e80cda67d$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$1995762e80cda67d$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $1995762e80cda67d$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$1995762e80cda67d$var$isCloning) return false;
    if ($1995762e80cda67d$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$1995762e80cda67d$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $1995762e80cda67d$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $1995762e80cda67d$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $1995762e80cda67d$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $1995762e80cda67d$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$1995762e80cda67d$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $1995762e80cda67d$var$parseForExpression(expression);
    let evaluateItems = $1995762e80cda67d$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $1995762e80cda67d$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$1995762e80cda67d$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$1995762e80cda67d$var$mutateDom(()=>{
                $1995762e80cda67d$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $1995762e80cda67d$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($1995762e80cda67d$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $1995762e80cda67d$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $1995762e80cda67d$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $1995762e80cda67d$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $1995762e80cda67d$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $1995762e80cda67d$var$mutateDom(()=>{
                $1995762e80cda67d$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $1995762e80cda67d$var$mutateDom(()=>{
                if (!elForSpot) $1995762e80cda67d$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $1995762e80cda67d$var$reactive(scope2);
            $1995762e80cda67d$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $1995762e80cda67d$var$mutateDom(()=>{
                lastEl.after(clone2);
                $1995762e80cda67d$var$skipDuringClone(()=>$1995762e80cda67d$var$initTree(clone2))();
            });
            if (typeof key === "object") $1995762e80cda67d$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $1995762e80cda67d$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $1995762e80cda67d$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $1995762e80cda67d$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $1995762e80cda67d$var$handler3() {}
$1995762e80cda67d$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $1995762e80cda67d$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$1995762e80cda67d$var$directive("ref", $1995762e80cda67d$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$1995762e80cda67d$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $1995762e80cda67d$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $1995762e80cda67d$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $1995762e80cda67d$var$addScopeToNode(clone2, {}, el);
        $1995762e80cda67d$var$mutateDom(()=>{
            el.after(clone2);
            $1995762e80cda67d$var$skipDuringClone(()=>$1995762e80cda67d$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $1995762e80cda67d$var$mutateDom(()=>{
                $1995762e80cda67d$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$1995762e80cda67d$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$1995762e80cda67d$var$setIdRoot(el, name));
});
$1995762e80cda67d$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$1995762e80cda67d$var$mapAttributes($1995762e80cda67d$var$startingWith("@", $1995762e80cda67d$var$into($1995762e80cda67d$var$prefix("on:"))));
$1995762e80cda67d$var$directive("on", $1995762e80cda67d$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $1995762e80cda67d$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $1995762e80cda67d$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$1995762e80cda67d$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$1995762e80cda67d$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$1995762e80cda67d$var$warnMissingPluginDirective("Focus", "trap", "focus");
$1995762e80cda67d$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $1995762e80cda67d$var$warnMissingPluginDirective(name, directiveName, slug) {
    $1995762e80cda67d$var$directive(directiveName, (el)=>$1995762e80cda67d$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$1995762e80cda67d$var$alpine_default.setEvaluator($1995762e80cda67d$var$normalEvaluator);
$1995762e80cda67d$var$alpine_default.setReactivityEngine({
    reactive: $1995762e80cda67d$var$reactive2,
    effect: $1995762e80cda67d$var$effect2,
    release: $1995762e80cda67d$var$stop,
    raw: $1995762e80cda67d$var$toRaw
});
var $1995762e80cda67d$export$b7ee041e4ad2afec = $1995762e80cda67d$var$alpine_default;
// packages/alpinejs/builds/module.js
var $1995762e80cda67d$export$2e2bcd8739ae039 = $1995762e80cda67d$export$b7ee041e4ad2afec;


/* eslint-disable */ // @generated
// ⚠️ DO NOT EDIT THIS FILE MANUALLY!
// This file was automatically generated from Go structs and constants.
// Source package: github.com/future-ai-hotel/aionara/internal/foundation/web/render/ts_shared
// Regenerate: go generate ./...
const $54bc1564cb809719$export$1674614146201a8c = "token";
const $54bc1564cb809719$export$f0e893938abd135c = "toast";
const $54bc1564cb809719$export$cb0ef4cbcebab94e = "success";
const $54bc1564cb809719$export$fabb6ef1f0611d0b = "warning";
const $54bc1564cb809719$export$4c380779a4e36018 = "error";
const $54bc1564cb809719$export$141fc778693e573f = "info";


class $2040b187572cc8da$export$52544d35a0066ce7 {
    constructor(sseURL, tokenEndpoint, toConsole = false){
        this.evtSource = null;
        this.toConsole = toConsole;
        this.baseSSEUrl = sseURL;
        this.tokenEndpoint = tokenEndpoint;
    }
    async connect() {
        const token = await this.fetchJWT();
        if (!token) {
            console.error("[SSE] Failed to obtain JWT.");
            return;
        }
        const urlWithToken = `${this.baseSSEUrl}?${(0, $54bc1564cb809719$export$1674614146201a8c)}=${encodeURIComponent(token)}`;
        this.evtSource = new EventSource(urlWithToken, {
            withCredentials: true
        });
        this.registerForEvents();
    }
    async fetchJWT() {
        try {
            const response = await fetch(this.tokenEndpoint, {
                method: "GET",
                credentials: "include"
            });
            if (!response.ok) throw new Error("Token fetch failed");
            const data = await response.json();
            return data.token;
        } catch (error) {
            console.error("[SSE] Error fetching JWT:", error);
            return null;
        }
    }
    registerForEvents() {
        if (!this.evtSource) return;
        this.evtSource.addEventListener("close", (event)=>{
            if (this.toConsole) console.log("[SSE] server closed the connection:", event.data);
            this.evtSource?.close();
        });
        if (!this.toConsole) return;
        console.log("[SSE] connected");
        this.evtSource.onmessage = function(event) {
            console.log("[SSE] Received message:", event.data);
        };
        this.evtSource.onerror = (err)=>{
            console.error("[SSE] Error triggered", err);
            console.log("readyState:", this.evtSource?.readyState);
            if (this.evtSource?.readyState === EventSource.CLOSED) console.warn("[SSE] Connection was closed.");
            else if (this.evtSource?.readyState === EventSource.CONNECTING) console.warn("[SSE] Connection is reconnecting...");
            else console.warn("[SSE] Unknown state");
        };
    }
}


// Owns the page's single SSE connection across the back/forward cache.
//
// A page entering the bfcache keeps its EventSource open. Over HTTP/1.1 every
// open stream pins one of the browser's 6 connections to the host, so after a
// few full-page navigations the cached pages hold every slot and the next
// click stalls in the browser's queue (observed: 30-60s) until one of them is
// evicted. The connection is therefore closed on pagehide and reopened on a
// bfcache restore (pageshow with persisted=true).
class $b605759c7d2aabe5$export$6bb11fd42f235146 {
    constructor(open, onConnected, onClosed){
        this.open = open;
        this.onConnected = onConnected;
        this.onClosed = onClosed;
        this.source = null;
        this.connecting = false;
        this.generation = 0;
        this.urls = null;
    }
    start(sseURL, tokenURL) {
        this.urls = [
            sseURL,
            tokenURL
        ];
        if (this.source || this.connecting) return;
        this.connecting = true;
        const gen = this.generation;
        this.open(sseURL, tokenURL).then((source)=>{
            if (gen !== this.generation) {
                source?.close();
                return;
            }
            this.connecting = false;
            if (!source) return;
            this.source = source;
            this.onConnected(source);
        }, ()=>{
            if (gen === this.generation) this.connecting = false;
        });
    }
    stop() {
        this.generation++;
        this.connecting = false;
        if (!this.source) return;
        this.source.close();
        this.source = null;
        this.onClosed();
    }
    // Reopens with the URLs of the last start(); a no-op before the first one.
    restart() {
        if (this.urls) this.start(...this.urls);
    }
    bind(target) {
        target.addEventListener("pagehide", ()=>this.stop());
        target.addEventListener("pageshow", (e)=>{
            if (e.persisted) this.restart();
        });
    }
}


// In-place navigation for links whose address only exists in Alpine state
// (`:href` inside x-for rows), which htmx never processes. Modifier and
// non-left clicks fall through to the browser so "open in new tab" works.
function $56a4cebe880c777d$export$aaf9a36dd84c3909(e) {
    return e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey;
}
function $56a4cebe880c777d$export$a01aa4785e9704e5(e, href) {
    if (!$56a4cebe880c777d$export$aaf9a36dd84c3909(e)) return;
    e.preventDefault();
    // htmx compares push against the string 'true' (the server's final URL);
    // a boolean true would be pushed literally as the URL "true". The cast is
    // needed because htmx.ajax's typings do not declare `push`.
    window.htmx.ajax("GET", href, {
        target: "#main-content",
        push: "true"
    });
}


// Staff pages scroll inside the app shell's content pane (#content-scroll in
// main.templ), not the window. An in-place navigation swaps #main-content
// inside that pane and htmx never touches the pane's scrollTop, so without a
// reset the new page opens at the old page's offset - clamped to the bottom
// when the new page is shorter.
//
// Wired to htmx:beforeHistoryUpdate, which htmx fires on document.body right
// before the swap with detail = {history: {type, path}, ...responseInfo};
// detail.target is the final swap target (after any HX-Retarget). The reset
// runs in the same task as the swap, so nothing paints in between, and it runs
// before settle, so URL anchors and autofocus still scroll afterwards.
const $9831061986491189$export$18d6475ce2e9bfe8 = "main-content";
const $9831061986491189$export$bdfcb2d25b947afe = "content-scroll";
function $9831061986491189$export$b5c1f025b40f0fa2(detail) {
    return detail.history?.type === "push" && detail.target?.id === $9831061986491189$export$18d6475ce2e9bfe8;
}
function $9831061986491189$export$ad446fa89ac42e58(detail, doc) {
    if (!$9831061986491189$export$b5c1f025b40f0fa2(detail)) return;
    const pane = doc.getElementById($9831061986491189$export$bdfcb2d25b947afe);
    if (pane) pane.scrollTop = 0;
}


// The element the global htmx:afterSettle handler re-initializes (htmx.process,
// Alpine.initTree, __alpineInits).
//
// event.detail.target is the request's swap target. After an outerHTML swap
// that element has been replaced and is detached: Alpine's mutation observer
// already destroyed its tree (clearing _x_marker), so initTree on it would
// re-run every directive on the orphaned nodes with no data stack. Any
// expression naming an x-data property then falls through to window (`open`
// becomes window.open, which Alpine calls: "TypeError: Illegal invocation").
// For a detached target the root is the settled element the event fired on,
// which is the new content.
function $536e9a288e0a2da4$export$825ed9e9c5a3375d(detailTarget, eventTarget) {
    if (detailTarget && detailTarget.isConnected) return detailTarget;
    if (eventTarget && eventTarget.isConnected) return eventTarget;
    return null;
}



const $58efe74bd4380493$var$NotificationTypeMap = {
    success: (0, $54bc1564cb809719$export$cb0ef4cbcebab94e),
    warning: (0, $54bc1564cb809719$export$fabb6ef1f0611d0b),
    error: (0, $54bc1564cb809719$export$4c380779a4e36018),
    info: (0, $54bc1564cb809719$export$141fc778693e573f)
};
class $58efe74bd4380493$export$e65cc68e71f15e38 {
    addEventSource(evtSource) {
        this.evtSource = evtSource;
        this.register();
    }
    register() {
        if (!this.evtSource) return;
        this.evtSource.addEventListener("toast", (event)=>{
            const data = JSON.parse(event.data);
            if (data && data.message && data.notification_type) this.add(data.message, data.notification_type, data.notification_duration || 2000);
        });
    }
    start() {
        console.log('ToastHandler started');
    }
    // Public so a screen can report something that happened in the browser and
    // never reached the server, such as a value copied to the clipboard. The
    // server path raises toasts over the event stream; this is the same queue,
    // so both kinds look and behave alike.
    add(message, type = 'success', duration = 3000) {
        const id = Date.now() + Math.random();
        const toast = {
            id: id,
            message: message,
            type: type,
            visible: true
        };
        this.toasts.push(toast);
        setTimeout(()=>{
            this.removeById(id);
        }, duration);
    }
    remove(index) {
        this.toasts[index].visible = false;
        setTimeout(()=>{
            this.toasts.splice(index, 1);
        }, 300);
    }
    removeById(id) {
        const index = this.toasts.findIndex((t)=>t.id === id);
        if (index !== -1) this.remove(index);
    }
    constructor(){
        this.toasts = [];
    }
}


const $01dba7cb2c4d359c$var$enc = new TextEncoder();
function $01dba7cb2c4d359c$var$capBytes(s, max) {
    const bytes = $01dba7cb2c4d359c$var$enc.encode(s);
    if (bytes.byteLength <= max) return s;
    return new TextDecoder().decode(bytes.slice(0, max));
}
function $01dba7cb2c4d359c$var$capContextJSON(obj, max) {
    const s = JSON.stringify(obj);
    if ($01dba7cb2c4d359c$var$enc.encode(s).byteLength <= max) return s;
    // Drop the heaviest field first, retry. If still over, fall through to byte-cut.
    const trimmed = JSON.stringify({
        ...obj,
        stores: "[omitted: oversize]"
    });
    if ($01dba7cb2c4d359c$var$enc.encode(trimmed).byteLength <= max) return trimmed;
    return $01dba7cb2c4d359c$var$capBytes(trimmed, max);
}
// Mirrors domain.MaxScreenshotBytes in
// internal/feedback/internal/domain/feedback.go, which is the authority — this
// copy exists only so the browser can shrink before wasting an upload.
const $01dba7cb2c4d359c$var$MAX_SCREENSHOT_BYTES = 4194304;
const $01dba7cb2c4d359c$var$ALLOWED_IMAGE_TYPES = new Set([
    "image/png",
    "image/jpeg",
    "image/webp"
]);
// Tried in order; the first result under the cap wins. PNG first so small UI
// text stays crisp — JPEG is the fallback that reliably collapses gradient-
// heavy captures. Re-encoding at full scale is skipped: it rarely gains enough
// to matter.
const $01dba7cb2c4d359c$var$SHRINK_LADDER = [
    {
        scale: 0.75,
        type: "image/png"
    },
    {
        scale: 0.5,
        type: "image/png"
    },
    {
        scale: 0.75,
        type: "image/jpeg",
        quality: 0.85
    }
];
async function $01dba7cb2c4d359c$var$normalizeImage(file) {
    let bitmap;
    try {
        bitmap = await createImageBitmap(file);
    } catch (e) {
        console.warn("feedback attachment decode failed", e);
        return null;
    }
    try {
        for (const step of $01dba7cb2c4d359c$var$SHRINK_LADDER){
            const canvas = document.createElement("canvas");
            canvas.width = Math.max(1, Math.round(bitmap.width * step.scale));
            canvas.height = Math.max(1, Math.round(bitmap.height * step.scale));
            const ctx = canvas.getContext("2d");
            if (!ctx) return null;
            ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
            const blob = await new Promise((res)=>canvas.toBlob(res, step.type, step.quality));
            if (blob && blob.size <= $01dba7cb2c4d359c$var$MAX_SCREENSHOT_BYTES) return blob;
        }
        return null;
    } finally{
        bitmap.close();
    }
}
function $01dba7cb2c4d359c$var$renameForType(name, type) {
    const ext = type === "image/png" ? ".png" : type === "image/webp" ? ".webp" : ".jpg";
    const base = name.replace(/\.[^.]+$/, "") || "screenshot";
    return base + ext;
}
function $01dba7cb2c4d359c$var$createDisplayMediaOptions() {
    return {
        video: {
            displaySurface: "browser",
            frameRate: {
                ideal: 1,
                max: 4
            }
        },
        audio: false,
        preferCurrentTab: true,
        selfBrowserSurface: "include",
        surfaceSwitching: "exclude"
    };
}
const $01dba7cb2c4d359c$var$VIDEO_FRAME_TIMEOUT_MS = 3000;
async function $01dba7cb2c4d359c$var$waitForVideoFrame(video) {
    let timer;
    const timeout = new Promise((_, reject)=>{
        timer = setTimeout(()=>reject(new Error("timed out waiting for capture video frame")), $01dba7cb2c4d359c$var$VIDEO_FRAME_TIMEOUT_MS);
    });
    const work = (async ()=>{
        if (video.readyState < 2) await new Promise((resolve, reject)=>{
            const onLoaded = ()=>resolve();
            const onError = ()=>reject(video.error ?? new Error("video failed to load capture stream"));
            video.addEventListener("loadeddata", onLoaded, {
                once: true
            });
            video.addEventListener("error", onError, {
                once: true
            });
        });
        await video.play();
        await new Promise((resolve)=>{
            if ("requestVideoFrameCallback" in video) {
                video.requestVideoFrameCallback(()=>resolve());
                return;
            }
            requestAnimationFrame(()=>resolve());
        });
    })();
    try {
        await Promise.race([
            work,
            timeout
        ]);
    } finally{
        clearTimeout(timer);
        // If the timeout won, work may still reject later; avoid an unhandled rejection.
        work.catch(()=>{});
    }
}
function $01dba7cb2c4d359c$export$853590d507b26d3b(alpine) {
    alpine.data("feedbackBubble", ()=>({
            open: false,
            busy: false,
            message: "",
            screenshotMode: "capture",
            attachment: null,
            attachError: "",
            dragOver: false,
            t: {},
            // Alpine runs init() with $el = the x-data root, which carries the
            // translated data-* attributes. Handlers later run with $el = the element
            // carrying the directive (e.g. the submit button), so copy them now.
            init () {
                this.t = {
                    ...this.$el.dataset
                };
            },
            async submit () {
                if (!this.message.trim()) return;
                this.busy = true;
                try {
                    let screenshot = null;
                    let captureStatus = "ok";
                    let screenshotName = "screenshot.jpg";
                    if (this.screenshotMode === "capture") {
                        const result = await this.captureScreenshot();
                        screenshot = result.blob;
                        captureStatus = result.status;
                    } else if (this.screenshotMode === "upload" && this.attachment) {
                        screenshot = this.attachment.blob;
                        screenshotName = this.attachment.name;
                    }
                    const fd = new FormData();
                    fd.set("message", this.message);
                    fd.set("url", location.href);
                    fd.set("viewport", `${innerWidth}x${innerHeight}`);
                    fd.set("referrer", document.referrer);
                    fd.set("console_log", $01dba7cb2c4d359c$var$capBytes(JSON.stringify(window.__feedbackBuffer || []), 65536));
                    fd.set("context_json", $01dba7cb2c4d359c$var$capContextJSON(this.collectContext(), 16384));
                    if (screenshot) fd.set("screenshot", screenshot, screenshotName);
                    const res = await fetch("feedback", {
                        method: "POST",
                        body: fd,
                        headers: {
                            "X-CSRF-Token": window.csrfToken()
                        },
                        credentials: "same-origin"
                    });
                    if (!res.ok) {
                        const e = new Error(`status ${res.status}`);
                        e.status = res.status;
                        throw e;
                    }
                    this.open = false;
                    this.message = "";
                    this.clearAttachment();
                    this.attachError = "";
                    const sentWithoutScreenshot = this.screenshotMode === "capture" && captureStatus !== "ok";
                    window.__toastHandler?.add?.(sentWithoutScreenshot ? this.t.toastSubmittedNoScreenshot : this.t.toastSubmitted, "success", 3000);
                } catch (err) {
                    const status = err.status;
                    const tooLarge = status === 413 || status === 422;
                    const msg = tooLarge ? this.t.errorBodyTooLarge ?? this.t.toastFailed : this.t.toastFailed;
                    window.__toastHandler?.add?.(msg, "error", 4000);
                    console.warn("feedback submit failed", err);
                } finally{
                    this.busy = false;
                }
            },
            collectContext () {
                const stores = {};
                for (const k of [
                    "toast",
                    "sidebar"
                ])try {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    stores[k] = window.Alpine?.store?.(k) ?? null;
                } catch  {
                /* ignore */ }
                return {
                    route: location.pathname,
                    stores: stores,
                    app_locale: document.documentElement.lang,
                    timestamp: new Date().toISOString(),
                    request_id: window.__feedbackRequestID
                };
            },
            handleDrop (event) {
                this.dragOver = false;
                const file = event.dataTransfer?.files?.[0];
                if (file) this.attachFile(file);
            },
            handleFileSelect (event) {
                const input = event.target;
                const file = input.files?.[0];
                if (file) this.attachFile(file);
                // Reset so re-picking the same file fires change again.
                input.value = "";
            },
            handlePaste (event) {
                if (!this.open) return;
                const file = Array.from(event.clipboardData?.files ?? []).find((f)=>f.type.startsWith("image/"));
                // No image on the clipboard means this is a normal text paste into the
                // textarea — leave it entirely alone.
                if (!file) return;
                event.preventDefault();
                this.screenshotMode = "upload";
                this.attachFile(file);
            },
            async attachFile (file) {
                this.attachError = "";
                // A 0-byte file still reports an image/* type, would pass the type check
                // untouched, and the server would then save the report with no screenshot
                // and a success toast — the user believing their image went through.
                if (file.size === 0) {
                    this.attachError = this.t.errorScreenshotUnsupportedType;
                    return;
                }
                if (!$01dba7cb2c4d359c$var$ALLOWED_IMAGE_TYPES.has(file.type)) {
                    this.attachError = this.t.errorScreenshotUnsupportedType;
                    return;
                }
                let blob = file;
                let name = file.name || "screenshot.png";
                if (file.size > $01dba7cb2c4d359c$var$MAX_SCREENSHOT_BYTES) {
                    const shrunk = await $01dba7cb2c4d359c$var$normalizeImage(file);
                    if (!shrunk) {
                        this.attachError = this.t.errorScreenshotShrinkFailed;
                        return;
                    }
                    blob = shrunk;
                    name = $01dba7cb2c4d359c$var$renameForType(name, shrunk.type);
                }
                this.clearAttachment();
                this.attachment = {
                    blob: blob,
                    name: name,
                    previewUrl: URL.createObjectURL(blob)
                };
            },
            clearAttachment () {
                if (this.attachment) URL.revokeObjectURL(this.attachment.previewUrl);
                this.attachment = null;
            },
            // Keeps Tab/Shift+Tab inside the dialog panel (mirrors modal.templ).
            trapTab (event) {
                const panel = this.$refs.panel;
                if (!panel) return;
                const items = Array.from(panel.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])')).filter((el)=>!el.hasAttribute("disabled") && el.getAttribute("aria-hidden") !== "true" && el.type !== "hidden" && el.getClientRects().length > 0);
                if (items.length === 0) {
                    event.preventDefault();
                    panel.focus();
                    return;
                }
                const first = items[0];
                const last = items[items.length - 1];
                const active = document.activeElement;
                if (event.shiftKey && (active === first || active === panel)) {
                    event.preventDefault();
                    last.focus();
                } else if (!event.shiftKey && active === last) {
                    event.preventDefault();
                    first.focus();
                }
            },
            closeModal () {
                this.open = false;
                this.clearAttachment();
                this.attachError = "";
            },
            async captureScreenshot () {
                if (!navigator.mediaDevices?.getDisplayMedia) {
                    console.warn("feedback screenshot capture unavailable: getDisplayMedia unsupported");
                    return {
                        blob: null,
                        status: "unsupported"
                    };
                }
                let stream = null;
                try {
                    stream = await navigator.mediaDevices.getDisplayMedia($01dba7cb2c4d359c$var$createDisplayMediaOptions());
                    // Close the modal only after the capture permission prompt resolves.
                    // getDisplayMedia requires transient user activation from the submit
                    // click, so we cannot defer the API call behind animation frames.
                    this.open = false;
                    await new Promise((res)=>requestAnimationFrame(()=>requestAnimationFrame(()=>res())));
                    const video = document.createElement("video");
                    video.muted = true;
                    video.playsInline = true;
                    video.srcObject = stream;
                    await $01dba7cb2c4d359c$var$waitForVideoFrame(video);
                    const width = video.videoWidth || window.innerWidth;
                    const height = video.videoHeight || window.innerHeight;
                    const canvas = document.createElement("canvas");
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext("2d");
                    if (!ctx) throw new Error("failed to create screenshot canvas context");
                    ctx.drawImage(video, 0, 0, width, height);
                    const blob = await new Promise((res)=>canvas.toBlob(res, "image/jpeg", 0.7));
                    return blob ? {
                        blob: blob,
                        status: "ok"
                    } : {
                        blob: null,
                        status: "failed"
                    };
                } catch (e) {
                    console.warn("feedback screenshot capture failed", e);
                    const cancelled = e instanceof DOMException && e.name === "NotAllowedError";
                    return {
                        blob: null,
                        status: cancelled ? "cancelled" : "failed"
                    };
                } finally{
                    stream?.getTracks().forEach((track)=>track.stop());
                }
            }
        }));
}


function $be091cf7199bbaa2$export$95844c2b493d6274(event, doc, kind) {
    if (event.isComposing) return true;
    if (doc.querySelector('[data-modal-open="1"]')) return true;
    if (kind === "palette") return false;
    const target = event.target;
    if (!target || typeof target.closest !== "function") return false;
    // isContentEditable also covers contenteditable="plaintext-only" and
    // editability inherited from an ancestor, which the selector cannot see.
    if (target.isContentEditable) return true;
    return target.closest('input, textarea, select, [contenteditable=""], [contenteditable="true"]') !== null;
}


// Alpine component behind the DatePicker templ component.
//
// Registered by CALLING registerDatePicker(Alpine) from scripts.ts rather than
// by side-effect import: ES imports are hoisted, so a side-effect import would
// evaluate this module before scripts.ts assigns window.Alpine. This mirrors
// registerFeedbackBubble.
//
// All date arithmetic lives in date_picker_logic.ts so it can be unit-tested
// without Alpine or a DOM.
// Pure date arithmetic for the DatePicker component.
//
// Deliberately free of Alpine and DOM references so it can be unit-tested with
// `bun test`. Dates are ISO yyyy-mm-dd strings throughout: that format sorts
// lexicographically in chronological order, which is why every comparison here
// is a plain string comparison rather than a Date conversion.
const $b931cf6d3bcf8712$var$MS_PER_DAY = 86400000;
function $b931cf6d3bcf8712$export$b1bc68b38a4b1ea7(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
}
function $b931cf6d3bcf8712$export$8b724767bfa64e7d(iso) {
    const [y, m, d] = iso.split("-").map(Number);
    return new Date(y, m - 1, d);
}
function $b931cf6d3bcf8712$export$4e985c1b25c164db(iso, b) {
    if (b.minISO && iso < b.minISO) return false;
    if (b.maxISO && iso > b.maxISO) return false;
    return true;
}
function $b931cf6d3bcf8712$export$f86b769ee984e9a(year, month, b) {
    const first = new Date(year, month, 1);
    // Monday-first: JS getDay() is Sunday-based, so rotate by 6 and wrap.
    const firstWeekday = (first.getDay() + 6) % 7;
    const gridStart = new Date(year, month, 1 - firstWeekday);
    const days = [];
    for(let i = 0; i < 42; i++){
        const date = new Date(gridStart);
        date.setDate(gridStart.getDate() + i);
        const iso = $b931cf6d3bcf8712$export$b1bc68b38a4b1ea7(date);
        days.push({
            iso: iso,
            day: date.getDate(),
            currentMonth: date.getMonth() === month,
            disabled: !$b931cf6d3bcf8712$export$4e985c1b25c164db(iso, b)
        });
    }
    return days;
}
function $b931cf6d3bcf8712$export$916cdbea08ffdf06(year, month, b) {
    if (!b.minISO) return true;
    // Day 0 of the current month is the last day of the previous month.
    return $b931cf6d3bcf8712$export$b1bc68b38a4b1ea7(new Date(year, month, 0)) >= b.minISO;
}
function $b931cf6d3bcf8712$export$84be5396c4dcf75(year, month, b) {
    if (!b.maxISO) return true;
    return $b931cf6d3bcf8712$export$b1bc68b38a4b1ea7(new Date(year, month + 1, 1)) <= b.maxISO;
}
function $b931cf6d3bcf8712$export$65c8990bcf06951a(state, iso, mode, b) {
    if (!$b931cf6d3bcf8712$export$4e985c1b25c164db(iso, b)) return {
        ...state,
        changed: false,
        close: false
    };
    if (mode === "singleDay") return {
        startISO: iso,
        endISO: "",
        step: "start",
        changed: true,
        close: true
    };
    if (state.step === "start") {
        // A start after the current end would invert the range, so drop the end.
        const endISO = state.endISO && iso > state.endISO ? "" : state.endISO;
        return {
            startISO: iso,
            endISO: endISO,
            step: "end",
            changed: true,
            close: false
        };
    }
    // step === "end". Picking the end completes the range, so the panel closes
    // — unless no start exists yet (the split-box trigger can open the end half
    // first), in which case there is still something to pick.
    //
    // Clicking before the start swaps the two bounds. This can
    // never produce an out-of-bounds start: the only value assigned to startISO
    // is `iso`, which the guard above already proved in bounds. A stored past
    // start (below min) is therefore left alone — `iso >= min > startISO` means
    // the swap branch is not taken.
    if (state.startISO && iso < state.startISO) return {
        startISO: iso,
        endISO: state.startISO,
        step: "end",
        changed: true,
        close: true
    };
    return {
        ...state,
        endISO: iso,
        changed: true,
        close: state.startISO !== ""
    };
}
function $b931cf6d3bcf8712$export$1c2b6984022f3a11(startISO, endISO) {
    if (!startISO || !endISO) return 0;
    const s = $b931cf6d3bcf8712$export$8b724767bfa64e7d(startISO).getTime();
    const e = $b931cf6d3bcf8712$export$8b724767bfa64e7d(endISO).getTime();
    if (e < s) return 0;
    return Math.round((e - s) / $b931cf6d3bcf8712$var$MS_PER_DAY) + 1;
}
function $b931cf6d3bcf8712$export$d7f23b884ef8a70e(startISO, endISO) {
    return Math.max(0, $b931cf6d3bcf8712$export$1c2b6984022f3a11(startISO, endISO) - 1);
}
const $b931cf6d3bcf8712$export$68594a1ce8a273d9 = 400;
const $b931cf6d3bcf8712$export$9cf7b52d10c0dd40 = 8;
function $b931cf6d3bcf8712$export$c7dfd3c51cd634b7(triggerTop, triggerBottom, viewportHeight, panelHeight = $b931cf6d3bcf8712$export$68594a1ce8a273d9) {
    const spaceBelow = viewportHeight - triggerBottom;
    const spaceAbove = triggerTop;
    return spaceBelow < panelHeight + $b931cf6d3bcf8712$export$9cf7b52d10c0dd40 && spaceAbove > spaceBelow;
}


function $1a6cdf73a1b02efb$export$6c71915904a0d700(alpine) {
    alpine.data("datePicker", (cfg)=>({
            cfg: cfg,
            startISO: cfg.startISO,
            endISO: cfg.endISO,
            startDisplay: "",
            endDisplay: "",
            activePicker: null,
            viewYear: 0,
            viewMonth: 0,
            monthLabel: "",
            days: [],
            pickerRect: {
                top: 0,
                left: 0
            },
            /**
     * True while the panel sits above its trigger. Starts as the forced
     * cfg.openAbove and is re-measured on every open from the trigger's
     * viewport rect, so a picker near the bottom of the window flips up.
     */ placeAbove: cfg.openAbove,
            /** Detaches the pending scroll-close listener; null when none is attached. */ scrollCleanup: null,
            /** The trigger the open panel was launched from, so Escape can restore focus. */ lastTrigger: null,
            /** Values as they were when the panel opened; Escape rolls back to these. */ snapshot: null,
            /** Set when the browser rejected the form because a required half is empty. */ missingStart: false,
            missingEnd: false,
            weekdays: window.__display.names.weekdaysNarrow.slice(1).concat(window.__display.names.weekdaysNarrow[0]),
            get bounds () {
                return {
                    minISO: this.cfg.minISO,
                    maxISO: this.cfg.maxISO
                };
            },
            get isRangeSelected () {
                return !!(this.startISO && this.endISO);
            },
            /** True once the mode's selection is complete — one date or both ends. */ get hasSelection () {
                return this.cfg.mode === "singleDay" ? !!this.startISO : this.isRangeSelected;
            },
            get dayCount () {
                return (0, $b931cf6d3bcf8712$export$1c2b6984022f3a11)(this.startISO, this.endISO);
            },
            get nightsCount () {
                return (0, $b931cf6d3bcf8712$export$d7f23b884ef8a70e)(this.startISO, this.endISO);
            },
            /** What the trigger badge shows — nights for check-in/check-out ranges. */ get badgeCount () {
                return this.cfg.countNights ? this.nightsCount : this.dayCount;
            },
            get badgeUnitLabel () {
                if (!this.cfg.countNights) return this.cfg.rangeDaysLabel;
                return this.nightsCount === 1 ? this.cfg.nightLabel : this.cfg.nightsLabel;
            },
            get canPrev () {
                return (0, $b931cf6d3bcf8712$export$916cdbea08ffdf06)(this.viewYear, this.viewMonth, this.bounds);
            },
            get canNext () {
                return (0, $b931cf6d3bcf8712$export$84be5396c4dcf75)(this.viewYear, this.viewMonth, this.bounds);
            },
            init () {
                // Deliberately does NOT clamp startISO/endISO to the bounds: a stored
                // past value (e.g. a rate plan's 2024 valid_from) must survive untouched
                // and submit unchanged if the operator never edits it.
                this.viewFrom(this.startISO);
                this.syncDisplays();
                this.buildCalendar();
            },
            viewFrom (iso) {
                const base = iso ? (0, $b931cf6d3bcf8712$export$8b724767bfa64e7d)(iso) : new Date();
                this.viewYear = base.getFullYear();
                this.viewMonth = base.getMonth();
            },
            openPanel (target, triggerEl) {
                if (this.activePicker === target) {
                    this.closeAndSubmit();
                    return;
                }
                // Snapshot on the transition from closed, never on a half switch, so
                // Escape rolls back to the values the operator saw before opening.
                if (this.activePicker === null) this.snapshot = {
                    startISO: this.startISO,
                    endISO: this.endISO
                };
                this.activePicker = target;
                // Replace, never add: a listener left behind by an earlier open would pin
                // this component until the container next scrolls. This sits OUTSIDE the
                // triggerEl branch on purpose — reopening on the other half without a
                // trigger element still has to drop the previous half's listener, or a
                // later scroll collapses a panel that is now showing a different half.
                this.detachScrollClose();
                if (triggerEl) {
                    this.lastTrigger = triggerEl;
                    const r = triggerEl.getBoundingClientRect();
                    // openAbove is a force flip; otherwise flip only when the space below
                    // is too tight for the panel and the space above is larger.
                    this.placeAbove = this.cfg.openAbove || (0, $b931cf6d3bcf8712$export$c7dfd3c51cd634b7)(r.top, r.bottom, window.innerHeight);
                    this.pickerRect = this.placeAbove ? {
                        top: r.top - 4,
                        left: r.left
                    } : {
                        top: r.bottom + 4,
                        left: r.left
                    };
                    const scroller = triggerEl.closest("[data-scroll-close]");
                    if (scroller) {
                        const onScroll = ()=>this.closePanel();
                        scroller.addEventListener("scroll", onScroll, {
                            once: true
                        });
                        this.scrollCleanup = ()=>scroller.removeEventListener("scroll", onScroll);
                    }
                }
                // Open on the month of whichever bound is being edited, so a stored past
                // date is visible rather than silently off-screen.
                this.viewFrom(target === "end" && this.endISO ? this.endISO : this.startISO);
                this.buildCalendar();
            },
            togglePicker (triggerEl) {
                if (this.activePicker !== null) {
                    this.closeAndSubmit();
                    return;
                }
                this.openPanel("start", triggerEl);
            },
            closeAndSubmit () {
                if (this.activePicker === null) return;
                this.closePanel();
                this.submitSelection();
            },
            /**
     * Escape cancels: it rolls the values back to the snapshot taken when the
     * panel opened, closes without submitting, and returns focus to the
     * trigger. The native <input type="date"> this component replaced closed
     * on Escape, and a keyboard user who opened the calendar would otherwise
     * be stranded on a dismissed dialog with no way back into the form.
     *
     * Rolling back is what separates Escape from @click.outside. pick() has
     * already written to the form input via x-model, so merely closing would
     * strand a half-edited range: submitSelection() bails when only one end is
     * set, leaving the pill reading "from X → indefinite" while the list still
     * shows the range that was actually applied. Escape must therefore undo,
     * not just dismiss — which is also what the key conventionally means.
     */ closeViaEscape () {
                if (this.activePicker === null) return;
                const trigger = this.lastTrigger;
                const snap = this.snapshot;
                this.closePanel();
                if (snap) {
                    this.startISO = snap.startISO;
                    this.endISO = snap.endISO;
                    this.syncDisplays();
                    this.buildCalendar();
                }
                trigger?.focus();
            },
            /** Every close path goes through here so the scroll listener never leaks. */ closePanel () {
                this.activePicker = null;
                this.snapshot = null;
                this.detachScrollClose();
            },
            detachScrollClose () {
                if (this.scrollCleanup) {
                    this.scrollCleanup();
                    this.scrollCleanup = null;
                }
            },
            /** Auto-submit for filter bars: fires only once the mode's selection is complete. */ submitSelection () {
                if (!this.cfg.submitURL || !window.htmx || !this.hasSelection) return;
                const query = this.cfg.mode === "singleDay" ? `from=${this.startISO}` : `from=${this.startISO}&to=${this.endISO}`;
                const sep = this.cfg.submitURL.includes("?") ? "&" : "?";
                window.htmx.ajax("GET", `${this.cfg.submitURL}${sep}${query}`, {
                    target: this.cfg.htmxTarget,
                    swap: this.cfg.htmxSwap
                });
            },
            /**
     * Handles the `invalid` event of a required half's value input. The native
     * bubble is suppressed (the input is invisible) and replaced by the half's
     * error state; focus goes to the first empty half's trigger.
     */ flagMissing (step, triggerEl) {
                if (step === "start") {
                    this.missingStart = true;
                    triggerEl?.focus();
                    return;
                }
                this.missingEnd = true;
                if (!this.missingStart) triggerEl?.focus();
            },
            prevMonth () {
                if (!this.canPrev) return;
                if (this.viewMonth === 0) {
                    this.viewMonth = 11;
                    this.viewYear -= 1;
                } else this.viewMonth -= 1;
                this.buildCalendar();
            },
            nextMonth () {
                if (!this.canNext) return;
                if (this.viewMonth === 11) {
                    this.viewMonth = 0;
                    this.viewYear += 1;
                } else this.viewMonth += 1;
                this.buildCalendar();
            },
            pick (iso) {
                const result = (0, $b931cf6d3bcf8712$export$65c8990bcf06951a)({
                    startISO: this.startISO,
                    endISO: this.endISO,
                    step: this.activePicker ?? "start"
                }, iso, this.cfg.mode, this.bounds);
                if (!result.changed) return;
                this.startISO = result.startISO;
                this.endISO = result.endISO;
                if (result.close) this.closePanel();
                else this.activePicker = result.step;
                this.syncDisplays();
                this.buildCalendar();
                // A single-day pick, or the end pick of a range, completes the selection,
                // so it is the close event — @click.outside will find the panel already
                // closed.
                if (result.close) this.submitSelection();
            },
            /**
     * Blanks one half of an optional Range without disturbing the other, so a
     * mis-picked start can be corrected without losing an already-picked end.
     * Neither closes the panel: clearRange() is the one that ends the
     * interaction, because an empty range is a complete (unfiltered) selection
     * while a half-empty one is not.
     */ clearStart () {
                this.startISO = "";
                // An open panel's Escape snapshot still holds the cleared date; roll it
                // forward, or Escape after Clear brings the old start date back.
                if (this.snapshot) this.snapshot = {
                    ...this.snapshot,
                    startISO: ""
                };
                // Send the open panel back to step 1. Without this the panel keeps the
                // "end" step it was on, and every later click only rewrites endISO — the
                // operator cannot set a start again without clicking the left half.
                if (this.activePicker !== null) this.activePicker = "start";
                this.syncDisplays();
                this.buildCalendar();
            },
            clearEnd () {
                this.endISO = "";
                // Same roll-forward as clearStart: Escape must not resurrect the end.
                if (this.snapshot) this.snapshot = {
                    ...this.snapshot,
                    endISO: ""
                };
                this.syncDisplays();
                this.buildCalendar();
            },
            /**
     * Drives the "open-ended" checkbox (OpenEndedLabel). The box mirrors
     * `!endISO`, so it keeps no state of its own: ticking clears the end and
     * ends the interaction; unticking opens the end half, so the end date that
     * replaces "open-ended" is picked right away.
     */ setOpenEnded (openEnded, triggerEl) {
                if (openEnded) {
                    this.clearEnd();
                    this.closePanel();
                    return;
                }
                this.openPanel("end", triggerEl);
            },
            clearRange () {
                this.startISO = "";
                this.endISO = "";
                this.closePanel();
                this.syncDisplays();
                this.buildCalendar();
                if (this.cfg.submitURL && window.htmx) window.htmx.ajax("GET", this.cfg.submitURL, {
                    target: this.cfg.htmxTarget,
                    swap: this.cfg.htmxSwap
                });
            },
            syncDisplays () {
                this.startDisplay = this.toDisplay(this.startISO);
                this.endDisplay = this.toDisplay(this.endISO);
                if (this.startISO) this.missingStart = false;
                if (this.endISO) this.missingEnd = false;
                // Contract consumed by stop_sale, daily_rate, daily_rate_bulk_modal and
                // blocking. Name and detail shape must not change.
                window.dispatchEvent(new CustomEvent("date-picker-synced", {
                    detail: {
                        from: this.startISO,
                        to: this.endISO
                    }
                }));
            },
            buildCalendar () {
                this.monthLabel = window.__display.monthYearLong(this.viewYear, this.viewMonth);
                this.days = (0, $b931cf6d3bcf8712$export$f86b769ee984e9a)(this.viewYear, this.viewMonth, this.bounds);
            },
            toDisplay (iso) {
                return iso ? window.__display.formatDate(iso, this.cfg.dateFormat) : "";
            },
            showRangeHighlight (iso) {
                return !!(this.cfg.mode === "range" && this.startISO && this.endISO && this.startISO !== this.endISO && iso >= this.startISO && iso <= this.endISO);
            },
            rangeSpanClass (iso) {
                if (iso === this.startISO && this.endISO && this.startISO !== this.endISO) return "left-0 right-0 rounded-l-full";
                if (iso === this.endISO && this.startISO && this.startISO !== this.endISO) return "left-0 right-0 rounded-r-full";
                return "left-0 right-0";
            },
            dayTextClass (day) {
                // A stored value outside the bounds sits on a grey circle (see the
                // panel's isLockedSelection binding); its digit must contrast with that
                // circle while the cursor still says it cannot be picked.
                if (this.isLockedSelection(day.iso)) return "text-gray-700 dark:text-gray-100 cursor-not-allowed";
                // Otherwise disabled wins over every other state so an out-of-range day
                // never looks clickable.
                if (day.disabled) return "text-gray-300 dark:text-gray-700 cursor-not-allowed";
                if (!day.currentMonth) return "text-gray-300 dark:text-gray-600";
                if (day.iso === this.startISO || day.iso === this.endISO) return "text-white";
                if (this.startISO && this.endISO && day.iso > this.startISO && day.iso < this.endISO) return "text-brand-600 dark:text-brand-300 hover:bg-gray-100 dark:hover:bg-gray-700";
                return "text-gray-800 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-700";
            },
            /** True when the stored value sits outside bounds — selected but locked. */ isLockedSelection (iso) {
                return (iso === this.startISO || iso === this.endISO) && !!iso && !(0, $b931cf6d3bcf8712$export$4e985c1b25c164db)(iso, this.bounds);
            },
            isoOf (date) {
                return (0, $b931cf6d3bcf8712$export$b1bc68b38a4b1ea7)(date);
            }
        }));
}


// Typed money and percent inputs: mark the input with `data-decimal-input`
// instead of an inline @input regex. The filter never decides what is a valid
// number and never drops a character the operator could mean: letters, "-",
// currency and percent signs all reach the server as typed, and the server's
// parser (numfmt.Parse) and the domain either read them correctly or refuse
// them with a field error. Silently stripping them used to turn "abc" into an
// empty (valid) field and "-5" into 5. "7,5", "89,50" and "1.250,50" also
// reach the server as typed, so a value can never change magnitude on the way.
//
// The only thing dropped is whitespace the server cannot read inside a number:
// ASCII space, NBSP and narrow NBSP are the grouping spaces numfmt.Parse
// accepts and are kept; tabs, newlines and other Unicode spaces are dropped.
// A value of data-decimal-input="signed" is accepted and behaves like the bare
// attribute, because a minus is no longer filtered for any field.
const $dec1b0b14983cac3$var$UNACCEPTED_WHITESPACE = /[^\S \u00A0\u202F]/g;
function $dec1b0b14983cac3$export$8800cad23ea9b245(value) {
    return value.replace($dec1b0b14983cac3$var$UNACCEPTED_WHITESPACE, "");
}
function $dec1b0b14983cac3$export$1eee5d04ef6bced4(value, caret) {
    return $dec1b0b14983cac3$export$8800cad23ea9b245(value.slice(0, caret)).length;
}
// sanitizeField cleans el in place, keeping the caret (or selection) where the
// operator left it rather than letting the assignment jump it to the end. It
// reports whether the value changed.
function $dec1b0b14983cac3$var$sanitizeField(el) {
    const raw = el.value;
    const clean = $dec1b0b14983cac3$export$8800cad23ea9b245(raw);
    if (clean === raw) return false;
    const start = el.selectionStart;
    const end = el.selectionEnd;
    el.value = clean;
    if (start !== null && end !== null && el.ownerDocument.activeElement === el) el.setSelectionRange(Math.min($dec1b0b14983cac3$export$1eee5d04ef6bced4(raw, start), clean.length), Math.min($dec1b0b14983cac3$export$1eee5d04ef6bced4(raw, end), clean.length));
    return true;
}
function $dec1b0b14983cac3$var$decimalInputTarget(event) {
    const el = event.target;
    if (!(el instanceof HTMLInputElement) || !el.hasAttribute("data-decimal-input")) return null;
    return el;
}
function $dec1b0b14983cac3$export$8c24ab11e87853c8(root) {
    root.addEventListener("input", (event)=>{
        const el = $dec1b0b14983cac3$var$decimalInputTarget(event);
        if (!el) return;
        // Text mid-composition is provisional; rewriting it would cancel
        // the IME. compositionend cleans the committed text instead.
        if (event instanceof InputEvent && event.isComposing) return;
        $dec1b0b14983cac3$var$sanitizeField(el);
    }, true);
    root.addEventListener("compositionend", (event)=>{
        const el = $dec1b0b14983cac3$var$decimalInputTarget(event);
        // Some browsers fire no input event after compositionend, so tell
        // x-model/@input about the cleaned value; the re-entrant input
        // event finds nothing left to clean.
        if (el && $dec1b0b14983cac3$var$sanitizeField(el)) el.dispatchEvent(new Event("input", {
            bubbles: true
        }));
    }, true);
}


// htmx keeps a snapshot of <body> for the back button. The snapshot includes
// the elements Alpine generated from <template x-for> and <template x-if>;
// when it is swapped back in, Alpine initialises those copies outside their
// loop scope and every loop variable ("state", "mod", ...) throws a
// ReferenceError. The generated elements are therefore marked before the
// snapshot and stripped from the cached HTML before it is restored; Alpine
// re-creates them from their templates. <template x-teleport> is the same
// case: its clone lives elsewhere in <body> (the date picker popup) and would
// be initialised without the scope of the component it came from.
const $a44e40ffada9e502$export$fc5ff8db203a999c = "data-alpine-generated";
function $a44e40ffada9e502$export$7710430de956c1de(root) {
    root.querySelectorAll("template").forEach((node)=>{
        const tpl = node;
        Object.values(tpl._x_lookup ?? {}).forEach((el)=>el.setAttribute($a44e40ffada9e502$export$fc5ff8db203a999c, ""));
        tpl._x_currentIfEl?.setAttribute($a44e40ffada9e502$export$fc5ff8db203a999c, "");
        tpl._x_teleport?.setAttribute($a44e40ffada9e502$export$fc5ff8db203a999c, "");
    });
}
function $a44e40ffada9e502$export$408a3d1e13bb9109(html) {
    const tpl = document.createElement("template");
    tpl.innerHTML = html;
    tpl.content.querySelectorAll(`[${$a44e40ffada9e502$export$fc5ff8db203a999c}]`).forEach((el)=>el.remove());
    return tpl.innerHTML;
}


// The product's confirm dialog. Staff UI never uses the browser's own
// window.confirm/alert/prompt (navguard's TestNoNativeDialogs enforces it):
// every question is this ui.Modal, rendered once per page by
// templates.ConfirmDialogHTML and driven through Alpine.store("confirm").
//
// Two ways in:
//   - markup: data-confirm="question" on the element that issues the htmx
//     request (the form, or the button/link carrying hx-post/hx-get);
//     handleHtmxConfirm holds the request back until the user confirms.
//   - script: await window.appConfirm("question") resolves true/false.
//
// Unlike window.confirm, the dialog does not block the page while it asks:
// a swap can replace the asking element in the meantime (handleHtmxConfirm
// reports that instead of dropping the request silently), and a form's
// submitter is not sent with a confirmed request (htmx forgets the clicked
// button when focus moves into the dialog), so a confirmed form must not
// depend on its submit button's name/value or formaction.
/**
 * A click on the backdrop this soon after opening is the second click of a
 * double-click on the asking button, not an answer.
 */ const $e02b84b493dd33a9$export$38541b632b2d608b = 400;
class $e02b84b493dd33a9$export$2cc85109a937009e {
    /** Opens the dialog. A question still pending is answered "no" first. */ ask(message, now = Date.now()) {
        // A question asked while one is open keeps the first opener: the element
        // focused now is the dialog's own button.
        const opener = this.open ? this.returnFocus : typeof document !== "undefined" ? document.activeElement : null;
        this.settle(false);
        this.returnFocus = opener;
        this.message = message;
        this.open = true;
        this.openedAt = now;
        return new Promise((resolve)=>{
            this.resolve = resolve;
        });
    }
    /** Closes the dialog with the user's answer. */ answer(ok) {
        this.open = false;
        const el = $e02b84b493dd33a9$export$46edb5a4ae75e21e(this.returnFocus);
        this.returnFocus = null;
        if (el) el.focus();
        this.settle(ok);
    }
    /** The backdrop, the close button and click-outside: a "no", except during
   * the double-click grace period right after opening. */ dismiss(now = Date.now()) {
        if (!this.open || now - this.openedAt < $e02b84b493dd33a9$export$38541b632b2d608b) return;
        this.answer(false);
    }
    settle(ok) {
        const resolve = this.resolve;
        this.resolve = null;
        if (resolve) resolve(ok);
    }
    constructor(){
        this.open = false;
        this.message = "";
        this.resolve = null;
        this.returnFocus = null;
        this.openedAt = 0;
    }
}
function $e02b84b493dd33a9$export$46edb5a4ae75e21e(el) {
    if (!el || !el.isConnected) return null;
    if (el.getClientRects().length > 0) return el;
    const trigger = el.closest("[x-data]")?.querySelector("[aria-haspopup]");
    return trigger && trigger.getClientRects().length > 0 ? trigger : null;
}
function $e02b84b493dd33a9$export$ae09b7bd3eed3f23(e, dialog) {
    if (e.key !== "Escape" || !dialog.open) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    dialog.answer(false);
}
function $e02b84b493dd33a9$export$10d45107f558966c(e, ask, gone = ()=>{}) {
    if (e.defaultPrevented) return;
    const detail = e.detail;
    const message = detail?.elt?.getAttribute("data-confirm");
    if (!message) return;
    e.preventDefault();
    ask(message).then((ok)=>{
        if (!ok) return;
        if (!detail.elt.isConnected) {
            gone();
            return;
        }
        detail.issueRequest(true);
    });
}


window.htmx = (0, $aES44.default);
// History restores past htmx's cache must fetch the full page: the server
// answers HX-Request with a shell-less partial, which htmx would swap into
// <body>. (htmx's own docs recommend this whenever HX-Request selects partials.)
(0, $aES44.default).config.historyRestoreAsHxRequest = false;
// A 422 carries a re-rendered form with validation messages: swap it, but keep
// it an error so success handlers (detail.successful) do not fire. Toast-only
// errors send HX-Reswap: none from the server and swap nothing.
// htmx.config is typed Record<string, unknown> in globals.d.ts, hence the cast.
(0, $aES44.default).config.responseHandling.unshift({
    code: "422",
    swap: true,
    error: true
});
// Add Alpine instance to window object.
(0, $1995762e80cda67d$export$2e2bcd8739ae039).plugin((0, $2c8b7f21ee529b26$export$2e2bcd8739ae039));
(0, $1995762e80cda67d$export$2e2bcd8739ae039).plugin((0, $565f2ff3230c1cc6$export$2e2bcd8739ae039));
window.Alpine = (0, $1995762e80cda67d$export$2e2bcd8739ae039);
window.navigateMain = (0, $56a4cebe880c777d$export$a01aa4785e9704e5);
window.__toastHandler = (0, $1995762e80cda67d$export$2e2bcd8739ae039).reactive(new (0, $58efe74bd4380493$export$e65cc68e71f15e38)());
(0, $1995762e80cda67d$export$2e2bcd8739ae039).store("toast", window.__toastHandler);
// Per-element wrapper inheriting from the shared store: Alpine injects its
// magics ($nextTick, …) onto this throwaway object instead of the singleton,
// so recreating the toast div on htmx history restore (browser back) can't
// redefine them. Reads/writes (toasts, start(), remove()) resolve through the
// prototype chain to the same reactive store, preserving shared state.
(0, $1995762e80cda67d$export$2e2bcd8739ae039).data("toastComponent", ()=>Object.create((0, $1995762e80cda67d$export$2e2bcd8739ae039).store("toast")));
// The product's confirm dialog (templates.ConfirmDialogHTML): the only way
// staff UI asks a question. data-confirm on an htmx element, or appConfirm()
// from script; never window.confirm.
const $d9038598a21a12df$var$confirmDialog = (0, $1995762e80cda67d$export$2e2bcd8739ae039).reactive(new (0, $e02b84b493dd33a9$export$2cc85109a937009e)());
(0, $1995762e80cda67d$export$2e2bcd8739ae039).store("confirm", $d9038598a21a12df$var$confirmDialog);
window.appConfirm = (message)=>$d9038598a21a12df$var$confirmDialog.ask(message);
// A confirmed element that a swap removed meanwhile: say so instead of doing
// nothing. The text is rendered translated on the dialog root.
const $d9038598a21a12df$var$confirmGone = ()=>{
    const el = document.querySelector("[data-confirm-dialog]");
    const msg = el?.dataset.goneMessage;
    if (msg) window.__toastHandler.add(msg, "error", 5000);
};
document.addEventListener("htmx:confirm", (e)=>(0, $e02b84b493dd33a9$export$10d45107f558966c)(e, window.appConfirm, $d9038598a21a12df$var$confirmGone));
window.addEventListener("keydown", (e)=>(0, $e02b84b493dd33a9$export$ae09b7bd3eed3f23)(e, $d9038598a21a12df$var$confirmDialog), true);
(0, $01dba7cb2c4d359c$export$853590d507b26d3b)((0, $1995762e80cda67d$export$2e2bcd8739ae039));
(0, $1a6cdf73a1b02efb$export$6c71915904a0d700)((0, $1995762e80cda67d$export$2e2bcd8739ae039));
(0, $dec1b0b14983cac3$export$8c24ab11e87853c8)(document);
// --- Tenant date display -------------------------------------------------
// Name tables come from the #display-names JSON block emitted by
// templates.Head. The per-property format code is NOT global — each Alpine
// component receives its own `dateFormat` in x-data, because that value varies
// per request while these tables are constant for the process.
const $d9038598a21a12df$var$EN_FALLBACK = {
    monthsLong: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ],
    monthsShort: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    weekdaysLong: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ],
    weekdaysShort: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    weekdaysNarrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    am: 'AM',
    pm: 'PM',
    patterns: {
        month_year_long: '%{month} %{year}',
        month_year_short: '%{month} %{year}',
        weekday_day_month: '%{weekday}, %{day} %{month}',
        weekday_day_month_year: '%{weekday}, %{day} %{month} %{year}'
    }
};
function $d9038598a21a12df$var$readDisplayNames() {
    const el = document.getElementById('display-names');
    if (!el || !el.textContent) return $d9038598a21a12df$var$EN_FALLBACK;
    try {
        const parsed = JSON.parse(el.textContent);
        // patterns is merged per key, not replaced wholesale: NamesJSON omits
        // any key whose translation does not resolve, so a partial map is a
        // legitimate payload for an incomplete catalog. A top-level spread
        // would leave the missing key undefined and make fillPattern throw on
        // .replace — breaking every calendar render on the page.
        return {
            ...$d9038598a21a12df$var$EN_FALLBACK,
            ...parsed,
            patterns: {
                ...$d9038598a21a12df$var$EN_FALLBACK.patterns,
                ...parsed.patterns ?? {}
            }
        };
    } catch  {
        // A malformed block must never break the page — every date on it would
        // disappear. Degrade to English and keep rendering.
        return $d9038598a21a12df$var$EN_FALLBACK;
    }
}
const $d9038598a21a12df$var$displayNames = $d9038598a21a12df$var$readDisplayNames();
/**
 * Substitutes %{token} placeholders — ctxi18n's interpolation syntax, so the
 * same catalog pattern strings work server-side and here. Unknown tokens
 * are left in place rather than blanked, so a typo is visible instead of
 * silently deleting text.
 */ function $d9038598a21a12df$var$fillPattern(pattern, params) {
    return pattern.replace(/%\{(\w+)\}/g, (match, key)=>Object.prototype.hasOwnProperty.call(params, key) ? params[key] : match);
}
/** Splits an ISO YYYY-MM-DD string. Returns null for anything else. */ function $d9038598a21a12df$var$isoParts(iso) {
    if (!iso) return null;
    const parts = iso.split('-');
    if (parts.length !== 3) return null;
    return {
        y: parts[0],
        m: parts[1],
        d: parts[2]
    };
}
window.__display = {
    names: $d9038598a21a12df$var$displayNames,
    // Mirrors display.toGoLayout in Go. Keep the two in sync.
    formatDate (iso, dateFormat) {
        const p = $d9038598a21a12df$var$isoParts(iso);
        if (!p) return '';
        switch(dateFormat){
            case 'DD.MM.YYYY':
                return `${p.d}.${p.m}.${p.y}`;
            case 'MM/DD/YYYY':
                return `${p.m}/${p.d}/${p.y}`;
            default:
                return `${p.y}-${p.m}-${p.d}`;
        }
    },
    // No dateFormat parameter: this label is built entirely from the
    // catalog pattern and the name tables, so the numeric format code has
    // nothing to contribute.
    formatWeekdayDayMonthYear (iso) {
        const dt = new Date(`${iso}T00:00:00`);
        if (Number.isNaN(dt.getTime())) return '';
        return $d9038598a21a12df$var$fillPattern($d9038598a21a12df$var$displayNames.patterns.weekday_day_month_year, {
            weekday: $d9038598a21a12df$var$displayNames.weekdaysShort[dt.getDay()],
            day: String(dt.getDate()),
            month: $d9038598a21a12df$var$displayNames.monthsShort[dt.getMonth()],
            year: String(dt.getFullYear())
        });
    },
    formatWeekdayDayMonth (iso) {
        const dt = new Date(`${iso}T00:00:00`);
        if (Number.isNaN(dt.getTime())) return '';
        return $d9038598a21a12df$var$fillPattern($d9038598a21a12df$var$displayNames.patterns.weekday_day_month, {
            weekday: $d9038598a21a12df$var$displayNames.weekdaysShort[dt.getDay()],
            day: String(dt.getDate()),
            month: $d9038598a21a12df$var$displayNames.monthsShort[dt.getMonth()]
        });
    },
    monthYearShort (iso) {
        const dt = new Date(`${iso}T00:00:00`);
        if (Number.isNaN(dt.getTime())) return '';
        return $d9038598a21a12df$var$fillPattern($d9038598a21a12df$var$displayNames.patterns.month_year_short, {
            month: $d9038598a21a12df$var$displayNames.monthsShort[dt.getMonth()],
            year: String(dt.getFullYear())
        });
    },
    monthYearLong (year, monthIndex) {
        return $d9038598a21a12df$var$fillPattern($d9038598a21a12df$var$displayNames.patterns.month_year_long, {
            month: $d9038598a21a12df$var$displayNames.monthsLong[monthIndex],
            year: String(year)
        });
    }
};
(0, $1995762e80cda67d$export$2e2bcd8739ae039).data("selectDropdown", (cfg)=>({
        isOpen: false,
        val: cfg.val,
        label: cfg.label,
        name: cfg.name,
        query: '',
        icons: cfg.icons,
        codeLabels: cfg.codeLabels,
        trailingTexts: cfg.trailingTexts,
        statusDots: cfg.statusDots || {},
        optionLabels: cfg.optionLabels,
        labels: cfg.labels,
        reset () {
            this.val = '';
            this.label = '';
            this.$dispatch('sd-change', {
                name: this.name,
                value: '',
                label: ''
            });
        },
        toggle () {
            this.isOpen = !this.isOpen;
            if (this.isOpen) this.$nextTick(()=>this.$refs.sdSearch?.focus());
        },
        close () {
            this.isOpen = false;
            this.query = '';
        },
        pick (v, l) {
            this.val = v;
            this.label = l;
            this.isOpen = false;
            this.query = '';
            this.$dispatch('sd-change', {
                name: cfg.name,
                value: v,
                label: l
            });
            // Also fire a native change on the hidden input so parent @change handlers
            // (e.g. the rate-rule condition row's sync()) react with an already-updated
            // DOM. $nextTick lets Alpine flush :value before the event is dispatched,
            // avoiding the capture-phase race. Uses $root (the component's own x-data
            // element), not $el: pick() is called from an option button's @click, so
            // $el there is that button, not the dropdown root — querying inside it
            // never finds the hidden input, silently skipping the dispatch.
            this.$nextTick(()=>{
                const inp = this.$root.querySelector('input[type="hidden"]');
                if (inp) inp.dispatchEvent(new Event('change', {
                    bubbles: true
                }));
            });
        },
        matches (l) {
            if (!this.query) return true;
            return l.toLowerCase().includes(this.query.toLowerCase());
        },
        get hasMatch () {
            return this.labels.some((l)=>this.matches(l));
        }
    }));
// Checkbox-based multi-select. The server renders real checkboxes and a
// fallback summary; this component only adds open/close, the live summary and
// the select-all / clear actions. Uses $root (the component's x-data element),
// not $el, because methods run from child @click handlers where $el is the child.
(0, $1995762e80cda67d$export$2e2bcd8739ae039).data("multiSelectDropdown", (cfg)=>({
        isOpen: false,
        query: '',
        summary: '',
        summaryIsPlaceholder: true,
        init () {
            this.refresh();
        },
        boxes () {
            return Array.from(this.$root.querySelectorAll('input[type="checkbox"]'));
        },
        refresh () {
            // Disabled boxes are not submitted, so they are not "selected".
            const picked = this.boxes().filter((b)=>b.checked && !b.disabled);
            this.summaryIsPlaceholder = picked.length === 0;
            if (picked.length === 0) this.summary = cfg.placeholder;
            else if (picked.length === 1) this.summary = picked[0].closest('label')?.textContent?.trim() ?? '';
            else this.summary = cfg.manyTemplate.replace('{count}', String(picked.length));
        },
        setAll (on) {
            // Act only on the options the search leaves visible.
            this.boxes().forEach((b)=>{
                if (!b.disabled && this.matches(b.closest('label')?.textContent ?? '')) b.checked = on;
            });
            this.refresh();
            // Programmatic checked changes fire no event; dispatch one so form-level
            // @change listeners (e.g. the live preview) react.
            this.$root.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        },
        matches (l) {
            if (!this.query) return true;
            return l.toLowerCase().includes(this.query.toLowerCase());
        },
        get hasMatch () {
            return this.boxes().some((b)=>this.matches(b.closest('label')?.textContent ?? ''));
        },
        toggle () {
            this.isOpen = !this.isOpen;
            if (this.isOpen) // Move focus into the panel: the search box when there is one, else the first enabled checkbox.
            this.$nextTick(()=>{
                const panel = this.$refs.panel;
                panel?.querySelector('input[type="text"], input[type="checkbox"]:not(:disabled)')?.focus();
            });
        },
        close () {
            this.isOpen = false;
            this.query = '';
        },
        // Escape closes the instance that holds focus and hands focus back to its trigger.
        closeAndFocus () {
            if (!this.isOpen) return;
            this.close();
            this.$refs.trigger?.focus();
        }
    }));
(0, $1995762e80cda67d$export$2e2bcd8739ae039).data("dropdown", ()=>({
        open: false,
        toggle () {
            this.open = !this.open;
            if (this.open) this.position();
        },
        // Alpine injects $nextTick, $el, $refs, $watch — typed via `this: any`.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        position () {
            this.$nextTick(()=>{
                const button = this.$el;
                const dropdown = this.$refs.dropdown;
                const rect = button.getBoundingClientRect();
                dropdown.style.position = "fixed";
                dropdown.style.top = `${rect.bottom + window.scrollY}px`;
                dropdown.style.right = `${window.innerWidth - rect.right}px`;
                dropdown.style.zIndex = "999";
                // Reposition if would overflow viewport
                const dropdownRect = dropdown.getBoundingClientRect();
                if (dropdownRect.bottom > window.innerHeight) dropdown.style.top = `${rect.top + window.scrollY - dropdownRect.height}px`;
            });
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        init () {
            this.$watch("open", (value)=>{
                if (value) this.position();
            });
        }
    }));
// Start Alpine on DOMContentLoaded so per-module bundles loaded from <body>
// have time to register Alpine.magic / Alpine.data / Alpine.store via
// 'alpine:init' listeners BEFORE Alpine walks the DOM. Module scripts (head
// and body) execute in document order after parsing but BEFORE
// DOMContentLoaded, so by the time DCL fires every per-module bundle has
// attached its registration listeners.
//
// document.readyState is 'interactive' here (modules execute pre-DCL), so
// the addEventListener call is sufficient and unconditional. Module-cloak
// (foundation x-cloak rule) hides any Alpine-controlled visible content
// during the one-tick gap; the body's dark-mode class is pre-applied via
// the Head() inline script (see main.templ).
document.addEventListener('DOMContentLoaded', ()=>(0, $1995762e80cda67d$export$2e2bcd8739ae039).start());
// --- CSRF Protection ---
// Reads the CSRF token from the _csrf cookie (set by Echo CSRF middleware).
// Automatically injects it into HTMX requests (via header) and regular form
// submissions (via hidden field). No per-form template changes needed.
function $d9038598a21a12df$var$csrfToken() {
    const match = document.cookie.match(/(?:^|;\s*)_csrf=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : "";
}
window.csrfToken = $d9038598a21a12df$var$csrfToken;
// HTMX: add X-CSRF-Token header to every request.
document.body.addEventListener("htmx:configRequest", (event)=>{
    event.detail.headers["X-CSRF-Token"] = $d9038598a21a12df$var$csrfToken();
    // X-App-Shell (base.AppShellHeader): tells the server this page has the
    // app shell's #main-content, so Renderer.Redirect may answer with an
    // in-place HX-Location swap. Pages without it (guest booking engine,
    // full-screen pages) get HX-Redirect instead; an HX-Location aimed at a
    // missing #main-content would fail with htmx:targetError.
    if (document.getElementById("main-content")) event.detail.headers["X-App-Shell"] = "1";
});
// Regular forms: inject hidden _csrf field before submission.
document.addEventListener("submit", (event)=>{
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    // getAttribute: a control named "method" shadows form.method.
    if ((form.getAttribute("method") ?? "get").toUpperCase() === "GET") return;
    if (form.querySelector('input[name="_csrf"]')) return;
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "_csrf";
    input.value = $d9038598a21a12df$var$csrfToken();
    form.appendChild(input);
});
function $d9038598a21a12df$export$36f8e2c4070764d8() {
    document.body.style.overflow = document.querySelector('[data-modal-open="1"]') ? "hidden" : "";
}
window.__syncBodyScrollLock = $d9038598a21a12df$export$36f8e2c4070764d8;
// Back-button snapshots must not carry Alpine-generated elements: see
// alpine_history.ts.
document.body.addEventListener("htmx:beforeHistorySave", (event)=>{
    (0, $a44e40ffada9e502$export$7710430de956c1de)(event.detail.historyElt);
});
document.body.addEventListener("htmx:historyCacheHit", (event)=>{
    event.detail.item.content = (0, $a44e40ffada9e502$export$408a3d1e13bb9109)(event.detail.item.content);
});
// Re-initialize HTMX and Alpine on content loaded via HTMX navigation.
// Module scripts (<script type="module">) only execute once per URL (browser
// de-duplication), so page-specific init code won't re-run on subsequent HTMX
// visits. Each module script registers its init function into __alpineInits
// on first load. This global handler calls all registered inits on every swap.
//
// Uses event.detail.target (the swapped-into element) rather than .elt (the
// element that triggered the request) — they differ whenever hx-target
// points somewhere other than the triggering element itself (e.g. a button
// appending a row into a sibling list via hx-swap="beforeend"), in which
// case .elt never contains the new content at all and initTree/process
// would silently no-op on it. An outerHTML swap detaches its target, so
// settleRoot then falls back to the settled element the event fired on (the new
// content); re-initializing the detached target would run Alpine directives
// with no data stack (see settle_root.ts).
document.body.addEventListener("htmx:afterSettle", (event)=>{
    const target = (0, $536e9a288e0a2da4$export$825ed9e9c5a3375d)(event.detail.target, event.target);
    if (!target) return;
    (0, $aES44.default).process(target);
    window.Alpine.initTree(target);
    Object.entries(window.__alpineInits || {}).forEach(([selector, init])=>{
        target.querySelectorAll(selector).forEach(init);
    });
});
// Registered as its own listener rather than called from the handler above:
// that handler returns early when settleRoot finds no connected root, and runs
// htmx.process/Alpine.initTree first — either of which can throw on bad swapped
// content. A skipped or thrown sync would leave the page permanently unscrollable.
//
// pageshow covers the one genuinely uncovered case: a native bfcache restore of a
// non-boosted navigation fires no htmx event at all. htmx:historyRestore is
// belt-and-braces — htmx's restoreHistory() swaps into details.historyElt, which
// defaults to document.body here (no [hx-history-elt] is defined), so doSettle()
// already fires htmx:afterSettle on document.body before historyRestore. Kept in
// case a future [hx-history-elt] narrows that swap root.
document.body.addEventListener("htmx:afterSettle", $d9038598a21a12df$export$36f8e2c4070764d8);
window.addEventListener("pageshow", $d9038598a21a12df$export$36f8e2c4070764d8);
document.body.addEventListener("htmx:historyRestore", $d9038598a21a12df$export$36f8e2c4070764d8);
// In-place navigation opens the new page at the top: the shell scrolls its
// content pane, not the window, so htmx would otherwise keep the old page's
// offset (see nav_scroll.ts). beforeHistoryUpdate fires right before the swap
// and carries both the history type and the final swap target.
document.body.addEventListener("htmx:beforeHistoryUpdate", (event)=>{
    (0, $9831061986491189$export$ad446fa89ac42e58)(event.detail, document);
});
const $d9038598a21a12df$var$sseLifecycle = new (0, $b605759c7d2aabe5$export$6bb11fd42f235146)(async (sseURL, tokenURL)=>{
    const sseConnection = new (0, $2040b187572cc8da$export$52544d35a0066ce7)(sseURL, tokenURL, true);
    await sseConnection.connect();
    // sse.ts closes the stream on the server's "close" event; release it
    // here too, or the lifecycle keeps a dead source and never reconnects.
    sseConnection.evtSource?.addEventListener("close", ()=>$d9038598a21a12df$var$sseLifecycle.stop());
    return sseConnection.evtSource;
}, (evtSource)=>{
    if (window.__toastHandler) window.__toastHandler.addEventSource(evtSource);
    window.__sseConnection = evtSource;
    document.dispatchEvent(new CustomEvent("sse:connected", {
        detail: evtSource
    }));
}, ()=>{
    window.__sseConnection = null;
});
$d9038598a21a12df$var$sseLifecycle.bind(window);
function $d9038598a21a12df$export$f73ecfa36fbf9d9a(sseURL, tokenURL) {
    console.log('Starting SSE connection to:', sseURL);
    $d9038598a21a12df$var$sseLifecycle.start(sseURL, tokenURL);
}
window.startSSEConnection = $d9038598a21a12df$export$f73ecfa36fbf9d9a;
document.addEventListener("DOMContentLoaded", ()=>{
    const searchInput = document.getElementById("search-input");
    const searchButton = document.getElementById("search-button");
    function focusSearchInput() {
        if (!searchInput) return;
        searchInput.focus();
    }
    if (searchButton) searchButton.addEventListener("click", focusSearchInput);
    document.addEventListener("keydown", (event)=>{
        if (!searchInput) return;
        if ((0, $be091cf7199bbaa2$export$95844c2b493d6274)(event, document, "palette")) return;
        if ((event.metaKey || event.ctrlKey) && event.key === "k") {
            event.preventDefault();
            focusSearchInput();
        }
    });
    document.addEventListener("keydown", (event)=>{
        if (!searchInput) return;
        if ((0, $be091cf7199bbaa2$export$95844c2b493d6274)(event, document, "slash")) return;
        if (event.key === "/" && document.activeElement !== searchInput) {
            event.preventDefault();
            focusSearchInput();
        }
    });
});


//# sourceMappingURL=foundation.imports.c167cf6c.js.map
